import React, { useState, useEffect, useRef, useMemo, useContext, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import HamburgerMenu from "../../Components/HamburgerMenu/HamburgerMenu.jsx";
import PuffLoader from "react-spinners/PuffLoader";
import Select, { components } from "react-select";
import ReactDatePicker, {
  registerLocale,
  setDefaultLocale,
} from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import enGB from "date-fns/locale/en-GB";
import { useTranslation } from "react-i18next";
import UserService from "../../Services/user.service.js";
import { useBack } from "use-back";
import "../../pages/OtherDocuments/OtherDocument.css";
import "./BankMatching.css";
import backIcon from "../../assests/images/left-arrow.png";
import EnumsService from "../../Services/enums.service.js";
import CustomDeleteConfirmationModal from "../../Components/CustomDeleteConfirmationModal/CustomDeleteConfirmationModal.js";
import { ToastContainer, toast } from "react-toastify";
import Swal from 'sweetalert2';
import DownloadIcon from "@mui/icons-material/Download";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { useSignalR } from "../../Contexts/signalR.js";
import { Dropdown } from "primereact/dropdown";
import "primereact/resources/themes/saga-blue/theme.css"; // Optional: PrimeReact theme
import "primereact/resources/primereact.min.css"; // PrimeReact CSS
import "primeicons/primeicons.css";
import SaveIcon from "@mui/icons-material/Save"; // Save icon
import ClearIcon from "@mui/icons-material/Clear";
import AdvancedDropdown from "../../Components/AdvancedDropdown/AdvancedDropdown.js";
import AutoAwesomeMotionIcon from "@mui/icons-material/AutoAwesomeMotion";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import Constants from "../../assests/Constants/constants.js";
import useCaseSystemAccountSettings from "../../hooks/useCaseSystemAccountSettings.js";
import useBankWorkspaceLayout from "../../hooks/useBankWorkspaceLayout.js";
import {
  DataGrid,
  useGridApiRef,
  useGridApiContext,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarQuickFilter,
  gridFilteredSortedRowIdsSelector,
  gridVisibleColumnDefinitionsSelector,
} from "@mui/x-data-grid";
import * as XLSX from "xlsx";
import { styled, darken, lighten } from "@mui/material/styles";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ExpandLess from "@mui/icons-material/ExpandLess";
import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import { createTheme, ThemeProvider, useTheme } from "@mui/material/styles";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import { arSD, heIL, enUS } from "@mui/x-data-grid/locales";
import CustomMonthDatePicker from "../../Components/Widgets/CustomDates/CustomMonthDatePicker/CustomMonthDatePicker.js";
import CustomDropdown from "../../Components/CustomDropdown/CustomDropdown.js";
import EditModal from "../../Components/EditModal/EditModal.js";
import AddOrEditBankDialog from "../../Components/BankMatching/AddOrEditBankDialog.js";
import AddExternalTransactionDialog from '../../Components/BankMatching/AddExternalTransactionDialog.js';
import EditExternalTransactionDialog from '../../Components/BankPages/EditExternalTransaction.js';
import BankAccountBar from '../../Components/BankMatching/BankAccountBar.jsx';
import BankPeriodPicker, {
  PERIOD_MODE,
  endOfUtcDay,
  startOfUtcDay,
  yearBounds,
} from '../../Components/BankMatching/BankPeriodPicker.jsx';
import DocumentThumbnail from '../../Components/BankMatching/DocumentThumbnail.jsx';
import AccountAutocomplete from "../../Components/Widgets/AccountAutocomplete/AccountAutocomplete.js";
import MatchedTable from "../../Components/BankMatching/SubComponents/MatchedTable.js";
//table imports
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  Download as DownloadIconMui,
  Search as SearchIcon,
  CancelRounded,
  Print as PrintIcon,
} from "@mui/icons-material";
import {
  Button,
  Box,
  Typography,
  TextField,
  Checkbox,
  InputAdornment,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  MenuItem,
  Switch,
  CircularProgress,
  IconButton,
  Autocomplete,
  FormControlLabel,
  Chip,
  Tooltip,
} from "@mui/material";
import dayjs, { Dayjs } from "dayjs";
import { beautifyNumber, parseBeautifiedNumber } from "../../Utils/FormatNumber.js";
import { getReferenceLastDigits } from "../../Utils/matchingUtils.js";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import ImportDialog from "../../Components/BankMatching/ImportDialog.js";
import ImportPreviewModal from "../../Components/BankMatching/ImportPreviewModal.jsx";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DocumentService from "../../Services/documents.service.js";
import ExternalTransactionsService from "../../Services/externalTransaction.service.js";
import { buildBankMatchJournalPayload, createBankMatch } from "../../Utils/bankMatchActions.js";
import BankMatchAiService from "../../Services/bankMatchAi.service.js";
import AiMatchSuggestionsModal from "../../Components/BankMatching/AiMatching/AiMatchSuggestionsModal.jsx";
import FinsiteService from "../../Services/finsite.service.js";
import ForeignCurrencyService from "../../Services/foreignCurrency.service.js";
import CloudSyncIcon from "@mui/icons-material/CloudSync";
import KeyboardIcon from "@mui/icons-material/Keyboard";
import UnfoldLessIcon from "@mui/icons-material/UnfoldLess";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import KeyboardShortcutsDialog from "../../Components/BankMatching/KeyboardShortcutsDialog.jsx";
import RemoveMatchConfirmModal from "../../Components/BankMatching/RemoveMatchConfirmModal.jsx";
import AccountCardSelect from "../../Components/BankMatching/AccountCardSelect.jsx";
import { FinsiteFetchModal } from "../../Components/BankMatching/FinsiteModals.jsx";
import { focusFirstField, handleDialogEnterNavigation } from "../../Utils/dialogKeyboardNav.js";
import XtramModal, {
  XtramButton,
  XtramField,
  XtramInput,
  XtramNotice,
  XtramSelect,
  xtramStyles,
} from "../../Components/Widgets/XtramModal/XtramModal";
import bankXtramStyles from "../../Components/BankMatching/BankXtram.module.scss";
import NoDocumentsPdf from "../../assests/pdf/NoDocument.pdf";
import ClientService from "../../Services/client.service.js";
import ClientDocumentCountService from "../../Services/ClientDocumentCount.service.js";
import EditPaymentAcceptanceModal from "../../Components/EditPaymentAcceptanceModal/EditPaymentAcceptanceModal.js";
import editIconImage from "../../assests/images/Icons/editIcon.svg";
import AddAccountCardModal from '../../Components/Widgets/AddAccountCardModal/AddAccountCardModal.jsx';
import { handleDownloadTemplate } from '../../Utils/handleDownloadTemplate';
import {
  getGridStringOperatorsWithComparison,
  getGridNumericOperatorsWithNotLike,
  getGridDateOperatorsWithNotLike,
} from '../../Utils/DataGridFilterOperators';

import BottomDockBar from "../../Components/BankMatching/BottomDockBar.js";
import CustomMonthDatePickerMui from "../../Components/Widgets/CustomDates/CustomMonthDatePicker/CustomMonthDatePickerMui.js";
import headerStyles from "../../Components/ClientDetails/SubComponents/ClientDetailsHeader/HeaderToolbar.module.scss";
import ActionChip, { toolbarIconButtonSx } from "../../Components/Widgets/ActionChip/ActionChip.jsx";
import FilterToggleGroup from "../../Components/Widgets/FilterToggleGroup/FilterToggleGroup.jsx";
import PaymentAcceptanceCreateEditModal from "../../Components/PaymentAcceptance/SubComponents/PaymentAcceptanceCreateEditModal.jsx";
import BankFile from "../../assests/templates/Xtram_Bank_Template.xlsx";
import { NavHistoryContext } from "../../Contexts/NavHistoryContext.js";
import { validateDocumentBeforeProcessing, validatePaymentAcceptanceItems } from '../../Utils/documentValidation'
import { buildPaymentAcceptanceUpdatePayload } from '../../Utils/paymentAcceptanceUpdatePayload.js'
import ChooseAsset from "../../Components/Widgets/ChooseAsset/ChooseAsset.js";
import AssetService from "../../Services/assets.service.js";
import AddAssetGroup from "../../Components/Assets/SubComponents/AddAssetGroup.js";
import { assertEachIs } from "pdf-lib";
import AssetFoundDialog from "../../Components/Widgets/AssetFoundDialog/AssetFoundDialog.js";
import { useHamburgerMenu } from '../../Contexts/HamburgerMenuContext';
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import TableChartIcon from "@mui/icons-material/TableChart";
import SummarizeIcon from "@mui/icons-material/Summarize";
import {
  buildUnmatchedCardsFlatSection,
  buildUnmatchedCardsSummary,
  downloadUnmatchedExcel,
  downloadUnmatchedPdf,
} from "../../Utils/unmatchedExport";
import UnmatchedReportModal from "../../Components/Widgets/UnmatchedReportModal/UnmatchedReportModal.jsx";

registerLocale("en-GB", {
  ...enGB,
  localize: {
    ...enGB.localize,
    month: (n) => n + 1, // Display months as numbers starting from 1
  },
  formatLong: {
    ...enGB.formatLong,
    date: () => "MM/yyyy", // Date format when the picker is not showing
  },
});

setDefaultLocale("en-GB"); // Set the default locale to use it

// Create rtl cache
const cacheRtl = createCache({
  key: "data-grid-rtl-demo",
  stylisPlugins: [prefixer, rtlPlugin],
});

const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '';
  const day = ("0" + date.getDate()).slice(-2);
  const month = ("0" + (date.getMonth() + 1)).slice(-2);
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};
// Utility to generate n number of absolutely distinct colors
const generateDistinctColors = (n, alpha = 0.5) => {
  const colors = [];
  const goldenRatio = 0.618033988749895; // To generate distinct hues
  let hue = Math.random(); // Start with a random initial hue

  for (let i = 0; i < n; i++) {
    hue += goldenRatio; // Spread hues using golden ratio for maximum distinctness
    hue %= 1; // Keep hue within [0, 1] range
    const saturation = 50 + Math.random() * 50; // Saturation between 50% and 100%
    const lightness = 40 + Math.random() * 30; // Lightness between 40% and 70%

    // Add opacity to the color by switching to hsla
    colors.push(`hsla(${hue * 360}, ${saturation}%, ${lightness}%, ${alpha})`);
  }

  return colors;
};

// Usage example:
const numberOfColors = 50;
const matchColors = generateDistinctColors(numberOfColors);

// The community DataGrid forces pagination on and rejects a `pageSize` above
// 100, but it only slices rows in client pagination mode. Declaring server mode
// makes it render every row it is handed, which is how the reconciliation lists
// scroll continuously instead of page by page. Rows stay virtualized, so only
// the visible ones are ever in the DOM.
const ALL_ROWS_PAGE_SIZE = 100;
const ALL_ROWS_PAGINATION_MODEL = { page: 0, pageSize: ALL_ROWS_PAGE_SIZE };
const ALL_ROWS_PAGE_SIZE_OPTIONS = [ALL_ROWS_PAGE_SIZE];

const getBackgroundColor = (color, mode) =>
  mode === "dark" ? darken(color, 0.6) : lighten(color, 0.6);

const StyledDataGrid = styled(DataGrid)(({ theme }) => {
  // Generate styles for matched rows as an object
  const matchedRowStyles = matchColors.reduce((styles, color, index) => {
    styles[`& .MuiDataGrid-row.super-app-theme--matched-${index}`] = {
      backgroundColor: color,
      "&:hover": {
        backgroundColor: color,
      },
    };
    return styles;
  }, {});

  return {
    "& *": {
      boxSizing: "border-box !important",
    },
    // Include the matched row styles
    ...matchedRowStyles,
    "& .super-app-theme--UnMatched": {
      backgroundColor: getBackgroundColor(
        theme.palette.info.main,
        theme.palette.mode
      ),
      "&:hover": {
        backgroundColor: getBackgroundColor(
          theme.palette.info.main,
          theme.palette.mode
        ),
      },
    },
    "& .super-app-theme--Matched": {
      backgroundColor: getBackgroundColor(
        theme.palette.success.main,
        theme.palette.mode
      ),
      "&:hover": {
        backgroundColor: getBackgroundColor(
          theme.palette.success.main,
          theme.palette.mode
        ),
      },
    },
    // Style for main matched rows (Level 0)
    "& .super-app-theme--MainRow": {
      backgroundColor: theme.palette.background.paper,
      "&:hover": {
        backgroundColor: getBackgroundColor(
          theme.palette.action.hover,
          theme.palette.mode
        ),
      },
    },
    // Style for header rows (Level 1)
    "& .super-app-theme--Header": {
      backgroundColor: theme.palette.grey[200],
      fontWeight: "bold",
      "&:hover": {
        backgroundColor: getBackgroundColor(
          theme.palette.grey[300],
          theme.palette.mode
        ),
      },
    },
    // Style for transaction sub-rows (Level 2)
    "& .super-app-theme--SubRow": {
      backgroundColor: theme.palette.grey[50],
      "&:hover": {
        backgroundColor: getBackgroundColor(
          theme.palette.action.hover,
          theme.palette.mode
        ),
      },
    },
    "& .MuiDataGrid-scrollbar.MuiDataGrid-scrollbar--horizontal": {
      display: "block !important",
    },
    "& .MuiDataGrid-columnHeaders": {
      // opacity: 0.7,
      backgroundColor: "#BFC8FF",
    },
    "& .MuiDataGrid-columnHeader": {
      backgroundColor: "#BFC8FF",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      color: "#304FFF",
      textAlign: "center",
      fontFamily: "Montserrat",
      fontSize: "14px",
      fontWeight: 600,
      lineHeight: "normal",
    },
    "& .MuiDataGrid-cell": {
      borderTop: "1px solid rgba(191, 191, 193, 0.56)",
      backgroundColor: "rgba(234, 237, 255, 0.32)",
      whiteSpace: "normal",
      wordWrap: "break-word",
    },
    "& .MuiDataGrid-row:hover": {
      backgroundColor: "rgba(191, 200, 255, 0.3)",
    },
    "& .MuiDataGrid-cell:focus": {
      outline: "none",
    },
    "& .MuiDataGrid-cell": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
  };
});

// Escapes text so it can be safely injected into the print window markup.
const escapeHtmlForPrint = (value) =>
  String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

const formatDateDMY = (date) => {
  if (!(date instanceof Date) || isNaN(date.getTime())) return "";
  const day = ("0" + date.getDate()).slice(-2);
  const month = ("0" + (date.getMonth() + 1)).slice(-2);
  return `${day}/${month}/${date.getFullYear()}`;
};

// Reads the display text of a cell honoring the column's valueFormatter so the
// exported/printed value matches what the user sees in the grid.
const getGridCellText = (api, id, column) => {
  try {
    const params = api.getCellParams(id, column.field);
    let value = params?.formattedValue;
    if (value == null || typeof value === "object") value = params?.value;
    if (value == null) return "";
    if (value instanceof Date) return formatDateDMY(value);
    if (typeof value === "object") return "";
    return String(value);
  } catch (e) {
    return "";
  }
};

// Only export/print real data columns (skip selection checkbox / action columns
// and non-textual columns such as embedded document previews).
const getExportableColumns = (apiRef) => {
  const columns = gridVisibleColumnDefinitionsSelector(apiRef);
  return columns.filter(
    (col) =>
      col.field !== "__check__" &&
      col.type !== "actions" &&
      col.field !== "document" &&
      !!col.field
  );
};

// Custom DataGrid toolbar: replaces the default CSV export with an XLSX export
// (UTF-8, so Hebrew is preserved) and replaces the browser grid print with a
// clean RTL table print that can be saved as PDF.
function CustomGridToolbar(props) {
  const { t, direction = "rtl", fileName = "export", title = "" } = props;
  const apiContext = useGridApiContext();

  const buildRows = () => {
    const api = apiContext.current;
    const columns = getExportableColumns(apiContext);
    const rowIds = gridFilteredSortedRowIdsSelector(apiContext);
    return { api, columns, rowIds };
  };

  const handleExportXlsx = () => {
    const { api, columns, rowIds } = buildRows();
    if (!columns.length) return;

    const header = columns.map((col) => col.headerName || col.field);
    const dataRows = rowIds.map((id) =>
      columns.map((col) => getGridCellText(api, id, col))
    );

    const worksheet = XLSX.utils.aoa_to_sheet([header, ...dataRows]);
    worksheet["!cols"] = header.map(() => ({ wch: 22 }));
    // Render the sheet right-to-left in Excel for Hebrew content.
    if (direction === "rtl") {
      worksheet["!views"] = [{ RTL: true }];
    }

    const workbook = XLSX.utils.book_new();
    const sheetName = (title || "Sheet1").substring(0, 31);
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    // xlsx stores strings as UTF-8, so Hebrew is preserved (unlike raw CSV).
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
  };

  const handlePrintPdf = () => {
    const { api, columns, rowIds } = buildRows();
    if (!columns.length) return;

    const headerCells = columns
      .map((col) => `<th>${escapeHtmlForPrint(col.headerName || col.field)}</th>`)
      .join("");
    const bodyRows = rowIds
      .map(
        (id) =>
          `<tr>${columns
            .map((col) => `<td>${escapeHtmlForPrint(getGridCellText(api, id, col))}</td>`)
            .join("")}</tr>`
      )
      .join("");

    const printWindow = window.open("", "_blank");
    if (!printWindow) return;

    const documentTitle = escapeHtmlForPrint(title || fileName || "");
    printWindow.document.write(`
      <!DOCTYPE html>
      <html dir="${direction}" lang="he">
        <head>
          <meta charset="utf-8" />
          <title>${documentTitle}</title>
          <style>
            * { box-sizing: border-box; }
            body {
              font-family: Arial, "Segoe UI", "Noto Sans Hebrew", sans-serif;
              margin: 24px;
              color: #1a1a1a;
            }
            h1 { font-size: 18px; margin: 0 0 16px; text-align: center; }
            table { width: 100%; border-collapse: collapse; direction: ${direction}; }
            th, td {
              border: 1px solid #999;
              padding: 6px 8px;
              font-size: 12px;
              text-align: center;
              word-break: break-word;
            }
            thead th { background: #BFC8FF; color: #304FFF; }
            tbody tr:nth-child(even) { background: #eef1ff; }
            @media print {
              thead { display: table-header-group; }
              tr { page-break-inside: avoid; }
            }
          </style>
        </head>
        <body>
          ${documentTitle ? `<h1>${documentTitle}</h1>` : ""}
          <table>
            <thead><tr>${headerCells}</tr></thead>
            <tbody>${bodyRows}</tbody>
          </table>
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    // Give the new document a tick to lay out before invoking the print dialog.
    setTimeout(() => {
      printWindow.print();
    }, 300);
  };

  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarDensitySelector />
      <Button
        size="small"
        startIcon={<DownloadIconMui />}
        onClick={handleExportXlsx}
        sx={{ textTransform: "none" }}
      >
        {t ? t("Export") : "Export"}
      </Button>
      <Button
        size="small"
        startIcon={<PrintIcon />}
        onClick={handlePrintPdf}
        sx={{ textTransform: "none" }}
      >
        {t ? t("Print") : "Print"}
      </Button>
      <Box sx={{ flex: 1 }} />
      <GridToolbarQuickFilter />
    </GridToolbarContainer>
  );
}

const formatMonthYearDate = (dateString) => {
  // Parse YYYY-MM-DD as date-only to avoid timezone shifting (e.g. 2026-01-10 showing as 12/2025)
  if (typeof dateString === "string" && /^\d{4}-\d{2}-\d{2}/.test(dateString)) {
    const [y, m] = dateString.split("T")[0].split("-");
    return `${m}/${y}`;
  }
  const date = new Date(dateString);
  const month = ("0" + (date.getMonth() + 1)).slice(-2);
  const year = date.getFullYear();
  return `${month}/${year}`;
};

// Utility function to convert DD-MM-YYYY to YYYY-MM-DD
const parseCustomDate = (dateStr) => {
  if (!dateStr) return null;
  if (dateStr instanceof Date) return dateStr.toISOString().split("T")[0];
  const str = String(dateStr);
  if (/^\d{4}-\d{2}-\d{2}/.test(str)) return str.split("T")[0];
  const sep = str.includes("/") ? "/" : "-";
  const [day, month, year] = str.split(sep);
  return `${year}-${month}-${day}`;
};

const getOldestBankDate = (bankRows) =>
  bankRows.reduce((oldest, row) => {
    const date = new Date(parseCustomDate(row.transactionDate));
    return oldest == null || date < oldest ? date : oldest;
  }, null);

// Normalize reporting month date to day 10 to avoid timezone display issues (e.g. 01-2026 showing as 31/12/2025)
const setReportingMonthToDay10 = (date) => {
  if (!date) return date;
  const d = new Date(date);
  d.setDate(10);
  return d;
};

const currencyOptions = Object
  .entries(Constants.ForeignCurrencyCode)
  .map(([code, num]) => ({ label: code, value: num }));

/** Balances accumulate from here so they stay comparable to the bank's own. */
const BALANCE_EPOCH = new Date(Date.UTC(1970, 0, 1));


function BankMatching() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const direction = i18n.dir();
  const [user, setUser] = useState(null);
  const [token, setToken] = useState("");
  const [client, setClient] = useState(null);
  const { settings: caseSystemSettings } = useCaseSystemAccountSettings(client?.caseId, token);
  const [type, setType] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const location = useLocation();
  const [selectedLanguage, setSelectedLanguage] = useState(
    localStorage.getItem("language") || "he"
  );
  const [loading, setLoading] = useState(false);
  const [bottomDockBarLoading, setBottomDockBarLoading] = useState(false);
  const [internalRows, setInternalRows] = useState([]);
  const [displayedRows, setDisplayedRows] = useState([]);
  const [externalRows, setExternalRows] = useState([]);
  const [isClientDataFetched, setIsClientDataFetched] = useState(false);
  const [shouldMatch, setShouldMatch] = useState(false);
  const [sortConfig, setSortConfig] = useState({
    key: "cardId",
    direction: "descending",
    type: "number",
  });
  const [focused, setFocused] = useState(false);
  const customScrollbarRef = useRef();
  const tableContainerRef = useRef();
  // const [matchedDisplayedRows, setMatchedDisplayedRows] = useState([]);
  const [openRemoveMatchDialog, setOpenRemoveMatchDialog] = useState(false);
  const [selectedMatch, setSelectedMatch] = useState(null);
  const apiRef = useGridApiRef();
  const externalApiRef = useGridApiRef();

  // Keyboard-driven reconciliation state: which panel the keyboard controls,
  // the focused row per panel, and the Shift range-selection anchor per panel.
  const [activePanel, setActivePanel] = useState("external");
  const [focusedInternalId, setFocusedInternalId] = useState(null);
  const [focusedExternalId, setFocusedExternalId] = useState(null);
  const [internalAnchorId, setInternalAnchorId] = useState(null);
  const [externalAnchorId, setExternalAnchorId] = useState(null);
  const [shortcutsOpen, setShortcutsOpen] = useState(false);
  const [focusMode, setFocusMode] = useBankWorkspaceLayout("BankMatchingFocusMode");
  const [sortedTransactions, setSortedTransactions] = useState([]);
  const [cardForNewBank, setCardForNewBank] = useState(null);
  const [foreignCurrencyCode, setForeignCurrencyCode] = useState(null);
  const [denseTableCreditDebitRows, setDenseTableCreditDebitRows] = useState([]);
  const [finsiteBalanceRows, setFinsiteBalanceRows] = useState([]);
  const [finsiteDiffRows, setFinsiteDiffRows] = useState([]);
  const [finsiteBalanceLoading, setFinsiteBalanceLoading] = useState(false);
  const [itemIdToDelete, setItemIdToDelete] = useState('');
  const [itemTypeToDelete, setItemTypeToDelete] = useState('');
  const handleChangeSetCardForNewBank = (value) => {


    if (value) {
      setCardForNewBank(value);
    } else {
      setCardForNewBank(null);
    }
  }
  const { setMenuProps } = useHamburgerMenu();
  useEffect(() => {
    setMenuProps({ client });
  }, [client, setMenuProps]);

  //account cards
  const [accountCardsData, setAccountCardsData] = useState([]);
  const [startDate, setStartDate] = useState(() => {
    const stored = localStorage.getItem("StartDate");
    const date = stored ? new Date(stored) : null;
    const currentYear = new Date().getFullYear();
    const defaultStart = new Date(Date.UTC(currentYear, 0, 1));


    return date && !isNaN(date.getTime()) ? date : defaultStart;
  });

  const [endDate, setEndDate] = useState(() => {
    const stored = localStorage.getItem("EndDate");
    const date = stored ? new Date(stored) : null;
    const currentYear = new Date().getFullYear();
    const defaultEnd = new Date(Date.UTC(currentYear, 11, 31, 23, 59, 59));


    return date && !isNaN(date.getTime()) ? date : defaultEnd;
  });

  const [isRange, setIsRange] = useState(() => localStorage.getItem("IsRange") === "true");

  const [isMatchDate, setIsMatchDate] = useState(() => {
    const stored = localStorage.getItem("BankMatchingIsMatchDate");
    return stored === "true";
  });

  const lastRangeRef = useRef({ start: null, end: null });

  const getFetchDateRange = (
    type = fetchType,
    rangeStart = startDate,
    rangeEnd = endDate,
    range = isRange
  ) => {
    if (type === "Matched") {
      return { start: rangeStart, end: rangeEnd };
    }
    // Year mode covers the whole calendar year; range mode honours the exact
    // days the user picked rather than snapping out to month boundaries.
    if (!range) {
      return yearBounds(rangeEnd.getUTCFullYear());
    }
    return { start: startOfUtcDay(rangeStart), end: endOfUtcDay(rangeEnd) };
  };

  const [fetchType, setFetchType] = useState("NotMatched");
  const [showOnlyWithDocuments, setShowOnlyWithDocuments] = useState(false);

  const handleFetchTypeChange = async (event, newAlignment) => {
    if (newAlignment !== null) {
      setFetchType(newAlignment);
      const { start, end } = getFetchDateRange(newAlignment);
      if (newAlignment === "Matched") {
        await fetchMatchDataOnDateRangeChange(start, end, isMatchDate);
      } else {
        await fetchNotMatchDataOnDateRangeChange(start, end);
      }
      await updateDenseTableTotalsForDateRange(start, end);
    }
  };

  const existingTheme = useTheme();
  useEffect(() => {
    const currentLanguage = localStorage.getItem("language") || "he";
    setSelectedLanguage(currentLanguage);
  }, [i18n.language]);


  // useEffect(() => {
  //   const currentYear = new Date().getFullYear();

  //   if (!startDate || isNaN(new Date(startDate).getTime())) {
  //     setStartDate(new Date(currentYear, 0, 1)); // Jan 1
  //   }

  //   if (!endDate || isNaN(new Date(endDate).getTime())) {
  //     setEndDate(new Date(currentYear, 11, 31, 23, 59, 59)); // Dec 31
  //   }
  // }, [startDate, endDate]);


  const [oldSelectedAccountCardItem, setOldSelectedAccountCardItem] = useState({
    cardId: "",
    caseId: "",
    accountCaseId: "",
    name: "",
    palCode: "",
    client: null,
  });

  const fileInputRef1 = useRef(null); // Reference to the first hidden file input

  const handleCustomScroll = (e) => {
    if (tableContainerRef.current) {
      tableContainerRef.current.scrollLeft = e.target.scrollLeft;
    }
  };

  const denseTableHeader = useMemo(() => [
    t("BanksColCurrency"),
    t("BanksColBankNo"),
    t("BanksColBankName"),
    t("BanksColBranch"),
    t("BanksColAccount"),
    t("BanksColCard"),
    t("BanksColFinsite"),
  ], [t]);
  const [denseTableRows, setDenseTableRows] = useState([]);
  const [tBanksData, setTBanksData] = useState([]);
  const [finsiteDialogOpen, setFinsiteDialogOpen] = useState(false);
  const [finsiteFrom, setFinsiteFrom] = useState(() => {
    const d = new Date();
    return `${d.getFullYear()}-01-01`;
  });
  const [finsiteTo, setFinsiteTo] = useState(() => new Date().toISOString().slice(0, 10));
  const [finsiteCardIds, setFinsiteCardIds] = useState([]);
  const [finsiteHasCredential, setFinsiteHasCredential] = useState(false);

  const [processedCardsData, setProcessedCardsData] = useState([]);
  const [selectedFormattedAccountCard, setSelectedFormattedAccountCard] =
    useState(null);
  const [mainCard, setMainCard] = useState("");
  const [editBankTransactionDialog, setEditBankTransactionDialog] = useState(false);
  const [editedTransaction, setEditedTransaction] = useState(null);
  const [oldEditedTransaction, setOldEditedTransaction] = useState(null);
  const [editViewOnly, setEditViewOnly] = useState(false);
  const [selectedCardId, setSelectedCardId] = useState("");
  const [selectedTBankIndex, setSelectedTBankIndex] = useState(-1); //used for dense table
  const [selectedTBank, setSelectedTBank] = useState("");
  // Inside your component's render/return method:
  const [openImportDialog, setOpenImportDialog] = useState(false);
  const [openPreviewModal, setOpenPreviewModal] = useState(false);
  const [previewData, setPreviewData] = useState(null);
  const [previewFile, setPreviewFile] = useState(null);
  const { goBack } = useContext(NavHistoryContext);



  const [matchData, setMatchData] = useState([]);
  const handleOpenImportDialog = () => {
    if (!selectedTBank) {
      toast.info(t("YouNeedToSelectABankFirst"));
      return;
    }

    // Search for a matching bank entry in tBanks
    const bankEntry = tBanksData.find(
      (bank) => bank.cardId?.toString() === mainCard.cardId?.toString()
    );

    // If a matching bank entry is found and it has a corresponding URL
    if (bankEntry && Constants.BankUrls[parseInt(bankEntry.bankCode)]) {
      // Open the bank's URL in a new tab
      window.open(Constants.BankUrls[parseInt(bankEntry.bankCode)], "_blank");
    }

    // Open the dialog
    setOpenImportDialog(true);
  };

  const handleCloseImportDialog = () => {
    setOpenImportDialog(false);
  };

  const [externalTransactions, setExternalTransactions] = useState([]);
  
  const handlePreview = async (file) => {
    setLoading(true);
    const bankType = Constants.BankTypes[parseInt(selectedTBank.bankCode)];
    const accountCard = accountCardsData.find(
      (card) => card.cardId === selectedCardId
    );

    try {
      const result = await ExternalTransactionsService.PreviewExternalTransactions(
        client.caseId,
        selectedCardId,
        accountCard.name,
        bankType,
        file,
        token
      );

      setPreviewData(result);
      setPreviewFile(file);
      setOpenPreviewModal(true);
    } catch (error) {
      toast.error(t("BankDataImportFailed"));
      console.error("Error previewing file:", error);
    }
    setLoading(false);
  };

  const handleImport = async (file) => {
    setLoading(true);
    // selectedTBank is the selected bank
    const bankType = Constants.BankTypes[parseInt(selectedTBank.bankCode)];
    const accountCard = accountCardsData.find(
      (card) => card.cardId === selectedCardId
    );

    try {
      // Call the service method to import transactions
      const response =
        await ExternalTransactionsService.ImportExternalTransactions(
          client.caseId,
          selectedCardId,
          accountCard.name,
          bankType,
          file,
          token
        );

      if (response.ok) {
        toast.success(t("BankDataImportSuccessful"));
        await FetchData();
      } else {
        toast.error(t("BankDataImportFailed"));
      }
    } catch (error) {
      toast.error(t("BankDataImportFailed"));

      console.error("Error importing file:", error);
    }
    setLoading(false);
  };

  const refreshFinsiteEligibility = async () => {
    if (!client?.caseId || !token) {
      setFinsiteCardIds([]);
      setFinsiteHasCredential(false);
      return;
    }
    try {
      const response = await FinsiteService.GetEligibility(client.caseId, token);
      if (response.ok) {
        const data = await response.json();
        setFinsiteCardIds((data?.cardIds || []).map((id) => String(id)));
        setFinsiteHasCredential(!!data?.hasCredential);
      } else {
        setFinsiteCardIds([]);
        setFinsiteHasCredential(false);
      }
    } catch (error) {
      console.error("Failed to load Finsite eligibility:", error);
      setFinsiteCardIds([]);
      setFinsiteHasCredential(false);
    }
  };

  // Keep the banks table Finsite column in sync with linked cardIds from eligibility.
  useEffect(() => {
    if (!Array.isArray(tBanksData) || tBanksData.length === 0) {
      return;
    }
    const linkedSet = new Set((finsiteCardIds || []).map(String));
    const rows = tBanksData.map((bank) => {
      const isLinked = linkedSet.has(String(bank.cardId));
      return [
        (() => {
          const currencyObj = currencyOptions.find((o) => o.value === bank.foreignCurrencyCode);
          const code = currencyObj?.label;
          const symbol = Constants.ForeignCurrencySymbol[code] || "";
          return code ? `${code}${symbol ? " (" + symbol + ")" : ""}` : "-";
        })(),
        bank.bankCode || "-",
        bank.bankName || "-",
        bank.branchNumber || "-",
        bank.accountNumber || "-",
        bank.cardId || "-",
        isLinked ? (
          <Chip
            key={`finsite-${bank.cardId}`}
            size="small"
            icon={<CloudSyncIcon sx={{ fontSize: "14px !important" }} />}
            label={t("FinsiteLinked")}
            sx={{
              height: 24,
              fontWeight: 600,
              fontSize: "0.7rem",
              bgcolor: "rgba(13, 148, 136, 0.12)",
              color: "#0F766E",
              border: "1px solid rgba(13, 148, 136, 0.28)",
              "& .MuiChip-icon": { color: "#0D9488" },
              "& .MuiChip-label": { px: 0.75 },
            }}
          />
        ) : (
          <Chip
            key={`finsite-off-${bank.cardId}`}
            size="small"
            label={t("FinsiteNotLinked")}
            variant="outlined"
            sx={{
              height: 24,
              fontWeight: 500,
              fontSize: "0.7rem",
              color: "rgba(15, 23, 42, 0.45)",
              borderColor: "rgba(15, 23, 42, 0.12)",
              bgcolor: "rgba(15, 23, 42, 0.02)",
              "& .MuiChip-label": { px: 0.75 },
            }}
          />
        ),
      ];
    });
    setDenseTableRows(rows);
  }, [tBanksData, finsiteCardIds, t]);

  useEffect(() => {
    refreshFinsiteEligibility();
  }, [client?.caseId, token]);

  const isSelectedAccountFinsiteLinked = finsiteCardIds.includes(String(selectedCardId));

  // Load Finsite Balance / TotalCredit / TotalDebit for the linked account so we can
  // compare against the Xtram summary (same date range).
  const refreshFinsiteBalances = async (cardId, rangeStart, rangeEnd, xtramTotals) => {
    if (!client?.caseId || !cardId || !finsiteCardIds.includes(String(cardId))) {
      setFinsiteBalanceRows([]);
      setFinsiteDiffRows([]);
      return;
    }

    const toIso = (d) => {
      if (!d) return null;
      const dt = d instanceof Date ? d : new Date(d);
      if (Number.isNaN(dt.getTime())) return null;
      return dt.toISOString().slice(0, 10);
    };

    setFinsiteBalanceLoading(true);
    try {
      const response = await FinsiteService.GetCaseAccountBalances(
        client.caseId,
        cardId,
        toIso(rangeStart),
        toIso(rangeEnd),
        token
      );
      if (!response.ok) {
        setFinsiteBalanceRows([]);
        setFinsiteDiffRows([]);
        return;
      }
      const data = await response.json();
      if (!data?.success && data?.status === 'NoMapping') {
        setFinsiteBalanceRows([]);
        setFinsiteDiffRows([]);
        return;
      }

      const fBalance = Number(data.balance) || 0;
      const fCredit = Number(data.totalCredit) || 0;
      const fDebit = Number(data.totalDebit) || 0;

      setFinsiteBalanceRows([{
        balance: beautifyNumber(fBalance),
        credit: beautifyNumber(fCredit),
        debit: beautifyNumber(fDebit),
      }]);

      if (xtramTotals) {
        setFinsiteDiffRows([{
          balance: beautifyNumber(fBalance - (Number(xtramTotals.balance) || 0)),
          credit: beautifyNumber(fCredit - (Number(xtramTotals.credit) || 0)),
          debit: beautifyNumber(fDebit - (Number(xtramTotals.debit) || 0)),
        }]);
      } else {
        setFinsiteDiffRows([]);
      }
    } catch (error) {
      console.error('Failed to load Finsite balances:', error);
      setFinsiteBalanceRows([]);
      setFinsiteDiffRows([]);
    } finally {
      setFinsiteBalanceLoading(false);
    }
  };

  // Preview Finsite transactions for the selected account/date range, then open the
  // same ImportPreviewModal used by Excel import. Confirm later runs the real sync.
  const handleFinsiteFetch = async () => {
    if (!selectedTBank || !selectedCardId) {
      toast.info(t("YouNeedToSelectABankFirst"));
      return;
    }

    const toIsoDate = (d) => {
      const date = new Date(d);
      return isNaN(date.getTime()) ? null : date.toISOString().slice(0, 10);
    };

    setLoading(true);
    try {
      const response = await FinsiteService.PreviewCaseAccount(
        client.caseId,
        selectedCardId,
        toIsoDate(finsiteFrom),
        toIsoDate(finsiteTo),
        token
      );

      if (response.ok) {
        const result = await response.json();
        if (result.success || result.status === "PartialSuccess") {
          const newCount = result.transactionsCount || 0;
          const dupCount = result.duplicateCount || (result.duplicateTransactions || []).length || 0;
          const docsAvailable = result.documentsAvailableToAttach
            || (result.duplicateTransactions || []).filter((r) => r.canAttachDocument).length
            || 0;
          const docsRefreshable = result.documentsAvailableToRefresh
            || (result.duplicateTransactions || []).filter((r) => r.canRefreshDocument || r.hasChequeImage).length
            || 0;
          if (newCount === 0 && dupCount === 0) {
            toast.info(t("FinsiteFetchNoNew"));
            setFinsiteDialogOpen(false);
          } else {
            setPreviewData({
              transactions: result.transactions || [],
              transactionsCount: newCount,
              duplicateTransactions: result.duplicateTransactions || [],
              duplicateCount: dupCount,
              documentsAvailableToAttach: docsAvailable,
              documentsAvailableToRefresh: docsRefreshable,
              balanceBefore: result.balanceBefore ?? 0,
              balanceAfter: result.balanceAfter ?? 0,
              bankBalance: result.bankBalance ?? null,
              systemBalance: result.systemBalance ?? result.balanceBefore ?? 0,
              totalDebit: result.totalDebit || 0,
              totalCredit: result.totalCredit || 0,
              skippedCount: result.skippedCount || dupCount,
              isFinsiteImport: true,
              finsiteFrom: toIsoDate(finsiteFrom),
              finsiteTo: toIsoDate(finsiteTo),
            });
            setPreviewFile(null);
            setFinsiteDialogOpen(false);
            setOpenPreviewModal(true);
          }
        } else if (result.status === "NoMapping") {
          toast.error(t("FinsiteNoMapping"));
        } else if (result.status === "NoActiveCredential") {
          toast.error(t("FinsiteNoCredential"));
        } else if (result.status === "AuthFailed") {
          toast.error(t("FinsiteAuthFailed"));
        } else {
          toast.error(t("FinsiteFetchFailed"));
        }
      } else {
        toast.error(t("FinsiteFetchFailed"));
      }
    } catch (error) {
      console.error("Finsite preview failed:", error);
      toast.error(t("FinsiteFetchFailed"));
    }
    setLoading(false);
  };

  const handleConfirmFinsiteImport = async (options = {}) => {
    if (!previewData?.isFinsiteImport || !selectedCardId) return;

    const attachDocumentsForExisting = options.attachDocumentsForExisting !== false;
    const forceRefreshDocuments = !!options.forceRefreshDocuments;

    setLoading(true);
    try {
      const response = await FinsiteService.SyncCaseAccount(
        client.caseId,
        selectedCardId,
        previewData.finsiteFrom,
        previewData.finsiteTo,
        token,
        attachDocumentsForExisting,
        forceRefreshDocuments
      );

      if (response.ok) {
        const result = await response.json();
        if (result.success) {
          const imported = result.importedCount || 0;
          const docsAttached = result.documentsAttachedCount || 0;
          if (imported > 0 && docsAttached > 0) {
            toast.success(
              `${t("FinsiteFetchSuccess")} (${imported}) · ${t("FinsiteDocumentsSaved")} (${docsAttached})`
            );
          } else if (imported > 0) {
            toast.success(`${t("FinsiteFetchSuccess")} (${imported})`);
          } else if (docsAttached > 0) {
            toast.success(`${t("FinsiteDocumentsSaved")} (${docsAttached})`);
          } else {
            toast.info(t("FinsiteFetchNoNew"));
          }
          setOpenPreviewModal(false);
          setPreviewData(null);
          await FetchData();
        } else if (result.status === "NoMapping") {
          toast.error(t("FinsiteNoMapping"));
        } else if (result.status === "NoActiveCredential") {
          toast.error(t("FinsiteNoCredential"));
        } else if (result.status === "AuthFailed") {
          toast.error(t("FinsiteAuthFailed"));
        } else {
          toast.error(t("FinsiteFetchFailed"));
        }
      } else {
        toast.error(t("FinsiteFetchFailed"));
      }
    } catch (error) {
      console.error("Finsite import failed:", error);
      toast.error(t("FinsiteFetchFailed"));
    }
    setLoading(false);
  };

  const handleConfirmImport = async (options = {}) => {
    if (previewData?.isFinsiteImport) {
      await handleConfirmFinsiteImport(options);
      return;
    }
    if (previewFile) {
      setOpenPreviewModal(false);
      await handleImport(previewFile);
      setPreviewFile(null);
      setPreviewData(null);
    }
  };

  const [addBankTransactionDialog, setAddBankTransactionDialog] =
    useState(false);

  const handleCloseBankAddTransactionDialog = () => {
    setAddBankTransactionDialog(false);
    setNewBankEditableItem({
      caseId: '',
      accountCodeId: '',
      accountCodeName: '',
      description: '',
      reference: '',
      amount: '',
      transactionDate: new Date()
    });
  };

  const handleAddBankTransaction = async () => {
    try {


      const isForeign = selectedTBank?.foreignCurrencyCode != null;
      const amountValue = parseFloat(newBankEditableItem.amount || 0);

      const updatedBankItem = {
        ...newBankEditableItem,
        caseId: client.caseId,
        accountCodeId: mainCard.cardId,
        accountCodeName: mainCard.name,

        // ─── domestic vs. foreign ───
        amount: isForeign ? 0 : amountValue,
        foreignCurrencyAmount: isForeign ? amountValue : null,
        foreignCurrencyCode: isForeign ? selectedTBank.foreignCurrencyCode : null,
      };



      const response = await ExternalTransactionsService.CreateTransaction(updatedBankItem, token);

      if (response.ok) {

        setNewBankEditableItem({
          caseId: '',
          accountCodeId: '',
          accountCodeName: '',
          description: '',
          reference: '',
          amount: '',
          transactionDate: new Date()
        });
        handleCloseBankAddTransactionDialog();
        await FetchData();
      } else {
        const errorMessage = await response.text();

        if (errorMessage === "A transaction with the same reference already exists.") {
          toast.error(t('TransactionWithSameReferenceExists'));
        }
        toast.error(t('TransactionWithSameReferenceExists'));
      }
    } catch (error) {

      toast.error(t('FailedToCreateBankCommand'));
    }
  };
  const changeNewBankTransaction = (field, value) => {
    setNewBankEditableItem(prevState => ({
      ...prevState,
      [field]: value
    }));

  };

  const [newBankEditableItem, setNewBankEditableItem] = useState({
    caseId: '',
    accountCodeId: '',
    accountCodeName: '',
    description: '',
    reference: '',
    amount: '',
    foreignCurrencyAmount: '',
    foreignCurrencyCode: null,
    transactionDate: ''
  });

  const handleOpenBankAddTransactionDialog = () => {
    if (!selectedTBank) {
      toast.info(t("YouNeedToSelectABankFirst"));
      return;
    }
    setAddBankTransactionDialog(true);
  };

  //for opening create bank modal
  const [createBankModal, setCreateBankModal] = useState(false);
  const bankOptions = Object.keys(Constants.BankNames).map((key) => ({
    value: key,
    label: `${Constants.BankNames[key]} - ${key}`, // Format: BankName - BankNumber
  }));

  const [selectedBankForCreate, setSelectedBankForCreate] = useState(null);
  const [bankBranch, setBankBranch] = useState("");
  const [bankAccountNumber, setBankAccountNumber] = useState("");
  const [selectedExternalRows, setSelectedExternalRows] = useState([]);
  const [selectedMatchedRows, setSelectedMatchedRows] = useState([]);
  const [removingMatches, setRemovingMatches] = useState(false);
  // Many-account open-items report: which accounts to cover, and how far the fetching got.
  const [unmatchedAccountsModalOpen, setUnmatchedAccountsModalOpen] = useState(false);
  const [unmatchedAccountsBusy, setUnmatchedAccountsBusy] = useState(false);
  const [unmatchedAccountsProgress, setUnmatchedAccountsProgress] = useState({ done: 0, total: 0 });
  const [selectedInternalRows, setSelectedInternalRows] = useState([]);
  const [expandedInternalRows, setExpandedInternalRows] = useState({});
  const [expandedExternalRows, setExpandedExternalRows] = useState({});
  const [externalSum, setExternalSum] = useState(0);
  const [internalSum, setInternalSum] = useState(0);
  const [createJournalEntries, setCreateJournalEntries] = useState(false);
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);
  const [usePerRowReportingMonth, setUsePerRowReportingMonth] = useState(false);
  // Split the difference journal entry into several separate journal entries.
  // Each split row carries its own amount + counter-account; all other fields
  // (description, reference, sort code, dates) are shared from the form.
  const [splitDifference, setSplitDifference] = useState(false);
  const [splitRows, setSplitRows] = useState([{ id: 1, amount: "", counterAccount: "" }]);
  const splitRowIdRef = useRef(1);
  const [shouldCallHandleMatch2, setShouldCallHandleMatch2] = useState(false);
  const [shouldCallHandleMatchPair2, setShouldCallHandleMatchPair2] = useState(false);
  const [pairTransaction, setPairTransaction] = useState([]);
  // Matching
  const [matchedPairs, setMatchedPairs] = useState([]);
  const [matchCounter, setMatchCounter] = useState(0);
  const [formValues, setFormValues] = useState({
    confirmationNumber: "",
    accountCaseId: "",
    reference: "",
    description: "",
    documentDate: "",
    reportingMonthDate: new Date(),
    registrationMonthDate: new Date(),
    amount: "",
    vat: 0,
    sortCodeId: "3",
    creditAccount: "",
    debitAccount: "",
    sortCode: "3",
    accountCard: "",
    // Foreign-currency fields for the Create Journal Entry dialog. They mirror the
    // EditModal contract so the JE the dialog creates carries the same exchange-rate
    // metadata as a JE edited via EditModal (otherwise reopening would re-fetch the
    // representative rate over the user's saved manual rate).
    foreignCurrencyCode: null,
    foreignCurrencyAmount: null,
    exchangeRateType: null,
    exchangeRate: null,
  });

  // ─────────────────────────────────────────────────────────────────────────────
  // Create Journal Entry dialog — foreign currency support (ported from EditModal)
  // ─────────────────────────────────────────────────────────────────────────────
  // NIS amount (`formValues.amount`) is always the anchor. Foreign currency amount
  // is derived as `amount / rate` where rate is either the fetched Representative
  // rate (`cjeFCRate`) or the user-entered Manual rate (`formValues.exchangeRate`).
  // Display / storage decimals:
  //   - Manual exchange rate: 10 decimals (matches EditModal)
  //   - Foreign currency amount: 2 decimals (matches Amount field and match tolerance)
  const CJE_MANUAL_RATE_DECIMALS = 10;
  const CJE_FC_AMOUNT_DECIMALS = 2;
  const CJE_AMOUNT_SYNC_DEBOUNCE_MS = 600;
  const [cjeAmountInput, setCjeAmountInput] = useState('');
  const [cjeCurrencyAmountInput, setCjeCurrencyAmountInput] = useState('');
  const [cjeManualRateInput, setCjeManualRateInput] = useState('');
  const [cjeFCRate, setCjeFCRate] = useState(1);
  const [cjeIsLoadingFCRate, setCjeIsLoadingFCRate] = useState(false);
  const cjeLastManualRateRef = useRef(null);
  const cjeUserClearedManualRateRef = useRef(false);
  const formValuesRef = useRef(formValues);
  const cjeManualRateInputRef = useRef('');
  const cjeFCRateRef = useRef(1);
  const cjeAmountSyncTimeoutRef = useRef(null);
  const cjeFcSyncTimeoutRef = useRef(null);
  const cjeRateCalcTimeoutRef = useRef(null);

  useEffect(() => { formValuesRef.current = formValues; }, [formValues]);
  useEffect(() => { cjeManualRateInputRef.current = cjeManualRateInput; }, [cjeManualRateInput]);
  useEffect(() => { cjeFCRateRef.current = cjeFCRate; }, [cjeFCRate]);

  useEffect(() => {
    return () => {
      if (cjeAmountSyncTimeoutRef.current) clearTimeout(cjeAmountSyncTimeoutRef.current);
      if (cjeFcSyncTimeoutRef.current) clearTimeout(cjeFcSyncTimeoutRef.current);
      if (cjeRateCalcTimeoutRef.current) clearTimeout(cjeRateCalcTimeoutRef.current);
    };
  }, []);

  const isCjeForeignBank = () =>
    selectedTBank?.foreignCurrencyCode != null && selectedTBank?.foreignCurrencyCode !== '';

  const cjeParseNumeric = (v) => {
    if (v == null) return NaN;
    if (typeof v === 'number') return v;
    const s = String(v).replace(/,/g, '').trim();
    if (s === '') return NaN;
    return Number(s);
  };

  const cjeHasForeignCode = (fv) =>
    fv?.foreignCurrencyCode != null && fv?.foreignCurrencyCode !== '';

  // Currency conversion is sign-agnostic: a withdrawal (negative difference) converts
  // at the same rate as a deposit. Every derivation below therefore runs on magnitudes,
  // otherwise a negative amount would be rejected by the `> 0` guards and no foreign
  // amount / rate would ever be produced. The two amounts always carry the same sign in
  // the dialog (a negative shekel amount shows a negative foreign amount), while the
  // rate stays positive and the payload sends both amounts as positive magnitudes.
  const cjeAbsNumeric = (v) => {
    const n = cjeParseNumeric(v);
    return isNaN(n) ? NaN : Math.abs(n);
  };

  const cjeSignOf = (v) => (cjeParseNumeric(v) < 0 ? -1 : 1);

  // "USD $" for a numeric ForeignCurrencyCode, used in the currency-aware labels.
  const cjeCurrencyLabel = (code) => {
    if (code == null || code === '') return '';
    const key = Object.entries(Constants.ForeignCurrencyCode).find(
      ([, value]) => value === code
    )?.[0];
    if (!key) return '';
    const symbol = Constants.ForeignCurrencySymbol[key];
    return symbol ? `${key} ${symbol}` : key;
  };

  // Foreign currency is always persisted as a snapshot - code, amount and the exact rate
  // that produced the shekel amount, flagged Manual. This mirrors how EditModal saves:
  // with an explicit manual rate the server keeps the shekel amount we computed instead
  // of re-deriving it from a representative rate that may have moved since.
  // Prefer the rate implied by the amounts themselves. A "known" rate can be the
  // representative fetch, or the default of 1 before any fetch has run - neither of
  // those is trustworthy once the user has typed concrete shekel + foreign totals.
  const cjeResolveSavedRate = (nisAmount, fcAmount, knownRate) => {
    const nis = cjeAbsNumeric(nisAmount);
    const fc = cjeAbsNumeric(fcAmount);
    if (!isNaN(nis) && nis > 0 && !isNaN(fc) && fc > 0) {
      return Number((nis / fc).toFixed(CJE_MANUAL_RATE_DECIMALS));
    }
    const explicit = cjeAbsNumeric(knownRate);
    if (!isNaN(explicit) && explicit > 0) {
      return Number(explicit.toFixed(CJE_MANUAL_RATE_DECIMALS));
    }
    return null;
  };

  const cjeGetRate = (fv) => {
    const isManual = fv?.exchangeRateType === Constants.ExchangeRateType.Manual;
    const rate = isManual
      ? cjeParseNumeric(fv?.exchangeRate ?? cjeManualRateInputRef.current)
      : cjeFCRateRef.current;
    return rate;
  };

  const cjeComputeManualRateFromAmounts = () => {
    const latest = formValuesRef.current;
    if (latest.exchangeRateType !== Constants.ExchangeRateType.Manual) return;
    if (!cjeHasForeignCode(latest)) return;
    const amountAbs = cjeAbsNumeric(latest.amount);
    const fcAbs = cjeAbsNumeric(latest.foreignCurrencyAmount);
    if (isNaN(amountAbs) || amountAbs <= 0 || isNaN(fcAbs) || fcAbs <= 0) return;
    const newRate = (amountAbs / fcAbs).toFixed(CJE_MANUAL_RATE_DECIMALS);
    setCjeManualRateInput(newRate);
    cjeLastManualRateRef.current = newRate;
    setFormValues((prev) => ({ ...prev, exchangeRate: newRate }));
  };

  const cjeScheduleRateCalc = () => {
    if (cjeRateCalcTimeoutRef.current) clearTimeout(cjeRateCalcTimeoutRef.current);
    cjeRateCalcTimeoutRef.current = setTimeout(() => {
      cjeRateCalcTimeoutRef.current = null;
      cjeComputeManualRateFromAmounts();
    }, CJE_AMOUNT_SYNC_DEBOUNCE_MS);
  };

  const cjeComputeAmountSideEffect = (value) => {
    const latest = formValuesRef.current;
    const isManual = latest.exchangeRateType === Constants.ExchangeRateType.Manual;
    if (value === '' || value == null) return;
    const amountAbs = cjeAbsNumeric(value);
    if (isNaN(amountAbs) || amountAbs <= 0) return;
    if (!cjeHasForeignCode(latest)) return;

    // The foreign amount mirrors the shekel amount's sign.
    const amountSign = cjeSignOf(value);

    if (isManual) {
      const fcAbs = cjeAbsNumeric(latest.foreignCurrencyAmount);
      const fcSet = !isNaN(fcAbs) && fcAbs > 0;
      if (fcSet) return;
      const manualRate = cjeParseNumeric(cjeManualRateInputRef.current);
      if (!isNaN(manualRate) && manualRate > 0) {
        const derived = (amountSign * (amountAbs / manualRate)).toFixed(
          CJE_FC_AMOUNT_DECIMALS
        );
        setFormValues((prev) => ({ ...prev, foreignCurrencyAmount: derived }));
      }
      return;
    }

    const rate = cjeFCRateRef.current;
    if (latest.documentDate && rate != null && rate > 0) {
      const derived = (amountSign * (amountAbs / rate)).toFixed(
        CJE_FC_AMOUNT_DECIMALS
      );
      setFormValues((prev) => ({ ...prev, foreignCurrencyAmount: derived }));
    }
  };

  const cjeComputeFcSideEffect = (value) => {
    const latest = formValuesRef.current;
    const isManual = latest.exchangeRateType === Constants.ExchangeRateType.Manual;
    if (value === '' || value == null) return;
    const fcAbs = cjeAbsNumeric(value);
    if (isNaN(fcAbs) || fcAbs <= 0) return;
    if (!cjeHasForeignCode(latest)) return;

    // Deriving the shekel amount must not flip the debit/credit direction, so it keeps
    // the sign it already has and only falls back to the foreign amount's sign when it
    // is still empty (foreign-bank pre-fill, where the foreign amount is the anchor).
    const hasAmount = !isNaN(cjeParseNumeric(latest.amount));
    const amountSign = hasAmount ? cjeSignOf(latest.amount) : cjeSignOf(value);

    if (isManual) {
      const amountAbs = cjeAbsNumeric(latest.amount);
      const amountSet = !isNaN(amountAbs) && amountAbs > 0;
      if (amountSet) return;
      const manualRate = cjeParseNumeric(cjeManualRateInputRef.current);
      if (!isNaN(manualRate) && manualRate > 0) {
        const derived = Number((amountSign * fcAbs * manualRate).toFixed(2));
        setFormValues((prev) => ({ ...prev, amount: derived }));
      }
      return;
    }

    const rate = cjeFCRateRef.current;
    if (latest.documentDate && rate != null && rate > 0) {
      const derived = Number((amountSign * fcAbs * rate).toFixed(2));
      setFormValues((prev) => ({ ...prev, amount: derived }));
    }
  };

  const cjeFlushAmountSync = (value) => {
    if (cjeAmountSyncTimeoutRef.current) {
      clearTimeout(cjeAmountSyncTimeoutRef.current);
      cjeAmountSyncTimeoutRef.current = null;
    }
    if (cjeRateCalcTimeoutRef.current) {
      clearTimeout(cjeRateCalcTimeoutRef.current);
      cjeRateCalcTimeoutRef.current = null;
    }
    if (value !== undefined) cjeComputeAmountSideEffect(value);
    cjeComputeManualRateFromAmounts();
  };

  const cjeFlushFcSync = (value) => {
    if (cjeFcSyncTimeoutRef.current) {
      clearTimeout(cjeFcSyncTimeoutRef.current);
      cjeFcSyncTimeoutRef.current = null;
    }
    if (cjeRateCalcTimeoutRef.current) {
      clearTimeout(cjeRateCalcTimeoutRef.current);
      cjeRateCalcTimeoutRef.current = null;
    }
    if (value !== undefined) cjeComputeFcSideEffect(value);
    cjeComputeManualRateFromAmounts();
  };

  const cjeResetCurrencyInputs = () => {
    setCjeAmountInput('');
    setCjeCurrencyAmountInput('');
    setCjeManualRateInput('');
    setCjeFCRate(1);
    setCjeIsLoadingFCRate(false);
    cjeLastManualRateRef.current = null;
    cjeUserClearedManualRateRef.current = false;
  };

  // When the dialog opens, pre-fill the currency code from the bank transaction
  // (back-compat: the old code implicitly used selectedTBank.foreignCurrencyCode).
  // Default rate type to Representative so the toggle is active even before a code
  // is chosen and the fetch effect can run as soon as code + date are set.
  useEffect(() => {
    if (!isCreateDialogOpen) return;
    const code = selectedTBank?.foreignCurrencyCode;
    setFormValues((prev) => {
      const patch = {};
      if (
        code != null &&
        code !== '' &&
        (prev.foreignCurrencyCode == null || prev.foreignCurrencyCode === '')
      ) {
        patch.foreignCurrencyCode = code;
      }
      if (prev.exchangeRateType == null || prev.exchangeRateType === '') {
        patch.exchangeRateType = Constants.ExchangeRateType.Representative;
      }
      if (Object.keys(patch).length === 0) return prev;
      return { ...prev, ...patch };
    });
    // Intentionally only runs when the dialog opens; we don't want to overwrite the
    // user's later choices.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCreateDialogOpen]);

  // Fetch the representative ILS rate whenever the relevant inputs change while the
  // dialog is open. Mirrors EditModal's fetchRate effect (Representative-mode only).
  useEffect(() => {
    if (!isCreateDialogOpen) return;
    let cancelled = false;
    const hasCode =
      formValues.foreignCurrencyCode != null && formValues.foreignCurrencyCode !== '';
    const hasDate = !!formValues.documentDate;
    const isManual = formValues.exchangeRateType === Constants.ExchangeRateType.Manual;

    async function fetchRate() {
      setCjeIsLoadingFCRate(true);
      try {
        const rate = await ForeignCurrencyService.GetIlsRateForDate(
          formValues.foreignCurrencyCode,
          formValues.documentDate,
          token
        );
        if (!cancelled) {
          setCjeFCRate(rate);
          // Representative mode: recalculate counterpart from whichever amount is set.
          // FC-only (bank-match pre-fill) -> derive NIS; NIS-only -> derive FC.
          if (!isManual) {
            setFormValues((prev) => {
              // Magnitudes only: a negative difference must still convert, and the
              // shekel amount keeps its original sign so the entry direction is intact.
              const fcAbs = cjeAbsNumeric(prev.foreignCurrencyAmount);
              const amtAbs = cjeAbsNumeric(prev.amount);
              const patch = {};
              if (!isNaN(fcAbs) && fcAbs > 0 && (isNaN(amtAbs) || amtAbs <= 0)) {
                patch.amount = Number(
                  (cjeSignOf(prev.foreignCurrencyAmount) * fcAbs * rate).toFixed(2)
                );
              } else if (!isNaN(amtAbs) && amtAbs > 0) {
                patch.foreignCurrencyAmount = (
                  cjeSignOf(prev.amount) * (amtAbs / rate)
                ).toFixed(CJE_FC_AMOUNT_DECIMALS);
              }
              if (Object.keys(patch).length === 0) return prev;
              return { ...prev, ...patch };
            });
          }
        }
      } catch (err) {
        console.error(err);
        if (!cancelled) toast.error(t('CurrencyRateFetchError'));
      } finally {
        if (!cancelled) setCjeIsLoadingFCRate(false);
      }
    }

    if (hasCode && hasDate && !isManual) {
      fetchRate();
    } else {
      if (!hasCode) setCjeFCRate(1);
      setCjeIsLoadingFCRate(false);
    }

    return () => {
      cancelled = true;
    };
  }, [
    isCreateDialogOpen,
    formValues.foreignCurrencyCode,
    formValues.documentDate,
    formValues.exchangeRateType,
    token,
  ]);

  // Sync local typing buffers when formValues change externally (dialog open, pre-fill, fetch).
  useEffect(() => {
    if (!isCreateDialogOpen) return;
    setCjeAmountInput(
      formValues.amount !== undefined && formValues.amount !== null && formValues.amount !== ''
        ? String(formValues.amount)
        : ''
    );
  }, [isCreateDialogOpen, formValues.amount]);

  useEffect(() => {
    if (!isCreateDialogOpen) return;
    setCjeCurrencyAmountInput(
      formValues.foreignCurrencyAmount !== undefined &&
      formValues.foreignCurrencyAmount !== null &&
      formValues.foreignCurrencyAmount !== ''
        ? String(formValues.foreignCurrencyAmount)
        : ''
    );
  }, [isCreateDialogOpen, formValues.foreignCurrencyAmount]);

  useEffect(() => {
    if (!isCreateDialogOpen) return;
    if (formValues.exchangeRateType !== Constants.ExchangeRateType.Manual) {
      setCjeManualRateInput('');
      cjeUserClearedManualRateRef.current = false;
      return;
    }
    if (cjeUserClearedManualRateRef.current) {
      setCjeManualRateInput('');
      return;
    }
    const rate =
      formValues.exchangeRate != null && formValues.exchangeRate !== ''
        ? String(Number(cjeParseNumeric(formValues.exchangeRate)))
        : (cjeLastManualRateRef.current ?? '');
    setCjeManualRateInput(rate);
    if (rate) cjeLastManualRateRef.current = rate;
  }, [
    isCreateDialogOpen,
    formValues.exchangeRateType,
    formValues.exchangeRate,
  ]);

  // Pre-fill the create-JE dialog with the selected balance. For foreign banks the
  // balance is in FC (same unit the match service uses); for ILS banks it is NIS.
  const applyCjeBalanceSum = (sum) => {
    const sumValue = parseFloat(sum.toFixed(2));
    if (isCjeForeignBank()) {
      // Keep the sign: it mirrors onto the derived shekel amount, which in turn picks
      // the debit/credit side of the entry.
      const fcStr = sumValue.toFixed(CJE_FC_AMOUNT_DECIMALS);
      setCjeCurrencyAmountInput(fcStr);
      setCjeAmountInput('');
      setFormValues((prev) => ({
        ...prev,
        foreignCurrencyCode: selectedTBank.foreignCurrencyCode,
        exchangeRateType:
          prev.exchangeRateType ?? Constants.ExchangeRateType.Representative,
        foreignCurrencyAmount: fcStr,
        amount: '',
      }));
    } else {
      setCjeAmountInput(String(sumValue));
      setCjeCurrencyAmountInput('');
      setFormValues((prev) => ({
        ...prev,
        amount: sumValue,
      }));
    }
  };

  const handleCjeAmountChange = (value) => {
    if (formValues.exchangeRateType === Constants.ExchangeRateType.Manual) {
      cjeUserClearedManualRateRef.current = false;
    }
    setCjeAmountInput(value);
    setFormValues((prev) => ({ ...prev, amount: value }));
    cjeScheduleRateCalc();
    if (cjeAmountSyncTimeoutRef.current) clearTimeout(cjeAmountSyncTimeoutRef.current);
    cjeAmountSyncTimeoutRef.current = setTimeout(() => {
      cjeComputeAmountSideEffect(value);
    }, CJE_AMOUNT_SYNC_DEBOUNCE_MS);
  };

  const handleCjeCurrencyCodeChange = (e) => {
    const v = e.target.value;
    if (v === '') {
      setFormValues((prev) => ({
        ...prev,
        foreignCurrencyCode: null,
        foreignCurrencyAmount: null,
        exchangeRateType: null,
        exchangeRate: null,
        amount: prev.amount,
      }));
      cjeResetCurrencyInputs();
    } else {
      setFormValues((prev) => ({
        ...prev,
        foreignCurrencyCode: Number(v),
        exchangeRateType:
          prev.exchangeRateType ?? Constants.ExchangeRateType.Representative,
      }));
    }
  };

  const handleCjeSwitchToRepresentative = () => {
    const r = cjeParseNumeric(cjeManualRateInput);
    if (cjeManualRateInput !== '' && !isNaN(r) && r > 0) {
      cjeLastManualRateRef.current = cjeManualRateInput;
    }
    setCjeManualRateInput('');
    setFormValues((prev) => ({
      ...prev,
      exchangeRateType: Constants.ExchangeRateType.Representative,
      exchangeRate: null,
    }));
  };

  const handleCjeSwitchToManual = () => {
    let restored =
      formValues.exchangeRate != null && formValues.exchangeRate !== ''
        ? String(Number(cjeParseNumeric(formValues.exchangeRate)))
        : (cjeLastManualRateRef.current ?? '');
    if (!restored) {
      const amount = cjeAbsNumeric(formValues.amount);
      const fc = cjeAbsNumeric(formValues.foreignCurrencyAmount);
      if (amount > 0 && fc > 0 && !isNaN(amount) && !isNaN(fc)) {
        restored = (amount / fc).toFixed(CJE_MANUAL_RATE_DECIMALS);
      }
    }
    cjeUserClearedManualRateRef.current = false;
    setCjeManualRateInput(restored);
    setFormValues((prev) => ({
      ...prev,
      exchangeRateType: Constants.ExchangeRateType.Manual,
      exchangeRate: restored || null,
    }));
  };

  const handleCjeManualRateChange = (rawValue) => {
    // An exchange rate is a magnitude - the direction of the entry lives on the amounts,
    // so a typed minus sign is dropped rather than producing a negative rate.
    const value =
      rawValue === '' || rawValue == null
        ? rawValue
        : String(rawValue).replace(/-/g, '');
    cjeUserClearedManualRateRef.current = value === '' || value == null;
    setCjeManualRateInput(value);
    const rateNum = cjeParseNumeric(value);
    if (value !== '' && !isNaN(rateNum) && rateNum > 0) {
      cjeLastManualRateRef.current = value;
    }
    setFormValues((prev) => ({
      ...prev,
      exchangeRate: value === '' ? null : value,
    }));
    if (value === '' || isNaN(rateNum) || rateNum <= 0) return;
    if (!cjeHasForeignCode(formValuesRef.current)) {
      toast.info(t('ToCalculateAmountWithForeignCurrencyChooseDateAndCurrencyCode'));
      return;
    }
    const latest = formValuesRef.current;
    const amountAbs = cjeAbsNumeric(latest.amount);
    const fcAbs = cjeAbsNumeric(latest.foreignCurrencyAmount);
    const amountValid = !isNaN(amountAbs) && amountAbs > 0;
    const fcValid = !isNaN(fcAbs) && fcAbs > 0;
    if (amountValid) {
      const derived = (cjeSignOf(latest.amount) * (amountAbs / rateNum)).toFixed(
        CJE_FC_AMOUNT_DECIMALS
      );
      setFormValues((prev) => ({ ...prev, foreignCurrencyAmount: derived }));
    } else if (fcValid) {
      const derived = Number(
        (cjeSignOf(latest.foreignCurrencyAmount) * fcAbs * rateNum).toFixed(2)
      );
      setFormValues((prev) => ({ ...prev, amount: derived }));
    }
  };

  const handleCjeForeignAmountChange = (value) => {
    if (formValues.exchangeRateType === Constants.ExchangeRateType.Manual) {
      cjeUserClearedManualRateRef.current = false;
    }
    if (!cjeHasForeignCode(formValuesRef.current)) {
      toast.error(t('PleaseSelectCurrencyCodeFirst'));
      return;
    }
    setCjeCurrencyAmountInput(value);
    setFormValues((prev) => ({ ...prev, foreignCurrencyAmount: value }));
    cjeScheduleRateCalc();
    if (cjeFcSyncTimeoutRef.current) clearTimeout(cjeFcSyncTimeoutRef.current);
    cjeFcSyncTimeoutRef.current = setTimeout(() => {
      cjeComputeFcSideEffect(value);
    }, CJE_AMOUNT_SYNC_DEBOUNCE_MS);
  };

  const handleReportingMonthDateChange = (event) => {
    const value = event.target.value; // This will be in YYYY-MM format
    const [year, month] = value.split("-"); // Split into year and month

    // Reformat to MM/YYYY
    const formattedDate = `${month}/${year}`;
    setReportingMonthDate(formattedDate); // Update state with MM/YYYY format
  };
  const handleInputChange = (event) => {
    const { name, value } = event.target;

    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const handleSelectChange = (field, newValue) => {
    if (newValue && (field === 'creditAccount' || field === 'debitAccount' || field === 'accountCard')) {
      if (newValue?.value1 === 'AddItem') {
        handleNoOptionCreditDebitClick('', field);
        return;
      }

      if (newValue?.cardId) {
        setFormValues((prev) => ({
          ...prev,
          [field]: newValue.cardId,
        }));
      } else {
        setFormValues((prev) => ({
          ...prev,
          [field]: newValue,
        }));
      }
      return;
    }
    if (field === 'sortCodeId') {

      if (!newValue || !sortCodeIdOptions.some((option) => option.value === newValue)) {
        // Set default values for the empty state

        setFormValues((prev) => ({
          ...prev,
          vat: 100, // Default VAT
          [field]: '',
        }));
        return; // Exit early since there's no valid sortCodeId
      }

      const name = sortCodeIdOptions.find(
        (option) => option.value === newValue
      )?.label || ''

      // Extract the name without the parentheses
      const nameWithoutParentheses = name.replace(/\s*\(.*?\)\s*/, '').trim();

      // Check for a number within parentheses
      const match = name.match(/\((\d+)%?/);
      let customVat = match ? parseInt(match[1], 10) : null;


      const sortCode = sortCodeIdOptions.filter(sc => sc.value === newValue)[0];

      // Determine the VAT based on the name without parentheses
      const newVat = sortCode?.vat ?? 100;
      setFormValues((prev) => ({
        ...prev,
        vat: newVat,
        [field]: newValue,
      }));
      return;
    }

    setFormValues((prev) => ({
      ...prev,
      [field]: newValue,
    }));
  };



  const sortCodeOptions = [
    { label: "Sort Code 1", value: 1 },
    { label: "Sort Code 2", value: 2 },
    // more options
  ];

  const CustomPalCode = (props) => {
    return (
      <components.Option {...props}>
        <div style={{ textAlign: "center", width: "100%" }}>{props.label}</div>
      </components.Option>
    );
  };

  // Edit Modal Vars
  const [editedItem, setEditedItem] = useState({});
  const [editedPopupItem, setEditedPopupItem] = useState(true);
  const [fade, setFade] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(-1);
  const [transactions, setTransactions] = useState(null);
  const [dataForPdf, setDataForPdf] = useState(null);
  const [sortedDataForPdf, setSortedDataForPdf] = useState(null);
  const [transactionDetailsDictionary, setTransactionDetailsDictionary] =
    useState({});
  const [itemToDelete, setItemToDelete] = useState({});
  const [editedJournalItem, setEditedJournalItem] = useState(true);
  const [paymentModal, setPaymentModal] = useState(false);
  const [openInvoiceCreatorModal, setOpenInvoiceCreatorModal] = useState(false);
  const [showType, setShowType] = useState({ type: 'all', index: -1 });

  const [addEditableItem, setAddEditableItem] = useState({
    checks: [],
    creditCards: [],
    cash: [],
    bankTransactions: [],
    offsets: [],
    date: new Date(),
  });
  const [responseData, setResponseData] = useState({});
  const [accountCardEditDownloadOptions, setAccountCardEditDownloadOptions] =
    useState([]);
  const [originalAccountCardId, setOriginalAccountCardId] = useState("");
  const [editedAddAccountCard, setEditedAddAccountCard] = useState(false);
  const [isClosedReportingMonth, setIsClosedReportingMonth] = useState(false);
  const [accountCardOptions, setAccountCardOptions] = useState([]);
  const [accountCardOptionsForBank, setAccountCardOptionsForBank] = useState([]);
  const [editModalsAccountCardOptions, setEditModalsAccountCardOptions] =
    useState([]);

  const [sortCodeIdOptions, setSortCodeIdOptions] = useState([]);
  const [sortCodeIdOptionsForEditModals, setSortCodeIdOptionsForEditModals] =
    useState([]);

  const [statusCheck, setStatusCheck] = useState(false);
  const [creditAccountOptions, setCreditAccountOptions] = useState([]);
  const [debitAccountOptions, setDebitAccountOptions] = useState([]);
  const [editingRow, setEditingRow] = useState(null);
  const [palCodeName, setPalCodeName] = useState(null);
  const [accountCardName, setAccountCardName] = useState(null);
  const [accountCardId, setAccountCardId] = useState(null);
  const [finalBalance, setFinalBalance] = useState("");
  const [isMonthly, setIsMonthly] = useState(false);
  const [firstRowDetails, setFirstRowDetails] = useState(null);
  const [palCodeDetails, setPalCodeDetails] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [formattedPalCodeOptions, setFormattedPalCodeOptions] = useState([]);
  const [journalEntriesList, setJournalEntriesList] = useState([]);
  const [isJournalEntriesListOpen, setIsJournalEntriesListOpen] =
    useState(false);
  const [expandedMatchedRows, setExpandedMatchedRows] = useState({});


  // Handle expand/collapse
  const handleMatchedExpandClick = (id) => {
    setExpandedMatchedRows((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const CustomInput1 = React.forwardRef(({ value, onClick }, ref) => (
    <button className="document-custom-input1" onClick={onClick} ref={ref}>
      {value}
    </button>
  ));

  const handleAccountEdit = (option) => {
    setShowAccountCardInputsEdit(true);
    setAccountCodeName(option.name);
    setAccountCodeId(option.cardId);
    setCompanyId(option.caseId);
    const account = accountCardOptions.find(
      (account) => account.cardId === option.cardId
    );
    setPalCode(account ? account.palCode : "");
    setOldSelectedAccountCardItem({
      cardId: option.cardId,
      caseId: option.caseId,
      accountCaseId: option.accountCaseId,
      name: option.name,
      palCode: "",
      client: null,
    });
    setAddNewAccountCardDocument(true);
  };

  const CustomInput2 = React.forwardRef(({ value, onClick }, ref) => (
    <button className="edit-custom-input" onClick={onClick} ref={ref}>
      {value}
    </button>
  ));

  const handleCancel = () => {
    setEditingRow(null);
    setEditedItem({});
    setEditedAddAccountCard(false);
  };
  const handleEditDeleteClick = (itemId) => {
    setEditedPopupItem(false);
    setEditedItem({});
    setPaymentModal(false);
    setAddEditableItem({
      checks: [],
      creditCards: [],
      cash: [],
      bankTransactions: [],
      offsets: [],
      date: new Date()
    });
    handleDeleteClick();
  };
  const handleDeleteClick = () => {
    setIsModalVisible(true);
  };

  const [bankTranToDelete, setBankTranToDelete] = useState(null);
  const handleDeleteClickBank = (transaction) => {
    setBankTranToDelete(transaction);
    setIsModalVisible(true);
  };

  const handleDoneClick = async (itemId, type) => {

    setLoading(true);
    try {
      const response =
        await ClientDocumentCountService.removeDocumentByTypeAndId(
          client.caseId,
          client.accountantId,
          type,
          itemId, token);
      if (response.ok) {
        // await fetchDocumentsNotification(client, token);
        toast.success(t("DocumentProcessed"), {
          position: direction === 'rtl' ? 'top-left' : 'top-right',
        });
      } else {
        const errorText = await response.text();
        toast.error(t("DocumentNotProcessed", { errorText }));
      }
    } catch (error) {
      // toast.error(t('DocumentNotProcessed', { errorText: error.message }));
    }
    setLoading(false);
  };

  const handleNotDoneClick = async (itemId, type) => {


    setLoading(true);
    try {
      const response = await ClientDocumentCountService.addDocumentByTypeAndId(
        client.caseId,
        client.accountantId,
        type,
        itemId,
        token
      );
      if (response.ok) {
        // await fetchDocumentsNotification(client, token)
        toast.success(t("DocumentProcessed"), {
          position: direction === 'rtl' ? 'top-left' : 'top-right',
        });
      } else {
        const errorText = await response.text();
        toast.error(t("DocumentNotProcessed", { errorText }));
      }
    } catch (error) {
      // toast.error(t('DocumentNotProcessed', { errorText: error.message }));
    }
    setLoading(false);
  };

  const handleUpdate = async (itemId) => {
    setLoading(true);
    let finalResponse = null;
    setEditedPopupItem(false);
    // Prefer the explicit payload that EditModal built via getItemToSave (which includes
    // the latest computed exchangeRate and the correct exchangeRateType). Fall back to
    // editedItem if the caller didn't pass one. This is what allows Manual exchange-rate
    // information to actually be persisted - using editedItem here loses values that the
    // debounced rate calculation hasn't yet written back into state.
    const dataToSave = (itemId && typeof itemId === 'object' && !Array.isArray(itemId))
      ? { ...itemId }
      : { ...editedItem };
    const documentUrl = dataToSave.documentUrl;
    try {
      dataToSave.accountCaseId = client.accountCaseId;
      delete dataToSave.documentUrl; // Ensure the document URL is not part of the update if present


      if (dataToSave.docType === "Incomes") {
        finalResponse = await DocumentService.UpdateDocument(
          "Incomes",
          token,
          dataToSave
        );
      }
      if (dataToSave.docType === "Expenses") {
        // If the income update fails, attempt the expense update
        finalResponse = await DocumentService.UpdateDocument(
          "Expenses",
          token,
          dataToSave
        );
      }
      if (dataToSave.docType === "JournalEntries") {
        finalResponse = await DocumentService.UpdateDocument(
          "JournalEntries",
          token,
          dataToSave
        );
      }
      setTypeToPassToChoose(dataToSave.docType);


      if (finalResponse && finalResponse.ok) {
        // Reassign documentUrl back to editedItem after successful update
        editedItem.documentUrl = documentUrl;

        if (editedItem.status === "done") {

          await handleDoneClick(editedItem.id, editedItem.docType);
          // handleSortChange('id', 'newest', 'descending');
        } else if (editedItem.status === "notDone") {
          await handleNotDoneClick(editedItem.id, editedItem.docType);
        }

        if (editedAddAccountCard) {
          await handleAccountCardSave(
            editedItem.accountCodeId,
            editedItem.accountCodeName,
            editedItem.accountCaseId
          );
          await fetchEnums(user, token, client);
        }

        setWholeDataTransactions((prevData) => {
          const newData = { ...prevData };

          // Check if editedItem.id exists in the previous data
          if (newData[editedItem.id]) {
            // Delete the existing entry
            delete newData[editedItem.id];
          }

          // Return the updated object without the removed entry
          return newData;
        });

        setWholeDataTransactions((prev) => {
          const updated = { ...prev };
          delete updated[editedItem.id];
          return updated;
        });
        toast.success(t("documentUpdateSuccess"));
      } else {
        // Reassign documentUrl back to editedItem even on error to maintain state
        editedItem.documentUrl = documentUrl;

        const errorText = await finalResponse.text();
        toast.error(t("documentUpdateError") + ": " + errorText);
      }
    } catch (error) {
      // This block catches unexpected errors such as network issues, not HTTP errors which are handled above
      console.error("Unexpected error occurred: ", error);
      toast.error(t("documentUpdateError"));
      // Reassign documentUrl back to editedItem on catch error to maintain state
      editedItem.documentUrl = documentUrl;
    }
    setEditedItem({});
    setEditingRow(null);
    setEditedAddAccountCard(false);

    await fetchEnums(user, token, client);
    await FetchData();
    setLoading(false); // Always stop loading at the end of the operation
  };

  const handleEditAddAccountChange = (selectedOption, field) => {
    if (field === "AccountCodeId") {
      type === "Incomes"
        ? setEditedItem({
          ...editedItem,
          accountCodeId: selectedOption,
          debitAccount: selectedOption,
        })
        : setEditedItem({
          ...editedItem,
          accountCodeId: selectedOption,
          creditAccount: selectedOption,
        });
    } else if (field === "AccountCodeName") {
      setEditedItem({ ...editedItem, accountCodeName: selectedOption });
    } else {
      setEditedItem({ ...editedItem, accountCaseId: selectedOption });
    }
  };

  const handleCloseEditAddNewAccountCardDocument = () => {
    setEditedItem({ ...editedItem, accountCodeName: "", accountCodeId: "" });
    setEditedAddAccountCard(false);
  };

    const handleRadioChange = async (e, options = {}) => {
        if (e.target.value?.toString() === 'done' && !options?.validationAlreadyDone) {

            const isValid = await validateDocumentBeforeProcessing(editedItem, t, client, options?.forceProcess === true);
            if (!isValid) return;
        }

        if (e.target.value?.toString() === 'done') {
            setStatusCheck(true);
        }
        else if (e.target.value?.toString() === 'notDone') {
            setStatusCheck(false);
        }

        setEditedItem({ ...editedItem, status: e.target.value });
    };


  const handleRadioPAChange = async (e) => {
    if (e.target.value?.toString() === 'done') {
      const isValid = await validatePaymentAcceptanceItems(addEditableItem, t, client);
      if (!isValid) return;

      setStatusCheck(true);
    }
    else if (e.target.value?.toString() === 'notDone') {
      setStatusCheck(false);
    }
    setAddEditableItem({ ...addEditableItem, ["status"]: e.target.value });
  };
  const handleAccountCardSave = async (
    AccountCodeId,
    AccountCodeName,
    AccountCaseId
  ) => {
    const response2 = await EnumsService.AddAccountCard(
      client.caseId,
      AccountCodeId,
      AccountCodeName,
      AccountCaseId,
      token
    );
    if (!response2.ok) {
      throw new Error(`HTTP error! status: ${response2.status}`);
    }
  };

  const updateAccountFields = (newValue, accountType) => {


    const isIncomesDebit = editedItem.docType === 'Incomes' && accountType === 'debitAccount';
    const isExpensesCredit = editedItem.docType === 'Expenses' && accountType === 'creditAccount';

    const updatedFields = {
      accountCodeId: isIncomesDebit || isExpensesCredit ? (newValue ? newValue.cardId : '') : '',
      accountCodeName: isIncomesDebit || isExpensesCredit ? (newValue ? newValue.name : '') : '',
      accountCaseId: isIncomesDebit || isExpensesCredit ? (newValue ? newValue.accountCaseId : '') : '',
    };

    // Update the edited item with the new fields
    setEditedItem((prev) => ({
      ...prev,
      [accountType]: newValue ? newValue.cardId : '',
      ...(isIncomesDebit || isExpensesCredit ? updatedFields : {}),
    }));
  };


  const [saleEquipment, setSaleEquipment] = useState(false);
  const [dateForAsset, setDateForAsset] = useState(new Date().toISOString());
  const [typeToPassToChoose, setTypeToPassToChoose] = useState('');
  const [clickedAsset, setClickedAsset] = useState(null);

  const [showAssetFoundDialog, setShowAssetFoundDialog] = useState(false);
  const [foundAsset, setFoundAsset] = useState(null);
  const fetchEnumsNoParams = async () => {
    await fetchEnums(user, token, client);
  }

  const isPurchaseOfEquipment = (item) => {
    if (!item) return false; // If the item is not found, allow processing
    const sortCode = sortCodeIdOptions.find((option) => option.sortCodeId === item.sortCodeId);
    if (!sortCode) return false; // If the sort code is not found, allow processing
    return Boolean(Constants.depreciationAssetSortCodeType[sortCode.sortCodeVatType]);
  };


  const isDepreciationDocument = (editedItem, sortCodeId) => {

    const item = editedItem;
    const itemId = editedItem.id;
    if (!item) return false; // If the item is not found, allow processing
    setItemForAssets(item);
    setDateForAsset(item.documentDate);


    const sortCode = sortCodeIdOptions.find((option) => option.value === sortCodeId);
    if (!sortCode) return false; // If the sort code is not found, allow processing

    const isItemUsedInAssets = assets.some(
      (asset) => asset.expenseId === itemId || asset.journalEntryId === itemId
    );


    const name = sortCode.sortCodeName?.trim().replace(/\s+/g, ' ') || "";
    const saleEquipmentRegex = /(מכירה|מכירת).*ציוד|ציוד.*(מכירה|מכירת)/;
    if (sortCode.sortCodeId === caseSystemSettings.fixedAssetSaleSortCode || saleEquipmentRegex.test(name)) {

      setSaleEquipment(true);
      return true;
    }


    setSaleEquipment(false);
    return Boolean(Constants.depreciationAssetSortCodeType[sortCode.sortCodeVatType]);
  };
  const [showChooseAsset, setShowChooseAsset] = useState(false);
  const [itemToAddToAsset, setItemToAddToAsset] = useState('');
  const [itemForAssets, setItemForAssets] = useState({});

  const handleAssetClicked = (asset, item) => {
    setItemToAddToAsset(item.id);
    setItemForAssets(item)
    setClickedAsset(asset);
    setShowChooseAsset(true);
  }

  const handleAssetClose = () => {
    setShowChooseAsset(false);
    setClickedAsset(null);
  }

  const handleChange = (field, value) => {

    const updatedValue = value;

    if (field === 'sortCodeId') {
      let depreciation = false;

      if (isDepreciationDocument(editedItem, value)) {
        depreciation = true;
        setItemToAddToAsset(editedItem.id);
        setShowChooseAsset(true);
      }

      if (isPurchaseOfEquipment(editedItem) && !depreciation) {
        if (assets) {
          const assetFound = assets.find(
            (asset) => asset.expenseId === editedItem.id || asset.journalEntryId === editedItem.id
          );
          if (assetFound) {
            setFoundAsset(assetFound);
            setShowAssetFoundDialog(true);
          }
        }
      }

      if (!value || !sortCodeIdOptions.some((option) => option.value === value)) {


        // Set default values for the empty state
        setEditedItem({
          ...editedItem,
          vat: 100, // Default VAT
          [field]: '',
        });
        return; // Exit early since there's no valid sortCodeId
      }

      const name = sortCodeIdOptions.find(
        (option) => option.sortCodeId === value
      )?.sortCodeName || ''

      // Extract the name without the parentheses
      const nameWithoutParentheses = name.replace(/\s*\(.*?\)\s*/, '').trim();

      // Check for a number within parentheses
      const match = name.match(/\((\d+)%?/);
      let customVat = match ? parseInt(match[1], 10) : null;


      const sortCode = sortCodeIdOptions.filter(sc => sc.value === updatedValue)[0];

      // Determine the VAT based on the name without parentheses
      const newVat = sortCode?.vat ?? 100;

      const accountCard = accountCardOptions.find(
        (item) => item.cardId === (type === 'Incomes' ? sortCode?.debitAccount : sortCode?.creditAccount)
      );
      setEditedItem({
        ...editedItem,
        vat: newVat,
        [field]: updatedValue,
        // [type === 'Incomes' ? 'debitAccount' : 'creditAccount']:
        //   editedItem[type === 'Incomes' ? 'debitAccount' : 'creditAccount']
        //     ? (accountCard ? accountCard.cardId : editedItem[type === 'Incomes' ? 'debitAccount' : 'creditAccount'])
        //     : editedItem[type === 'Incomes' ? 'debitAccount' : 'creditAccount'],
        accountCodeName: accountCard ? accountCard.name : editedItem.accountCodeName,
        accountCodeId: accountCard ? accountCard.cardId : editedItem.accountCodeId,
        accountCaseId: accountCard ? accountCard.accountCaseId : editedItem.accountCaseId,
      });

    }
    else if (field === 'creditAccount' || field === 'debitAccount') {

      // Use the helper function to update account fields for credit or debit account
      const newValue = accountCardOptions.find(option => option.cardId === updatedValue) || null;
      updateAccountFields(newValue, field);
    }
    else {
      // For fields other than sortCodeId, just update the edited item
      setEditedItem({
        ...editedItem,
        [field]: updatedValue,
      });
    }
  };

  const [reportingMonthDate, setReportingMonthDate] = useState(new Date());

  const handleVatRadioChange = (e) => {
    setEditedItem({ ...editedItem, ["vat"]: parseFloat(e.target.value) });
  };

  const handleDateChange = (e, field) => {
    setEditedItem({ ...editedItem, [field]: e });
  };

  const getAccountCardName = (accountId) => {
    const accountCard = formattedAccountCardOptions.find(
      (option) => option.cardId === accountId
    );
    return accountCard ? accountCard.name : "--"; // Fallback to 'Unknown Account' if not found
  };
  const getSortCodeName = (sortCodeId) => {
    const sortCode = sortCodeIdOptions.find(
      (option) => option.value === sortCodeId
    );
    return sortCode ? sortCode.label : "--"; // Fallback to 'Unknown Account' if not found
  };
  const handleReopenEdit = async (item, index) => {
    await fetchEnums(user, token, client);
    item.key = item.id;
    handleEdit(item);
  };

  const handleAccountChange = (selectedOption, field) => {
    if (field === "debitAccount" || field === "creditAccount") {
      const accountCardEditDownload = accountCardEditDownloadOptions.find(
        (option) => option.cardId === selectedOption.value
      );
      const name = accountCardEditDownload?.name;
      const accountCaseId = accountCardEditDownload?.accountCaseId;
      if (selectedOption.value < 0) {
        setOriginalAccountCardId(editedItem.cardId);
      }
      if (editedItem.docType === "Incomes") {
        setEditedItem({
          ...editedItem,
          accountCodeName: name,
          accountCodeId: selectedOption.value,
          debitAccount: selectedOption.value,
          accountCaseId: accountCaseId,
        });
      } else if (editedItem.docType === "Expenses") {
        setEditedItem({
          ...editedItem,
          accountCodeName: name,
          accountCodeId: selectedOption.value,
          creditAccount: selectedOption.value,
          accountCaseId: accountCaseId,
        });
      } else if (editedItem.docType === "JournalEntries") {
        setEditedItem({
          ...editedItem,
          [field]: selectedOption.value,
        });
      }
    } else if (field === "accountCodeName") {
      if (selectedOption.value1 === "AddItem") {
        setEditedAddAccountCard(true);
        setEditedItem({
          ...editedItem,
          accountCodeName: "",
          accountCodeId: "",
          accountCaseId: "",
        });
      } else {
        const accountCardEdit = accountCardEditDownloadOptions.find(
          (option) => option.cardId === selectedOption.value
        );
        const name = accountCardEdit?.name;
        const accountCaseId = accountCardEdit?.accountCaseId;
        const cardId = selectedOption.value;
        if (editedItem.docType === "Incomes") {
          setEditedItem({
            ...editedItem,
            accountCodeName: name,
            accountCodeId: cardId,
            debitAccount: cardId,
            accountCaseId: accountCaseId,
          });
        } else if (editedItem.docType === "Expenses") {
          setEditedItem({
            ...editedItem,
            accountCodeName: name,
            accountCodeId: cardId,
            creditAccount: cardId,
            accountCaseId: accountCaseId,
          });
        } else if (editedItem.docType === "JournalEntries") {
          setEditedItem({
            ...editedItem,
            accountCodeName: name,
            accountCodeId: cardId,
            accountCaseId: accountCaseId,
          });
        }
      }
    }
  };

  // Function to load the surrounding items (previous and next)
  const loadSurroundingItems = (rowIndex, type, transactionArray) => {
    return new Promise((resolve, reject) => {
      const updatedDictionary = { ...transactionDetailsDictionary };
      const promises = [];

      // Load the previous transaction if it exists and is not already loaded
      if (
        rowIndex > 0 &&
        !transactionDetailsDictionary[transactionArray[rowIndex - 1].id]
      ) {
        const previousPromise = DocumentService.GetDocumentById(
          transactionArray[rowIndex - 1].type,
          client.caseId,
          transactionArray[rowIndex - 1].id,
          token
        )
          .then((response) => (response.ok ? response.json() : null))
          .then((data) => {
            if (data) {
              data.docType = transactionArray[rowIndex - 1].type;
              updatedDictionary[transactionArray[rowIndex - 1].id] = data;
              setTransactionDetailsDictionary(updatedDictionary);
            }
          })
          .catch((error) => {
            console.error("Error fetching previous transaction:", error);
            reject(error);
          });

        promises.push(previousPromise);
      }

      // Load the next transaction if it exists and is not already loaded
      if (
        rowIndex < transactionArray.length - 1 &&
        !transactionDetailsDictionary[transactionArray[rowIndex + 1].id]
      ) {
        const nextPromise = DocumentService.GetDocumentById(
          transactionArray[rowIndex + 1].type,
          client.caseId,
          transactionArray[rowIndex + 1].id,
          token
        )
          .then((response) => (response.ok ? response.json() : null))
          .then((data) => {
            if (data) {
              data.docType = transactionArray[rowIndex + 1].type;
              updatedDictionary[transactionArray[rowIndex + 1].id] = data;
              setTransactionDetailsDictionary(updatedDictionary);
            }
          })
          .catch((error) => {
            console.error("Error fetching next transaction:", error);
            reject(error);
          });

        promises.push(nextPromise);
      }

      // Resolve when all promises are complete
      Promise.all(promises)
        .then(() => resolve())
        .catch((error) => reject(error));
    });
  };



  const handleFinalizeEntries = async () => {
    // Guard: never create entries whose edited amounts would invalidate the match.
    // The match reconciles on the FC amount (foreign) or the NIS amount (non-foreign).
    // For split-difference rows, matchAmount is set per row; if it is missing, fall
    // back to the entry amount so we don't compare against 0.
    const matchBroken = journalEntriesList.some((e) => {
      const cur =
        Math.abs(
          Number(e.bankIsForeign ? e.foreignCurrencyAmount : e.amount)
        ) || 0;
      const req =
        Math.abs(Number(e.matchAmount ?? e.amount)) || 0;
      return Math.abs(cur - req) >= 0.005;
    });
    if (matchBroken) {
      toast.error(t("EditedAmountsBreakMatch"));
      return;
    }

    setLoading(true);

    setIsJournalEntriesListOpen(false);
    try {
      const payload = journalEntriesList.map((entry) => {
        // A foreign-currency entry carries its own FC code/amount and the rate used
        // to derive the NIS (shekel) amount. `entry.amount` is always the NIS amount.
        const isEntryForeign =
          entry.foreignCurrencyCode != null && entry.foreignCurrencyCode !== "";
        const atNoon = (yyyyMmDd) => (yyyyMmDd ? yyyyMmDd + "T12:00:00" : null);
        return buildBankMatchJournalPayload({
          caseId: client.caseId,
          accountantId: client.accountantId,
          sortCodeId: entry.sortCodeId,
          reference: entry.reference,
          description: entry.description,
          amount: entry.amount,
          documentDate: entry.documentDate,
          reportingMonthDate: atNoon(entry.reportingMonthDate),
          registrationMonthDate: atNoon(entry.registrationMonthDate),
          creditAccount: entry.creditAccount,
          debitAccount: entry.debitAccount,
          vat: entry.vat,
          externalId: entry.externalId,
          foreignCurrencyCode: isEntryForeign ? entry.foreignCurrencyCode : null,
          foreignCurrencyAmount: entry.foreignCurrencyAmount,
          exchangeRate: isEntryForeign
            ? cjeResolveSavedRate(
                entry.amount,
                entry.foreignCurrencyAmount,
                entry.exchangeRate
              )
            : null,
        });
      });

      const response = await DocumentService.UploadDocumentPayloads(
        "JournalEntries",
        payload,
        token
      );

      if (response.ok) {
        // setShouldMatch(true); // Set flag to trigger handleMatch
        const data = await response.json(); // Parse the response as JSON
        const newJournalEntryIds = data.journalEntryIds; // Extract the new journal entry IDs
        toast.success(t("documentUploadSuccess"));

        const updatedSelectedInternalRows = [...selectedInternalRows, ...newJournalEntryIds];

        // Update the state for selectedInternalRows with new IDs
        setSelectedInternalRows(updatedSelectedInternalRows);


        const newJournalEntries = newJournalEntryIds.map((id) => ({
          id,
          type: "JournalEntries",
        }));

        // Update displayedRows by appending the new journal entries
        const updatedDisplayedRows = [...displayedRows, ...newJournalEntries];

        await handleMatch2(updatedSelectedInternalRows, selectedExternalRows, updatedDisplayedRows, externalRows)


        handleClearMatches();
        await FetchData();
      } else {
        const errorText = await response.text();
        toast.error(t("documentUploadError", { errorText }));
      }
    } catch (error) {
      toast.error(
        t("documentUploadError", { errorText: "Error uploading documents" })
      );
    }

    setLoading(false);
  };

  // Per-entry rate loading flags for the journal-entries preview dialog.
  const [journalEntryRateLoading, setJournalEntryRateLoading] = useState({});

  const updateJournalEntryAt = (index, patch) => {
    setJournalEntriesList((prev) =>
      prev.map((e, i) => (i === index ? { ...e, ...patch } : e))
    );
  };

  const getJournalEntryNisAnchor = (entry) =>
    Math.abs(Number(entry.matchAmount)) || Math.abs(Number(entry.amount)) || 0;

  // Optional FC on a shekel-bank entry: user picks a currency and we derive the FC
  // amount from the locked NIS match amount and the representative/manual rate.
  const handleJournalEntryCurrencyChange = async (index, code) => {
    const entry = journalEntriesList[index];
    if (!entry || entry.bankIsForeign) return;

    if (code == null || code === "") {
      updateJournalEntryAt(index, {
        foreignCurrencyCode: null,
        foreignCurrencyAmount: null,
        exchangeRate: null,
        exchangeRateType: null,
      });
      return;
    }

    const nisAmount = getJournalEntryNisAnchor(entry);
    updateJournalEntryAt(index, {
      foreignCurrencyCode: Number(code),
      exchangeRateType: Constants.ExchangeRateType.Representative,
      amount: nisAmount,
    });

    setJournalEntryRateLoading((prev) => ({ ...prev, [index]: true }));
    try {
      const rate = await ForeignCurrencyService.GetIlsRateForDate(
        Number(code),
        entry.documentDate,
        token
      );
      const hasRate = rate != null && rate > 0;
      updateJournalEntryAt(index, {
        exchangeRate: hasRate ? rate : null,
        foreignCurrencyAmount: hasRate
          ? parseFloat((nisAmount / rate).toFixed(CJE_FC_AMOUNT_DECIMALS))
          : null,
        amount: nisAmount,
      });
    } catch (err) {
      console.error(err);
      toast.error(t("CurrencyRateFetchError"));
    } finally {
      setJournalEntryRateLoading((prev) => ({ ...prev, [index]: false }));
    }
  };

  // Toggle a preview entry between representative (automatic) and manual rate.
  // Automatic re-fetches the representative rate for the entry date and recomputes
  // the NIS amount from the foreign-currency amount.
  const handleJournalEntryRateTypeChange = async (index, rateType) => {
    const entry = journalEntriesList[index];
    if (!entry) return;
    updateJournalEntryAt(index, { exchangeRateType: rateType });
    if (rateType !== Constants.ExchangeRateType.Representative) return;
    if (entry.foreignCurrencyCode == null) return;

    setJournalEntryRateLoading((prev) => ({ ...prev, [index]: true }));
    try {
      const rate = await ForeignCurrencyService.GetIlsRateForDate(
        entry.foreignCurrencyCode,
        entry.documentDate,
        token
      );
      const hasRate = rate != null && rate > 0;
      if (entry.bankIsForeign) {
        const fc = Number(entry.foreignCurrencyAmount);
        updateJournalEntryAt(index, {
          exchangeRate: hasRate ? rate : null,
          amount:
            hasRate && !isNaN(fc)
              ? parseFloat((fc * rate).toFixed(2))
              : entry.amount,
        });
      } else {
        const nis = getJournalEntryNisAnchor(entry);
        updateJournalEntryAt(index, {
          exchangeRate: hasRate ? rate : null,
          foreignCurrencyAmount: hasRate
            ? parseFloat((nis / rate).toFixed(CJE_FC_AMOUNT_DECIMALS))
            : entry.foreignCurrencyAmount,
          amount: nis,
        });
      }
    } catch (err) {
      console.error(err);
      toast.error(t("CurrencyRateFetchError"));
    } finally {
      setJournalEntryRateLoading((prev) => ({ ...prev, [index]: false }));
    }
  };

  // FC amount edited in the preview. Amounts are converted on their magnitude so a
  // negative entry yields the same (positive) rate and foreign amount.
  const handleJournalEntryFcAmountChange = (index, value) => {
    const entry = journalEntriesList[index];
    if (!entry) return;
    const fc = Math.abs(Number(value));
    const rate = Number(entry.exchangeRate);
    const patch = { foreignCurrencyAmount: value };

    if (entry.bankIsForeign) {
      // Foreign bank: FC is the match anchor; NIS = FC * rate.
      if (!isNaN(fc) && rate > 0) {
        patch.amount = parseFloat((fc * rate).toFixed(2));
      }
    } else if (entry.exchangeRateType === Constants.ExchangeRateType.Manual) {
      // Shekel bank + optional FC: NIS is fixed; derive rate from NIS / FC.
      const nis = getJournalEntryNisAnchor(entry);
      if (!isNaN(fc) && fc > 0) {
        patch.exchangeRate = parseFloat(
          (nis / fc).toFixed(CJE_MANUAL_RATE_DECIMALS)
        );
        patch.amount = nis;
      }
    }
    updateJournalEntryAt(index, patch);
  };

  // NIS amount edited. Only applies when the field is unlocked.
  const handleJournalEntryAmountChange = (index, value) => {
    const entry = journalEntriesList[index];
    if (!entry) return;
    const nis = Math.abs(Number(value));
    const patch = { amount: value };

    if (entry.bankIsForeign && entry.foreignCurrencyCode != null) {
      const fc = Math.abs(Number(entry.foreignCurrencyAmount));
      if (entry.exchangeRateType === Constants.ExchangeRateType.Manual) {
        if (!isNaN(nis) && !isNaN(fc) && fc > 0) {
          patch.exchangeRate = parseFloat(
            (nis / fc).toFixed(CJE_MANUAL_RATE_DECIMALS)
          );
        }
      } else {
        const rate = Number(entry.exchangeRate);
        if (!isNaN(nis) && rate > 0) {
          patch.foreignCurrencyAmount = parseFloat(
            (nis / rate).toFixed(CJE_FC_AMOUNT_DECIMALS)
          );
        }
      }
    }
    updateJournalEntryAt(index, patch);
  };

  // Rate edited -> recompute the derived side from the match anchor.
  const handleJournalEntryRateChange = (index, value) => {
    const entry = journalEntriesList[index];
    if (!entry) return;
    // Rates are always positive; the sign lives on the amounts.
    const rate = Math.abs(Number(value));
    const patch = { exchangeRate: value === '' ? value : String(value).replace(/-/g, '') };

    if (entry.bankIsForeign) {
      const fc = Math.abs(Number(entry.foreignCurrencyAmount));
      if (!isNaN(rate) && rate > 0 && !isNaN(fc)) {
        patch.amount = parseFloat((fc * rate).toFixed(2));
      }
    } else {
      const nis = getJournalEntryNisAnchor(entry);
      if (!isNaN(rate) && rate > 0) {
        patch.foreignCurrencyAmount = parseFloat(
          (nis / rate).toFixed(CJE_FC_AMOUNT_DECIMALS)
        );
        patch.amount = nis;
      }
    }
    updateJournalEntryAt(index, patch);
  };

  const journalEntriesMatchInfo = useMemo(() => {
    const getMatchAmt = (e) =>
      Math.abs(
        Number(e.bankIsForeign ? e.foreignCurrencyAmount : e.amount)
      ) || 0;
    // Prefer matchAmount; fall back to the entry amount (e.g. split rows) so a
    // missing matchAmount is not treated as required=0.
    const getRequiredAmt = (e) =>
      Math.abs(Number(e.matchAmount ?? e.amount)) || 0;
    const required = journalEntriesList.reduce(
      (sum, e) => sum + getRequiredAmt(e),
      0
    );
    const current = journalEntriesList.reduce((sum, e) => sum + getMatchAmt(e), 0);
    // Each entry must keep its own match-relevant amount so no single transaction
    // pairing is thrown off (aggregate equality alone can hide offsetting edits).
    const isValid = journalEntriesList.every(
      (e) => Math.abs(getMatchAmt(e) - getRequiredAmt(e)) < 0.005
    );
    return { required, current, isValid };
  }, [journalEntriesList]);




  const getItemAtIndex = (transactions, newIndex) => {
    // Convert the object to an array of its values
    const transactionsArray = Object.values(transactions);

    // Check if the index is within the bounds of the array
    if (newIndex >= 0 && newIndex < transactionsArray.length) {
      return transactionsArray[newIndex];
    } else {
      console.error("Index out of bounds");
      return null;
    }
  };

  const filteredAndSortedTransactions = useMemo(() => {
    if (!transactions || transactions.length === 0) {
      return [];
    }

    // Filtering the transactions based on searchQuery
    const filteredData = transactions.filter((transaction) => {
      const query = searchQuery.toLowerCase();
      return (
        transaction?.description?.toLowerCase().includes(query) ||
        transaction?.reference1?.toLowerCase().includes(query) ||
        transaction?.reference2?.toLowerCase().includes(query) ||
        transaction?.debitAccount?.toString().includes(query) ||
        transaction?.creditAccount?.toString().includes(query) ||
        transaction?.balance?.toString().includes(query) ||
        new Date(transaction.documentDate)
          .toLocaleDateString()
          .includes(query) ||
        new Date(transaction.uploadDate).toLocaleDateString().includes(query)
      );
    });

    // Sorting the filtered transactions based on sortConfig
    if (sortConfig.key) {
      filteredData.sort((a, b) => {
        const aValue = a[sortConfig.key] || ""; // Default to empty string if null or undefined
        const bValue = b[sortConfig.key] || ""; // Default to empty string if null or undefined

        if (sortConfig.type === "number") {
          return sortConfig.direction === "ascending"
            ? aValue - bValue
            : bValue - aValue;
        } else if (sortConfig.type === "date") {
          return sortConfig.direction === "ascending"
            ? new Date(aValue) - new Date(bValue)
            : new Date(bValue) - new Date(aValue);
        } else {
          // default to string comparison
          return sortConfig.direction === "ascending"
            ? aValue?.localeCompare(bValue)
            : bValue?.localeCompare(aValue);
        }
      });
    }
    const updatedDataForPdf = {
      ...dataForPdf,
      transactions: filteredData,
    };
    setSortedDataForPdf(updatedDataForPdf);

    return filteredData;
  }, [sortedTransactions, searchQuery, sortConfig]);

  const handleNext = () => {
    let newIndex = currentIndex;

    while (newIndex < sortedTransactions.length - 1) {
      newIndex += 1;
      const nextItem = sortedTransactions[newIndex];
      const currentItem = sortedTransactions[currentIndex];
      // Check if the next item has a different id
      if (nextItem.id !== currentItem.id) {
        handleEdit(nextItem);
        break; // Exit the loop once a different ID is found
      }
    }
  };

  const handlePrevious = () => {
    let newIndex = currentIndex;


    while (newIndex > 0) {
      newIndex -= 1;
      const previousItem = sortedTransactions[newIndex];
      const currentItem = sortedTransactions[currentIndex];

      // Check if the previous item has a different id
      if (previousItem.id !== currentItem.id) {
        handleEdit(previousItem);
        break;
      }
    }
  };

  const handleInternalExpandClick = (id) => {
    setExpandedInternalRows((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const InternalRows = [
    {
      id: 1,
      matchNumber: 1001,
      description: "Value 1",
      reference: "Value 2",
      documentDate: "2023-10-15", // Replace 'Value 3' with a valid date
      amount: 100, // Add amount field
      status: "Filled",
      subRows: [
        {
          id: 2,
          matchNumber: 2001,
          description: "Sub Value 1",
          reference: "Sub Value 2",
          documentDate: "2023-10-14", // Replace 'Sub Value 3' with a valid date
          amount: 50, // Add amount field
          status: "Filled",
        },
        {
          id: 3,
          matchNumber: 2002,
          description: "Sub Value 4",
          reference: "Sub Value 5",
          documentDate: "2023-10-13", // Replace 'Sub Value 6' with a valid date
          amount: 75, // Add amount field
          status: "PartiallyFilled",
        },
      ],
    },
    {
      id: 4,
      matchNumber: 1002,
      description: "Value 4",
      reference: "Value 5",
      documentDate: "2023-10-12", // Replace 'Value 6' with a valid date
      amount: 200, // Add amount field
      status: "Rejected",
    },
    // Add more rows if needed
  ];

  const stringFilterOperators = useMemo(() => getGridStringOperatorsWithComparison(t), [t]);
  const numericFilterOperators = useMemo(() => getGridNumericOperatorsWithNotLike(t), [t]);
  const dateFilterOperators = useMemo(() => getGridDateOperatorsWithNotLike(t), [t]);

  const InternalColumns = [
    // Data columns in reverse order for RTL
    {
      field: "description",
      headerName: t("Description"),
      flex: 1,
      headerAlign: "center",
      align: "center",
      type: "string",
      filterOperators: stringFilterOperators,
    },
    {
      field: "reference",
      headerName: t("Reference"),
      flex: 1,
      headerAlign: "center",
      align: "center",
      type: "string",
      filterOperators: stringFilterOperators,
    },
    {
      field: "reference2",
      headerName: t("Reference2"),
      flex: 1,
      headerAlign: "center",
      align: "center",
      type: "string",
      filterOperators: stringFilterOperators,
    },
    {
      field: "documentDate",
      headerName: t("DueOrDocumentDate"),
      flex: 1,
      headerAlign: "center",
      align: "center",
      type: "date",
      filterOperators: dateFilterOperators,
      valueGetter: (value) => {
        if (value == null) return null;
        if (value instanceof Date) return value;
        const str = String(value);
        if (/^\d{4}-\d{2}-\d{2}/.test(str)) return new Date(str);
        return new Date(parseCustomDate(str));
      },
      valueFormatter: (value) => {
        if (!value) return "";
        const date = value instanceof Date ? value : new Date(value);
        if (isNaN(date.getTime())) return "";
        const day = ("0" + date.getDate()).slice(-2);
        const month = ("0" + (date.getMonth() + 1)).slice(-2);
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
      },
      sortComparator: (v1, v2) => {
        const date1 = v1 instanceof Date ? v1 : new Date(parseCustomDate(v1));
        const date2 = v2 instanceof Date ? v2 : new Date(parseCustomDate(v2));
        return date1 - date2;
      },
    },
    {
      field: "amount",
      // when the tbank is fc show the label amount1
      headerName: selectedTBank?.foreignCurrencyCode != null || selectedTBank?.foreignCurrencyCode != undefined
        ? t("CurrencyAmount")
        : t("Amount"),
      flex: 1,
      headerAlign: "center",
      align: "center",
      type: "number",
      filterOperators: numericFilterOperators,
      valueGetter: (value, row) => {
        if (row?.amount1 != null && row.amount1 !== "") {
          const n = Number(row.amount1);
          if (Number.isFinite(n)) return n;
        }
        return parseBeautifiedNumber(value);
      },
      valueFormatter: (value) => {
        if (value == null || value === "") return "";
        return beautifyNumber(value);
      },
      sortComparator: (v1, v2) => (v1 ?? 0) - (v2 ?? 0),
    },

  ];

  // Function to get the displayed rows based on expanded state
  const getDisplayedRows = () => {
    const result = [];

    const addRowAndSubRows = (row, level = 0) => {
      result.push({ ...row, level });
      if (expandedInternalRows[row.id] && row.subRows) {
        row.subRows.forEach((subRow) => {
          addRowAndSubRows(subRow, level + 1);
        });
      }
    };

    internalRows.forEach((row) => {
      addRowAndSubRows(row);
    });


    return result;
  };

  // useEffect to update displayedRows whenever internalRows or expandedInternalRows change
  useEffect(() => {


    const updatedDisplayedRows = getDisplayedRows();
    setDisplayedRows(updatedDisplayedRows);
  }, [internalRows]);

  const getFilteredSortedRows = () => {
    // Get the sorted rows
    const sortedRows = apiRef.current.getSortedRows();

    // Access the filteredRowsLookup from the grid state
    const filteredRowsLookup = apiRef.current.state.filter.filteredRowsLookup;

    if (filteredRowsLookup) {
      // Create a Set of IDs of rows that pass the filter
      const filteredRowIdsSet = new Set(
        Object.entries(filteredRowsLookup)
          .filter(([_, isVisible]) => isVisible)
          .map(([id]) => id)
      );

      // Filter the sorted rows to include only those that are in the filteredRowIdsSet
      const filteredSortedRows = sortedRows.filter((row) =>
        filteredRowIdsSet.has(row.id)
      );

      return filteredSortedRows;
    } else {
      // If no filtering is applied, return the sorted rows
      return sortedRows;
    }
  };

  const handleSortModelChange = () => {
    const sortedRows = getFilteredSortedRows();

    setSortedTransactions(sortedRows);
  };

  // const ExternalRows = [
  //     {
  //         id: 1,
  //         matchNumber: 1001,
  //         description: 'Value 1',
  //         reference: 'Value 2',
  //         transactionDate: '2023-10-15', // Replace 'Value 3' with a valid date
  //         amount: 100, // Add amount field
  //         status: 'Open',
  //         subRows: [
  //             {
  //                 id: 5,
  //                 matchNumber: 2001,
  //                 description: 'Sub Value 1',
  //                 reference: 'Sub Value 2',
  //                 transactionDate: '2023-10-14', // Replace 'Sub Value 3' with a valid date
  //                 amount: 50, // Add amount field
  //                 status: 'Filled',
  //             },
  //             {
  //                 id: 6,
  //                 matchNumber: 2002,
  //                 description: 'Sub Value 4',
  //                 reference: 'Sub Value 5',
  //                 transactionDate: '2023-10-13', // Replace 'Sub Value 6' with a valid date
  //                 amount: 75, // Add amount field
  //                 status: 'PartiallyFilled',
  //             },
  //         ],
  //     },
  //     {
  //         id: 2,
  //         matchNumber: 1002,
  //         description: 'Value 4',
  //         reference: 'Value 5',
  //         transactionDate: '2023-10-12', // Replace 'Value 6' with a valid date
  //         amount: 200, // Add amount field
  //         status: 'Filled',
  //     },
  //     {
  //         id: 3,
  //         matchNumber: 1003,
  //         description: 'Value 7',
  //         reference: 'Value 8',
  //         transactionDate: '2023-10-11', // Replace 'Value 9' with a valid date
  //         amount: 150, // Add amount field
  //         status: 'PartiallyFilled',
  //     },
  //     // Add more rows if needed
  // ];

  const ExternalColumns = [
    {
      field: "description",
      headerName: t("Description"),
      flex: 1,
      headerAlign: "center",
      align: "center",
      type: "string",
      filterOperators: stringFilterOperators,
    },
    {
      field: "reference",
      headerName: t("Reference"),
      flex: 1,
      headerAlign: "center",
      align: "center",
      type: "string",
      filterOperators: stringFilterOperators,
    },
    {
      field: "reference2",
      headerName: t("Reference2"),
      flex: 1,
      headerAlign: "center",
      align: "center",
      type: "string",
      filterOperators: stringFilterOperators,
    },
    {
      field: "transactionDate",
      headerName: t("Date"),
      flex: 1,
      headerAlign: "center",
      align: "center",
      type: "date",
      filterOperators: dateFilterOperators,
      valueGetter: (value) => {
        if (value == null) return null;
        if (value instanceof Date) return value;
        const str = String(value);
        if (/^\d{4}-\d{2}-\d{2}/.test(str)) return new Date(str);
        return new Date(parseCustomDate(str));
      },
      valueFormatter: (value) => {
        if (!value) return "";
        const date = value instanceof Date ? value : new Date(value);
        if (isNaN(date.getTime())) return "";
        const day = ("0" + date.getDate()).slice(-2);
        const month = ("0" + (date.getMonth() + 1)).slice(-2);
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
      },
      sortComparator: (v1, v2) => {
        const date1 = v1 instanceof Date ? v1 : new Date(parseCustomDate(v1));
        const date2 = v2 instanceof Date ? v2 : new Date(parseCustomDate(v2));
        return date1 - date2;
      },
    },
    {
      field: "amount",
      headerName: selectedTBank?.foreignCurrencyCode != null || selectedTBank?.foreignCurrencyCode != undefined
        ? t("CurrencyAmount")
        : t("Amount"),
      flex: 1,
      headerAlign: "center",
      align: "center",
      type: "number",
      filterOperators: numericFilterOperators,
      valueGetter: (value, row) => {
        if (row?.amount1 != null && row.amount1 !== "") {
          const n = Number(row.amount1);
          if (Number.isFinite(n)) return n;
        }
        return parseBeautifiedNumber(value);
      },
      valueFormatter: (value) => {
        if (value == null || value === "") return "";
        return beautifyNumber(value);
      },
      sortComparator: (v1, v2) => (v1 ?? 0) - (v2 ?? 0),
    },

    {
      field: "document",
      headerName: t("Document"),
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        if (!params.row.documentUrl) return "-";
        return (
          <DocumentThumbnail
            url={params.row.documentUrl}
            title={`document-${params.row.id}`}
          />
        );
      },
    },

    // {
    //     field: 'expand',
    //     headerName: '',
    //     width: 50,
    //     sortable: false,
    //     filterable: false,
    //     renderCell: (params) => {
    //         const isExpandable = params.row.subRows && params.row.subRows.length > 0;
    //         return isExpandable ? (
    //             <IconButton
    //                 size="small"
    //                 onClick={() => handleExternalExpandClick(params.row.id)}
    //             >
    //                 {expandedExternalRows[params.row.id] ? <ExpandLess /> : <ExpandMore />}
    //             </IconButton>
    //         ) : null;
    //     },
    // },
  ];
  const handleExternalExpandClick = (id) => {
    setExpandedExternalRows((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  // Memoized so the grid's `rows` prop keeps a stable identity between renders.
  // Rebuilding it on every render made the grid re-hydrate its rows and drop the
  // focused cell, which is why arrow-key navigation stopped after one step in
  // the bank panel while the book panel (backed by state) kept working.
  const externalDisplayedRows = useMemo(() => {
    const result = [];

    const addRowAndSubRows = (row, level = 0) => {
      result.push({ ...row, level });
      if (expandedExternalRows[row.id] && row.subRows) {
        row.subRows.forEach((subRow) => {
          addRowAndSubRows(subRow, level + 1);
        });
      }
    };

    const sourceRows = showOnlyWithDocuments
      ? (externalRows || []).filter((row) => !!row.documentUrl)
      : externalRows || [];

    sourceRows.forEach((row) => {
      addRowAndSubRows(row);
    });

    return result;
  }, [externalRows, expandedExternalRows, showOnlyWithDocuments]);

  /** The bank accounts a many-account report can cover, named the way the account bar names them. */
  const bankAccountReportItems = useMemo(
    () => (tBanksData || [])
      .filter((bank) => bank.cardId)
      .map((bank) => ({
        cardId: bank.cardId,
        name: [bank.bankName, bank.branchNumber, bank.accountNumber].filter(Boolean).join(" "),
      })),
    [tBanksData]
  );

  /** One side of a bank reconciliation report: the open items an accountant works through. */
  const bankUnmatchedSection = (title, rows, dateField) => ({
    title,
    headers: [t("Description"), t("Reference"), t("Reference2"), t("Date"), t("Amount")],
    amountIndex: 4,
    rows: rows
      .filter((row) => !row.level)
      .map((row) => [row.description, row.reference, row.reference2, row[dateField], row.amount1 ?? row.amount]),
  });

  const handleDownloadUnmatched = async (format) => {
    const toSection = bankUnmatchedSection;
    const report = {
      title: t("UnmatchedReport"),
      clientName: client?.name,
      clientCase: client?.caseId,
      cardLabel: selectedCardId ? `${selectedCardId} - ${getAccountCardName(selectedCardId)}` : "",
      startDate,
      endDate,
      fileSuffix: `BankUnmatched_${selectedCardId || ""}`,
      sections: [
        toSection(t("BookCommands"), displayedRows, "documentDate"),
        toSection(t("BankCommands"), externalDisplayedRows, "transactionDate"),
      ],
      t,
    };
    if (format === "excel") {
      downloadUnmatchedExcel(report);
      return;
    }
    setLoading(true);
    try {
      await downloadUnmatchedPdf({ ...report, token });
    } catch (err) {
      toast.error(err?.message || t("ErrorGeneratingPDF"));
    } finally {
      setLoading(false);
    }
  };

  /**
   * The open items of one bank account over a period: the book side and the bank side, the same two
   * lists the screen shows. There is no bulk endpoint, so a many-account report asks one at a time.
   */
  const fetchUnmatchedRowsForAccount = async (cardId, period = {}) => {
    const from = period.startDate || startDate;
    const to = period.endDate || endDate;
    const formattedStartDate = new Date(Date.UTC(from.getUTCFullYear(), from.getUTCMonth(), 1));
    const formattedEndDate = new Date(
      Date.UTC(to.getUTCFullYear(), to.getUTCMonth() + 1, 0, 23, 59, 59)
    );
    const account = tBanksData.find((bank) => bank.cardId === cardId);

    const [internalResponse, externalResponse] = await Promise.all([
      DocumentService.GetInternalByAccountCodeIdDateRange(
        client.caseId,
        formattedStartDate,
        formattedEndDate,
        cardId,
        token,
        account?.foreignCurrencyCode != null
      ),
      ExternalTransactionsService.GetNotMatchedbyDateRange(
        client.caseId,
        formattedStartDate,
        formattedEndDate,
        cardId,
        token
      ),
    ]);
    if (!internalResponse.ok || !externalResponse.ok) return { bookRows: [], bankRows: [] };

    const [internalData, externalData] = await Promise.all([
      internalResponse.json(),
      externalResponse.json(),
    ]);
    return {
      bookRows: internalData.map((row) => ({
        description: row.description,
        reference: row.reference,
        reference2: row.reference2,
        documentDate: row.documentDate ? formatDate(row.documentDate) : "",
        amount1: row.amount,
      })),
      bankRows: externalData.map((row) => ({
        description: row.description,
        reference: row.reference,
        reference2: "",
        transactionDate: row.transactionDate ? formatDate(row.transactionDate) : "",
        amount1: row.amount,
      })),
    };
  };

  /**
   * The many-account open-items report: every selected account is fetched, the ones with nothing
   * open are left out, and what remains is a summary page followed by a page per account.
   */
  const handleDownloadUnmatchedAccounts = async (accounts, format, period = {}) => {
    setUnmatchedAccountsBusy(true);
    setUnmatchedAccountsProgress({ done: 0, total: accounts.length });
    try {
      const accountReports = [];
      for (let index = 0; index < accounts.length; index += 1) {
        const account = accounts[index];
        // eslint-disable-next-line no-await-in-loop
        const { bookRows, bankRows } = await fetchUnmatchedRowsForAccount(account.cardId, period);
        if (bookRows.length > 0 || bankRows.length > 0) {
          accountReports.push({
            label: `${account.cardId} - ${account.name}`,
            sections: [
              bankUnmatchedSection(t("BookCommands"), bookRows, "documentDate"),
              bankUnmatchedSection(t("BankCommands"), bankRows, "transactionDate"),
            ],
          });
        }
        setUnmatchedAccountsProgress({ done: index + 1, total: accounts.length });
      }

      if (accountReports.length === 0) {
        toast.info(t("NoUnmatchedCardsFound"));
        return;
      }

      const summary = buildUnmatchedCardsSummary({
        cards: accountReports,
        sideLabels: [t("BookCommands"), t("BankCommands")],
        t,
      });
      const report = {
        title: t("UnmatchedAccountsReport"),
        clientName: client?.name,
        clientCase: client?.caseId,
        cardLabel: `${t("BankAccounts")}: ${accountReports.length}`,
        startDate: period.startDate || startDate,
        endDate: period.endDate || endDate,
        fileSuffix: "BankUnmatchedAccounts",
        t,
      };

      if (format === "excel") {
        downloadUnmatchedExcel({
          ...report,
          sections: [summary, buildUnmatchedCardsFlatSection({ cards: accountReports, t })],
        });
      } else {
        await downloadUnmatchedPdf({
          ...report,
          summary,
          groups: accountReports.map((account) => ({ title: account.label, sections: account.sections })),
          token,
        });
      }
      setUnmatchedAccountsModalOpen(false);
    } catch (err) {
      toast.error(err?.message || t("ErrorGeneratingPDF"));
    } finally {
      setUnmatchedAccountsBusy(false);
    }
  };



  // Handle Create Journal Entries checkbox
  const handleCreateJournalEntries = (checked) => {
    // Case 1: Selected rows from externalDisplayedRows
    const selectedRows = externalDisplayedRows.filter((row) =>
      selectedExternalRows.includes(row.id)
    );

    // Calculate the minimum transaction date from selected external rows
    let minTransactionDate = null;
    if (selectedRows.length > 0) {
      const oldestRow = selectedRows.reduce((oldest, current) => {
        return new Date(parseCustomDate(current.transactionDate)) <
          new Date(parseCustomDate(oldest.transactionDate))
          ? current
          : oldest;
      }, selectedRows[0]);
      minTransactionDate = new Date(parseCustomDate(oldestRow.transactionDate));
    }

    // For single journal entry: use min date from selected rows, or current date - 1 month
    // For multiple journal entries: use min date from selected rows
    let defaultDate = null;
    if (minTransactionDate) {
      defaultDate = minTransactionDate;
    } else if (!checked) {
      // Single journal entry: current date minus one month
      defaultDate = new Date();
      defaultDate.setMonth(defaultDate.getMonth() - 1);
    } else {
      // Multiple journal entries: use current date if no selected rows
      defaultDate = new Date();
    }

    const defaultDateString = defaultDate ? defaultDate.toISOString().split("T")[0] : "";
    // For reporting month date, use the 10th of the month to avoid timezone display issues
    let defaultReportingMonthDate = null;
    if (minTransactionDate) {
      defaultReportingMonthDate = new Date(
        Date.UTC(
          minTransactionDate.getUTCFullYear(),
          minTransactionDate.getUTCMonth(),
          10,
          12,
          0,
          0
        )
      );
    } else if (!checked) {
      // Single journal entry: use the default date (already adjusted to -1 month)
      defaultReportingMonthDate = defaultDate
        ? new Date(
            Date.UTC(
              defaultDate.getUTCFullYear(),
              defaultDate.getUTCMonth(),
              10,
              12,
              0,
              0
            )
          )
        : setReportingMonthToDay10(new Date());
    } else {
      // Multiple journal entries: use current month if no selected rows
      const now = new Date();
      defaultReportingMonthDate = new Date(
        Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 10, 12, 0, 0)
      );
    }

    // Open the create journal entries dialog
    setCreateJournalEntries(checked);
    setIsCreateDialogOpen(true);
    setUsePerRowReportingMonth(false);
    resetSplitState();

    if (!checked) {
      if (
        selectedExternalRows.length > 0
      ) {
        // Case 1: Both selectedInternalRows and selectedExternalRows are not empty

        const oldestRow = selectedRows.reduce((oldest, current) => {
          return new Date(parseCustomDate(current.transactionDate)) <
            new Date(parseCustomDate(oldest.transactionDate))
            ? current
            : oldest;
        }, selectedRows[0]); // Initialize with the first row

        // Get the oldest transactionDate and description
        const oldestDate = new Date(parseCustomDate(oldestRow.transactionDate))
          .toISOString()
          .split("T")[0];
        const oldestDescription = oldestRow.description;

        // Calculate the total sum
        const Sum = externalSum - internalSum;

        // Handle the logic for assigning the creditAccount or debitAccount based on externalSum
        if (Sum < 0) {
          handleSelectChange("creditAccount", selectedCardId); // Set creditAccount if externalSum is negative
        } else {
          handleSelectChange("debitAccount", selectedCardId); // Set debitAccount if externalSum is positive
        }

        // Set form values — for foreign banks balance is in FC, not NIS
        applyCjeBalanceSum(Sum);
        handleSelectChange("reference", oldestRow.reference);
        handleSelectChange("description", oldestDescription);
        handleSelectChange("documentDate", oldestDate);
        handleSelectChange("reportingMonthDate", new Date(oldestDate));
        handleSelectChange("registrationMonthDate", new Date(oldestDate));
      } else if (
        selectedInternalRows.length > 0 &&
        selectedExternalRows.length === 0
      ) {
        // Case 2: selectedInternalRows is not empty, selectedExternalRows is empty
        const filteredRows = displayedRows.filter((row) =>
          selectedInternalRows.includes(row.id)
        );

        const oldestRow = filteredRows.reduce((oldest, current) => {
          return new Date(parseCustomDate(current.documentDate)) <
            new Date(parseCustomDate(oldest.documentDate))
            ? current
            : oldest;
        }, filteredRows[0]); // Initialize with the first row

        // Get the oldest documentDate and description
        const oldestDate = new Date(parseCustomDate(oldestRow.documentDate))
          .toISOString()
          .split("T")[0];
        const oldestDescription = oldestRow.description;

        // Calculate the total sum
        const Sum = externalSum - internalSum;

        // Handle the logic for assigning the creditAccount or debitAccount based on externalSum
        if (Sum < 0) {
          handleSelectChange("creditAccount", selectedCardId); // Set creditAccount if externalSum is negative
        } else {
          handleSelectChange("debitAccount", selectedCardId); // Set debitAccount if externalSum is positive
        }

        // Set form values — for foreign banks balance is in FC, not NIS
        applyCjeBalanceSum(Sum);
        handleSelectChange("description", oldestDescription);
        handleSelectChange("documentDate", oldestDate);
        handleSelectChange("reportingMonthDate", new Date(oldestDate));
        handleSelectChange("registrationMonthDate", new Date(oldestDate));
      } else {
        // No selected rows: use default date (current date - 1 month for single entry)
        handleSelectChange("documentDate", defaultDateString);
        handleSelectChange("reportingMonthDate", defaultReportingMonthDate);
        handleSelectChange("registrationMonthDate", defaultReportingMonthDate);
      }
    } else {
      // Case 2: Checked is true (multiple journal entries)
      // Set dates to minimum transaction date from selected rows
      // Set the reportingMonthDate state first to ensure it's available when dialog opens
      if (defaultReportingMonthDate) {
        setReportingMonthDate(defaultReportingMonthDate);
      }
      setFormValues({
        confirmationNumber: "",
        accountCaseId: "",
        reference: "",
        description: "",
        documentDate: defaultDateString,
        reportingMonthDate: defaultReportingMonthDate,
        registrationMonthDate: defaultReportingMonthDate,
        amount: "",
        vat: 0,
        sortCodeId: "3",
        creditAccount: "",
        debitAccount: "",
        sortCode: "3",
        accountCard: "",
        foreignCurrencyCode: null,
        foreignCurrencyAmount: null,
        exchangeRateType: null,
        exchangeRate: null,
      });
      cjeResetCurrencyInputs();
    }
  };


  const handleMatchEntries = async () => {
    const externalMatchedIds = matchedPairs.map((match) => match.externalId);
    const internalMatchedIds = matchedPairs.map((match) => match.internalId);

    // Prepare the DTO for all matches
    const matchDTOs = matchedPairs.map((pair) => {
      const externalRow = externalDisplayedRows.find(
        (row) => row.id === pair.externalId
      );
      const internalRow = displayedRows.find(
        (row) => row.id === pair.internalId
      );

      // Get the oldest transaction date from external rows
      const oldestTransaction = externalDisplayedRows.reduce(
        (oldest, current) => {
          return new Date(parseCustomDate(current.transactionDate)) <
            new Date(parseCustomDate(oldest.transactionDate))
            ? current
            : oldest;
        },
        externalDisplayedRows[0]
      );

      const oldestTransactionDate = oldestTransaction
        ? new Date(parseCustomDate(oldestTransaction.transactionDate))
        : new Date();

      return {
        CaseId: client.caseId,
        AccountCodeId: selectedCardId,
        TransactionDate: oldestTransactionDate.toISOString(),
        ExternalTransactionIds: [{ Id: pair.externalId }],
        InternalTransactions: [{ Id: pair.internalId, Type: internalRow.type }],
      };
    });

    try {
      // Call the API to create multiple matches
      await ExternalTransactionsService.createMultipleMatches(matchDTOs, token);

      handleClearMatches();
      await FetchData();
      toast.success(t("MatchesCreatedSuccessfully"));
    } catch (error) {
      console.error("Error creating matches:", error);
      toast.error(t("ErrorCreatingMatches"));
    }
  };

  // Define a set of colors for matched pairs
  const matchColors = [
    "#FFCDD2", // Light Red
    "#C8E6C9", // Light Green
    "#BBDEFB", // Light Blue
    "#FFF9C4", // Light Yellow
    "#D1C4E9", // Light Purple
    "#FFECB3", // Light Orange
    "#B2DFDB", // Light Teal
  ];

  // Function to get color based on matchId
  const getMatchColor = (matchId) => {
    const index = parseInt(matchId.split("-")[1], 10);
    return matchColors[index % matchColors.length];
  };

  // Function to handle automatic matching

  /**
   * Compare two rows.  Return 1 iff **every** selected column matches,
   * otherwise return 0.
   *
   * @param {object}   externalRow
   * @param {object}   internalRow
   * @param {string[]} selectedColumns
   * @param {number}   amountTolerance
   */
  const normalize = str =>
    str
      ?.toString()
      .trim()
      .toLowerCase()
      .normalize('NFKC')            // Normalize Unicode
      .replace(/\s+/g, ' ')         // Replace multiple spaces
      .replace(/[^\w\sא-ת-]/g, '');
  const parseFormattedAmount = (value) => {
    if (!value) return NaN;
    
    // Convert to string and trim
    const strValue = String(value).trim();
    
    // Check if it's wrapped in parentheses (negative number format)
    if (strValue.startsWith('(') && strValue.endsWith(')')) {
      // Remove parentheses and parse as negative number
      const cleanValue = strValue.slice(1, -1).replace(/,/g, '');
      return -parseFloat(cleanValue);
    }
    
    // Remove commas and parse normally
    const cleanValue = strValue.replace(/,/g, '');
    return parseFloat(cleanValue);
  };

  const computeSimilarity = (
    externalRow,
    internalRow,
    selectedColumns,
    amountTolerance = 0.01,
    referenceLastDigits = 4
  ) => {
    if (!selectedColumns?.length) return 0;


    for (const column of selectedColumns) {
      let externalValue = externalRow?.[column];
      let internalValue = column === "transactionDate" ? internalRow?.["documentDate"] : internalRow?.[column];
      
      // Last-N options are virtual columns. Compare the real reference
      // fields by their last N digits from the right.
      if (column === "reference_last") {
        externalValue = externalRow?.reference;
        internalValue = internalRow?.reference;
      } else if (column === "reference2" || column === "reference2_last") {
        externalValue = externalRow?.reference;
        internalValue = internalRow?.reference2;
      }
      
      if (column.toLowerCase() === 'amount') {
        const extAmt = parseFormattedAmount(externalValue);
        const intAmt = parseFormattedAmount(internalValue);
        
        if (
          isNaN(extAmt) ||
          isNaN(intAmt) ||
          Math.abs(extAmt - intAmt) > amountTolerance
        ) {
          return 0; // mismatch → bail out
        }
      } else if (column === "reference_last" || column === "reference2_last") {
        const extSuffix = getReferenceLastDigits(externalValue, referenceLastDigits);
        const intSuffix = getReferenceLastDigits(internalValue, referenceLastDigits);

        if (
          extSuffix.length < referenceLastDigits ||
          intSuffix.length < referenceLastDigits ||
          extSuffix !== intSuffix
        ) {
          return 0;
        }
      } else {
        const extStr = normalize(externalValue ?? '');
        const intStr = normalize(internalValue ?? '');

        if (extStr !== intStr) return 0; // mismatch → bail out
      }
    }

    // got through all columns → everything matches
    return 1;
  };


  const handleAutoMatchHeaders = (selectedColumns, referenceLastDigits = 4) => {
    if (!selectedColumns.includes("amount")) {
      alert("Please include the Amount column in your selection.");
      return;
    }

    const matches = [];
    const updatedExternalRows = [...externalRows];
    const updatedInternalRows = [...internalRows];
    let matchIdCounter = matchCounter;

    // Collect potential matches with similarity scores
    const potentialMatches = [];

    externalRows.forEach((externalRow, extIndex) => {
      internalRows.forEach((internalRow, intIndex) => {
        const score = computeSimilarity(
          externalRow,
          internalRow,
          selectedColumns,
          0.01,
          referenceLastDigits
        );

        if (score > 0) {
          potentialMatches.push({
            externalRow,
            internalRow,
            score,
            externalIndex: extIndex,
            internalIndex: intIndex,
          });
        }
      });
    });

    // Sort potential matches by descending similarity score
    potentialMatches.sort((a, b) => b.score - a.score);

    // Perform one-to-one matching
    const matchedExternalIds = new Set(); // To track matched external rows
    const matchedInternalIds = new Set(); // To track matched internal rows

    for (const match of potentialMatches) {
      const { externalRow, internalRow, score, externalIndex, internalIndex } =
        match;

      // Define a threshold for accepting matches
      const threshold = 0.5; // Adjust as needed

      if (
        !matchedExternalIds.has(externalRow.id) && // Check if the external row is already matched
        !matchedInternalIds.has(internalRow.id) && // Check if the internal row is already matched
        score >= threshold
      ) {
        const matchId = `match-${matchIdCounter++}`;
        const colorIndex =
          parseInt(matchId.split("-")[1], 10) % matchColors.length;
        const rowClassName = `super-app-theme--matched-${colorIndex}`;

        // Update external row
        updatedExternalRows[externalIndex] = {
          ...externalRow,
          matchId,
          rowClassName,
        };

        // Update internal row
        updatedInternalRows[internalIndex] = {
          ...internalRow,
          matchId,
          rowClassName,
        };

        matches.push({
          externalId: externalRow.id,
          internalId: internalRow.id,
          matchId,
        });

        // Mark rows as matched
        matchedExternalIds.add(externalRow.id);
        matchedInternalIds.add(internalRow.id);
      }
    }

    // Sort the rows so that matched rows are placed at the top
    const reorderRows = (rows) => {
      return rows.sort((a, b) => {
        if (a.matchId && !b.matchId) return -1; // a is matched, b is not
        if (!a.matchId && b.matchId) return 1; // b is matched, a is not
        return 0; // Both are matched or both are unmatched, keep original order
      });
    };

    const reorderedExternalRows = reorderRows(updatedExternalRows);
    const reorderedInternalRows = reorderRows(updatedInternalRows);

    setMatchedPairs(matches);
    setExternalRows(reorderedExternalRows);
    setInternalRows(reorderedInternalRows);

    setMatchCounter(matchIdCounter);

    // Update selection state
    const externalMatchedIds = matches.map((match) => match.externalId);
    const internalMatchedIds = matches.map((match) => match.internalId);

    setSelectedExternalRows(externalMatchedIds);
    setSelectedInternalRows(internalMatchedIds);
  };

  // Function to clear matches
  const handleClearMatches = () => {
    const clearedExternalRows = externalRows.map((row) => {
      const newRow = { ...row };
      delete newRow.matchId;
      delete newRow.rowClassName;
      return newRow;
    });

    const clearedInternalRows = internalRows.map((row) => {
      const newRow = { ...row };
      delete newRow.matchId;
      delete newRow.rowClassName;
      return newRow;
    });

    setExternalRows(clearedExternalRows);
    setInternalRows(clearedInternalRows);
    setSelectedExternalRows([]);
    setSelectedInternalRows([]);
    setMatchedPairs([]);
    setFormValues({
      confirmationNumber: "",
      accountCaseId: "",
      reference: "",
      description: "",
      documentDate: "",
      reportingMonthDate: "",
      registrationMonthDate: "",
      amount: "",
      vat: 0,
      sortCodeId: "3",
      creditAccount: "",
      debitAccount: "",
      sortCode: "3",
      accountCard: "",
      foreignCurrencyCode: null,
      foreignCurrencyAmount: null,
      exchangeRateType: null,
      exchangeRate: null,
    });
    cjeResetCurrencyInputs();
  };

  // Function to handle Match action
  const handleMatch = async (selectedInternalRows) => {
    // This contains the list of selected external transaction IDs
    // This contains the list of selected internal transaction IDs

    // Filter the complete row objects from externalDisplayedRows based on selectedExternalRows IDs
    const selectedExternalRowsData = externalDisplayedRows.filter((row) =>
      selectedExternalRows.includes(row.id)
    );

    // Filter the complete row objects from internalDisplayedRows based on selectedInternalRows IDs
    const selectedInternalRowsData = displayedRows.filter((row) =>
      selectedInternalRows.includes(row.id)
    );

    try {
      const response = await createBankMatch({
        caseId: client.caseId,
        accountCodeId: selectedCardId,
        externalIds: selectedExternalRowsData.map((row) => row.id),
        internalTransactions: selectedInternalRowsData,
        transactionDate: getOldestBankDate(selectedExternalRowsData),
        token,
      });
      if (response.ok) {
        // Optionally refresh data or update UI
        toast.success(t("MatchCreatedSuccessfully"));
        handleClearMatches();
        await FetchData();
      } else {
        console.error("Failed to create match:", response.statusText);
        toast.error(t("ErrorCreatingMatch"));
      }
    } catch (error) {
      console.error("Error creating match:", error);
      toast.error(t("ErrorCreatingMatch"));
    }
  };

  const withBottomDockBarLoading = (fn) => async (...args) => {
    setBottomDockBarLoading(true);
    try {
      return await Promise.resolve(fn(...args));
    } finally {
      setBottomDockBarLoading(false);
    }
  };

  // ─────────────────────────────────────────────────────────────────────────
  // Keyboard-driven reconciliation
  // Arrows move between rows/panels, Space toggles selection, Shift extends a
  // range, F5 reconciles (or opens the difference journal entry), F6 creates
  // separate journal entries per selected bank row, "?" opens the guide.
  // ─────────────────────────────────────────────────────────────────────────

  // Tracks a Shift+click on a row so the selection-model callback can expand
  // it into a range (the grid itself only toggles the clicked row).
  const shiftClickRef = useRef(null);

  // Ordered visible row ids of a panel, respecting the grid's sort + filter.
  const getPanelRowIds = (panel) => {
    const gridRef = panel === "internal" ? apiRef : externalApiRef;
    try {
      if (gridRef.current?.getSortedRowIds) {
        const sortedIds = gridRef.current.getSortedRowIds();
        const lookup = gridRef.current.state?.filter?.filteredRowsLookup;
        if (lookup) {
          return sortedIds.filter((id) => lookup[id] !== false);
        }
        return sortedIds;
      }
    } catch (error) {
      // Grid not mounted yet; fall through to the plain row arrays.
    }
    const rows = panel === "internal" ? displayedRows : externalDisplayedRows;
    return rows.map((row) => row.id);
  };

  const getPanelState = (panel) =>
    panel === "internal"
      ? {
          focusedId: focusedInternalId,
          setFocusedId: setFocusedInternalId,
          anchorId: internalAnchorId,
          setAnchorId: setInternalAnchorId,
          selected: selectedInternalRows,
          setSelected: setSelectedInternalRows,
          gridRef: apiRef,
        }
      : {
          focusedId: focusedExternalId,
          setFocusedId: setFocusedExternalId,
          anchorId: externalAnchorId,
          setAnchorId: setExternalAnchorId,
          selected: selectedExternalRows,
          setSelected: setSelectedExternalRows,
          gridRef: externalApiRef,
        };

  const scrollPanelToRow = (panel, rowId, ids, skipCellFocus = false) => {
    const { gridRef } = getPanelState(panel);
    try {
      const rowIndex = ids.indexOf(rowId);
      if (rowIndex !== -1) {
        // Both grids run as a single page, so the row index is the scroll index.
        gridRef.current?.scrollToIndexes({ rowIndex, colIndex: 0 });
      }
      // Skipped while typing in the search box so DOM focus stays there.
      if (!skipCellFocus) {
        const visibleColumns = gridRef.current?.getVisibleColumns?.() || [];
        const firstField = visibleColumns.find((col) => col.field !== "__check__")?.field;
        if (firstField) {
          gridRef.current?.setCellFocus?.(rowId, firstField);
        }
      }
    } catch (error) {
      // Row may not be rendered yet (virtualization); focus highlight still applies.
    }
  };

  // mode "select" adds the contiguous range to the selection, "deselect"
  // removes it.
  const selectPanelRange = (panel, fromId, toId, ids, mode = "select") => {
    const { selected, setSelected } = getPanelState(panel);
    const fromIndex = ids.indexOf(fromId);
    const toIndex = ids.indexOf(toId);
    if (fromIndex === -1 || toIndex === -1) return;
    const [start, end] = fromIndex <= toIndex ? [fromIndex, toIndex] : [toIndex, fromIndex];
    const rangeIds = ids.slice(start, end + 1);
    if (mode === "deselect") {
      const rangeSet = new Set(rangeIds);
      setSelected(selected.filter((id) => !rangeSet.has(id)));
      return;
    }
    setSelected(Array.from(new Set([...selected, ...rangeIds])));
  };

  // Arrow up/down inside the active panel. With Shift, the selection follows
  // the range between the anchor and the focused row: rows entering the range
  // are selected, rows leaving it (walking back over them) are deselected,
  // and a deselected anchor turns the walk into a deselect sweep.
  const moveFocus = (delta, extendSelection, panelOverride, skipCellFocus = false) => {
    const panel = panelOverride || activePanel;
    const ids = getPanelRowIds(panel);
    if (ids.length === 0) return;
    const { focusedId, setFocusedId, anchorId, setAnchorId, selected, setSelected } =
      getPanelState(panel);
    const currentIndex = ids.indexOf(focusedId);
    const nextIndex =
      currentIndex === -1
        ? delta > 0
          ? 0
          : ids.length - 1
        : Math.min(ids.length - 1, Math.max(0, currentIndex + delta));
    const nextId = ids[nextIndex];
    setFocusedId(nextId);
    if (extendSelection) {
      const effectiveAnchor =
        anchorId != null && ids.includes(anchorId) ? anchorId : focusedId ?? nextId;
      if (anchorId == null) setAnchorId(effectiveAnchor);
      const anchorIndex = ids.indexOf(effectiveAnchor);
      // Deselect sweep only when the anchor row was explicitly deselected
      // (e.g. toggled off with Space); a fresh anchor always selects.
      const mode =
        anchorId != null && !selected.includes(effectiveAnchor) ? "deselect" : "select";
      const [rangeStart, rangeEnd] =
        anchorIndex <= nextIndex ? [anchorIndex, nextIndex] : [nextIndex, anchorIndex];
      const rangeIds = ids.slice(rangeStart, rangeEnd + 1);
      const rangeSet = new Set(rangeIds);
      if (mode === "deselect") {
        setSelected(selected.filter((id) => !rangeSet.has(id)));
      } else {
        // Rows that just left the range (the walk reversed toward the anchor)
        // are deselected again.
        const prevIndex = currentIndex === -1 ? nextIndex : currentIndex;
        const [oldStart, oldEnd] =
          anchorIndex <= prevIndex ? [anchorIndex, prevIndex] : [prevIndex, anchorIndex];
        const exitedSet = new Set(
          ids.slice(oldStart, oldEnd + 1).filter((id) => !rangeSet.has(id))
        );
        setSelected(
          Array.from(new Set([...selected.filter((id) => !exitedSet.has(id)), ...rangeIds]))
        );
      }
    }
    scrollPanelToRow(panel, nextId, ids, skipCellFocus);
  };

  // Arrow left/right between the two panels, restoring that panel's last
  // focused row (or its first visible row).
  const switchPanel = (targetPanel) => {
    if (targetPanel === activePanel) return;
    setActivePanel(targetPanel);
    const ids = getPanelRowIds(targetPanel);
    if (ids.length === 0) return;
    const { focusedId, setFocusedId } = getPanelState(targetPanel);
    const restoredId = focusedId != null && ids.includes(focusedId) ? focusedId : ids[0];
    setFocusedId(restoredId);
    scrollPanelToRow(targetPanel, restoredId, ids);
  };

  // Space: toggle the focused row. Shift+Space: apply the anchor row's state
  // to the whole range - if the anchor row is selected the range is selected,
  // if the anchor row was just deselected the range is deselected too.
  const toggleFocusedRowSelection = (shiftKey) => {
    const panel = activePanel;
    const ids = getPanelRowIds(panel);
    const { focusedId, anchorId, setAnchorId, selected, setSelected } = getPanelState(panel);
    if (focusedId == null || !ids.includes(focusedId)) return;
    if (shiftKey && anchorId != null && ids.includes(anchorId)) {
      const mode = selected.includes(anchorId) ? "select" : "deselect";
      selectPanelRange(panel, anchorId, focusedId, ids, mode);
    } else {
      if (selected.includes(focusedId)) {
        setSelected(selected.filter((id) => id !== focusedId));
      } else {
        setSelected([...selected, focusedId]);
      }
      setAnchorId(focusedId);
    }
  };

  // F5: when the difference is zero reconcile the selection; otherwise open
  // the journal-entry dialog pre-filled with the remaining difference.
  const handleReconcileShortcut = () => {
    if (loading || bottomDockBarLoading) return;
    if (selectedExternalRows.length === 0 && selectedInternalRows.length === 0) {
      toast.info(t("KbdSelectRowsFirst"));
      return;
    }
    const difference = (externalSum || 0) - (internalSum || 0);
    if (Math.abs(difference) < 0.01) {
      withBottomDockBarLoading(handleMatch)(selectedInternalRows);
    } else {
      handleCreateJournalEntries(false);
    }
  };

  // "/": focus the quick-search box of the active panel's grid.
  const focusPanelSearch = () => {
    const { gridRef } = getPanelState(activePanel);
    const root = gridRef.current?.rootElementRef?.current;
    const input = root?.querySelector(".MuiDataGrid-toolbarQuickFilter input");
    if (input) {
      input.focus();
      input.select?.();
    }
  };

  // Which panel's grid contains the given DOM element (e.g. its search box).
  const getPanelForTarget = (target) => {
    if (apiRef.current?.rootElementRef?.current?.contains(target)) return "internal";
    if (externalApiRef.current?.rootElementRef?.current?.contains(target)) return "external";
    return null;
  };

  const isQuickSearchTarget = (target) =>
    !!target?.closest?.(".MuiDataGrid-toolbarQuickFilter");

  // F6: one separate journal entry per selected bank transaction.
  const handlePerRowEntriesShortcut = () => {
    if (loading || bottomDockBarLoading) return;
    if (selectedExternalRows.length > 0) {
      handleCreateJournalEntries(true);
    } else {
      toast.info(t("KbdSelectMultipleBankRows"));
    }
  };

  const isTypingTarget = (target) => {
    if (!target || !target.tagName) return false;
    const tag = target.tagName;
    return (
      tag === "INPUT" ||
      tag === "TEXTAREA" ||
      tag === "SELECT" ||
      target.isContentEditable
    );
  };

  // Any open dialog disables the shortcuts (covers MUI dialogs and Swal).
  const isAnyOverlayOpen = () =>
    isCreateDialogOpen ||
    addBankTransactionDialog ||
    openImportDialog ||
    openPreviewModal ||
    finsiteDialogOpen ||
    shortcutsOpen ||
    !!document.querySelector(".MuiDialog-root, .swal2-container");

  useEffect(() => {
    const handleKeyDown = (event) => {
      // Always neutralize F5/F6 on this screen so the browser never refreshes
      // mid-reconciliation (the global F-key navigation steps aside here too).
      if (event.key === "F5" || event.key === "F6") {
        event.preventDefault();
        event.stopPropagation();
        if (fetchType === "Matched" || isAnyOverlayOpen() || isTypingTarget(event.target)) {
          return;
        }
        if (event.key === "F5") {
          handleReconcileShortcut();
        } else {
          handlePerRowEntriesShortcut();
        }
        return;
      }

      if (fetchType === "Matched") return;
      if (isAnyOverlayOpen()) return;

      // Escape inside the quick-search box clears the search and returns
      // control to keyboard navigation.
      if (event.key === "Escape" && isTypingTarget(event.target)) {
        const panel = getPanelForTarget(event.target);
        if (panel && isQuickSearchTarget(event.target)) {
          const { gridRef } = getPanelState(panel);
          try {
            gridRef.current?.setQuickFilterValues?.([]);
          } catch (error) {
            // Grid API unavailable; the box is still blurred below.
          }
        }
        event.target.blur();
        return;
      }

      // While typing in a grid's quick-search box, Arrow Up/Down still
      // navigate the (filtered) rows of that grid; other keys type normally.
      if (isTypingTarget(event.target)) {
        if (
          isQuickSearchTarget(event.target) &&
          (event.key === "ArrowDown" || event.key === "ArrowUp")
        ) {
          event.preventDefault();
          event.stopPropagation();
          const panel = getPanelForTarget(event.target) || activePanel;
          if (panel !== activePanel) setActivePanel(panel);
          moveFocus(event.key === "ArrowDown" ? 1 : -1, event.shiftKey, panel, true);
        }
        return;
      }

      // Search ("/") and guide ("?") shortcuts, matched by the physical slash
      // key (event.code) and by the characters that key produces on Hebrew
      // ("." / "?") and Arabic ("ظ" / "؟") layouts, plus the Hebrew layout's
      // own slash on the Q key. Layout-independent this way.
      const isSlashKey = event.code === "Slash" || event.key === "/" || event.key === "ظ";
      const isQuestionKey = event.key === "?" || event.key === "؟";
      if (isSlashKey || isQuestionKey) {
        event.preventDefault();
        event.stopPropagation();
        if (isQuestionKey || event.shiftKey) {
          setShortcutsOpen(true);
        } else {
          focusPanelSearch();
        }
        return;
      }

      switch (event.key) {
        case "ArrowDown":
          event.preventDefault();
          event.stopPropagation();
          moveFocus(1, event.shiftKey);
          break;
        case "ArrowUp":
          event.preventDefault();
          event.stopPropagation();
          moveFocus(-1, event.shiftKey);
          break;
        case "ArrowRight":
          event.preventDefault();
          event.stopPropagation();
          switchPanel(direction === "rtl" ? "internal" : "external");
          break;
        case "ArrowLeft":
          event.preventDefault();
          event.stopPropagation();
          switchPanel(direction === "rtl" ? "external" : "internal");
          break;
        case " ":
          event.preventDefault();
          event.stopPropagation();
          // Ignore auto-repeat while the key is held so the selection does
          // not rapidly flicker on and off.
          if (!event.repeat) toggleFocusedRowSelection(event.shiftKey);
          break;
        default:
          break;
      }
    };

    // Capture phase: runs before the grid's own key handling and before the
    // browser's default F5 refresh.
    window.addEventListener("keydown", handleKeyDown, true);
    return () => window.removeEventListener("keydown", handleKeyDown, true);
  });

  // Row click: focus the row, activate its panel, and remember the range
  // anchor. A Shift+click is stored so the selection callback expands it.
  const handlePanelCellClick = (panel) => (params, event) => {
    setActivePanel(panel);
    const { setFocusedId, setAnchorId } = getPanelState(panel);
    setFocusedId(params.id);
    if (event?.shiftKey) {
      shiftClickRef.current = { panel, rowId: params.id, ts: Date.now() };
    } else {
      shiftClickRef.current = null;
      setAnchorId(params.id);
    }
  };

  // Selection callback shared by both grids: expands a recent Shift+click into
  // a contiguous range, otherwise applies the grid's model as-is.
  const handlePanelSelectionChange = (panel) => (ids) => {
    const { anchorId, setSelected } = getPanelState(panel);
    const shiftClick = shiftClickRef.current;
    if (
      shiftClick &&
      shiftClick.panel === panel &&
      anchorId != null &&
      Date.now() - shiftClick.ts < 500
    ) {
      shiftClickRef.current = null;
      const ordered = getPanelRowIds(panel);
      if (ordered.includes(anchorId) && ordered.includes(shiftClick.rowId)) {
        selectPanelRange(panel, anchorId, shiftClick.rowId, ordered);
        return;
      }
    }
    setSelected(ids);
  };

  const handleMatch2 = async (selectedInternalRows, selectedExternalRows, internalDisplayedRows = displayedRows, externalDisplayedRows = externalRows) => {
    // This contains the list of selected external transaction IDs
    // This contains the list of selected internal transaction IDs


    // Filter the complete row objects from externalDisplayedRows based on selectedExternalRows IDs
    const selectedExternalRowsData = externalDisplayedRows.filter((row) =>
      selectedExternalRows.includes(row.id)
    );

    // Filter the complete row objects from internalDisplayedRows based on selectedInternalRows IDs
    const selectedInternalRowsData = internalDisplayedRows.filter((row) =>
      selectedInternalRows.includes(row.id)
    );

    try {
      const response = await createBankMatch({
        caseId: client.caseId,
        accountCodeId: selectedCardId,
        externalIds: selectedExternalRowsData.map((row) => row.id),
        internalTransactions: selectedInternalRowsData,
        transactionDate: getOldestBankDate(selectedExternalRowsData),
        token,
      });
      if (response.ok) {
        toast.success(t("MatchCreatedSuccessfully"));
      } else {
        console.error("Failed to create match:", response.statusText);
        toast.error(t("ErrorCreatingMatch"));
      }
    } catch (error) {
      console.error("Error creating match:", error);
      toast.error(t("ErrorCreatingMatch"));
    }
  };

  // Close dialog
  const handleCloseDialog = () => {
    setIsCreateDialogOpen(false);
    resetSplitState();
    setFormValues({
      confirmationNumber: "",
      accountCaseId: "",
      reference: "",
      description: "",
      documentDate: "",
      reportingMonthDate: new Date(),
      amount: "",
      vat: 0,
      sortCodeId: "3",
      creditAccount: "",
      debitAccount: "",
      sortCode: "3",
      accountCard: "",
      foreignCurrencyCode: null,
      foreignCurrencyAmount: null,
      exchangeRateType: null,
      exchangeRate: null,
    });
    cjeResetCurrencyInputs();
  };

  // ----- Split-difference helpers -----
  const resetSplitState = () => {
    setSplitDifference(false);
    splitRowIdRef.current = 1;
    setSplitRows([{ id: 1, amount: "", counterAccount: "" }]);
  };

  const addSplitRow = () => {
    splitRowIdRef.current += 1;
    setSplitRows((prev) => [
      ...prev,
      { id: splitRowIdRef.current, amount: "", counterAccount: "" },
    ]);
  };

  const updateSplitRow = (id, field, value) => {
    setSplitRows((prev) =>
      prev.map((row) => (row.id === id ? { ...row, [field]: value } : row))
    );
  };

  const removeSplitRow = (id) => {
    setSplitRows((prev) =>
      prev.length > 1 ? prev.filter((row) => row.id !== id) : prev
    );
  };

  // ----- Split difference: one difference -> several journal entries -----
  // Every split row becomes its own entry: it carries an amount and a counter account,
  // while description, reference, dates and sort code stay shared. Rows are entered in
  // the unit the entry is anchored in - the foreign currency when one is selected (the
  // same unit as the "amount in foreign currency" field), shekels otherwise - so the
  // allocation is always compared against a single, visible total.
  //
  // Signs never take part in the allocation: the difference's sign already fixed which
  // side of the entry the bank sits on, so only magnitudes are allocated here.
  const splitTotals = useMemo(() => {
    const nisTotal = cjeAbsNumeric(formValues.amount);
    const fcTotal = cjeAbsNumeric(formValues.foreignCurrencyAmount);
    const rawRate = cjeGetRate(formValues);
    const rate = !isNaN(rawRate) && rawRate > 0 ? Math.abs(rawRate) : null;
    const currencyCode = cjeHasForeignCode(formValues)
      ? formValues.foreignCurrencyCode
      : null;

    const hasFcTotal = currencyCode != null && !isNaN(fcTotal) && fcTotal > 0;
    // A foreign split still needs a shekel total to spread over the rows; derive it from
    // the rate when the shekel field itself has not been filled in yet.
    const nis =
      !isNaN(nisTotal) && nisTotal > 0
        ? Number(nisTotal.toFixed(2))
        : hasFcTotal && rate
          ? Number((fcTotal * rate).toFixed(2))
          : 0;

    // Shekel shares are allocated as nisTotal * (rowFc / fcTotal), so the rate that
    // belongs on every split row is always nis/fc - never the representative fetch
    // (which defaults to 1 before it lands, and may disagree with the typed totals).
    const effectiveRate =
      hasFcTotal && nis > 0
        ? Number((nis / fcTotal).toFixed(CJE_MANUAL_RATE_DECIMALS))
        : rate ?? null;

    // The rows mirror the difference's sign so they read like the amount fields above,
    // even though only magnitudes take part in the allocation.
    const signedSource = !isNaN(nisTotal) && nisTotal > 0
      ? formValues.amount
      : formValues.foreignCurrencyAmount;

    return {
      isForeign: hasFcTotal && nis > 0,
      currencyCode,
      rate: effectiveRate,
      sign: cjeSignOf(signedSource),
      nisTotal: nis,
      fcTotal: hasFcTotal ? Number(fcTotal.toFixed(CJE_FC_AMOUNT_DECIMALS)) : 0,
      // What the rows are allocating against, in the unit the rows are typed in.
      target: hasFcTotal && nis > 0 ? Number(fcTotal.toFixed(CJE_FC_AMOUNT_DECIMALS)) : nis,
      decimals: hasFcTotal && nis > 0 ? CJE_FC_AMOUNT_DECIMALS : 2,
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    formValues.amount,
    formValues.foreignCurrencyAmount,
    formValues.foreignCurrencyCode,
    formValues.exchangeRate,
    formValues.exchangeRateType,
    cjeFCRate,
  ]);

  const splitTarget = splitTotals.target;
  const splitAllocated = splitRows.reduce(
    (sum, row) => sum + (cjeAbsNumeric(row.amount) || 0),
    0
  );
  const splitRemaining = Number((splitTarget - splitAllocated).toFixed(2));
  const isSplitSumValid = splitTarget > 0 && Math.abs(splitRemaining) < 0.01;
  const splitRowsHaveAmounts = splitRows.every((row) => cjeAbsNumeric(row.amount) > 0);
  const splitRowsHaveAccounts = splitRows.every((row) => !!row.counterAccount);
  const isSplitValid = isSplitSumValid && splitRowsHaveAmounts && splitRowsHaveAccounts;

  // Row amounts are typed in whichever unit the split is anchored in, so they have to
  // follow the dialog: picking a currency (or clearing it) re-expresses them through the
  // rate, and a changed difference re-seeds a single row with the whole amount. Without
  // this a row seeded in shekels would keep its shekel value after switching to USD and
  // could never add up to the foreign total.
  const splitUnitRef = useRef(null);
  useEffect(() => {
    if (!splitDifference) {
      splitUnitRef.current = null;
      return;
    }

    const previous = splitUnitRef.current;
    const current = {
      isForeign: splitTotals.isForeign,
      target: splitTotals.target,
      rate: splitTotals.rate,
      sign: splitTotals.sign,
    };
    splitUnitRef.current = current;
    if (!previous) return;

    const unitChanged = previous.isForeign !== current.isForeign;
    const targetChanged = Math.abs(previous.target - current.target) >= 0.005;
    const signChanged = previous.sign !== current.sign;
    if (!unitChanged && !targetChanged && !signChanged) return;

    const signed = (value) =>
      value ? (current.sign * value).toFixed(splitTotals.decimals) : "";

    setSplitRows((rows) => {
      // A single row can only ever hold the whole difference.
      if (rows.length === 1) {
        return [{ ...rows[0], amount: signed(current.target) }];
      }
      if (unitChanged && current.rate) {
        return rows.map((row) => {
          const magnitude = cjeAbsNumeric(row.amount);
          if (isNaN(magnitude) || magnitude === 0) return row;
          const converted = current.isForeign
            ? magnitude / current.rate
            : magnitude * current.rate;
          return { ...row, amount: signed(converted) };
        });
      }
      if (signChanged) {
        // Only the sign moved: keep each allocation, flip how it reads.
        return rows.map((row) => {
          const magnitude = cjeAbsNumeric(row.amount);
          if (isNaN(magnitude) || magnitude === 0) return row;
          return { ...row, amount: signed(magnitude) };
        });
      }
      return rows;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    splitDifference,
    splitTotals.isForeign,
    splitTotals.target,
    splitTotals.rate,
    splitTotals.sign,
  ]);

  // Turn the rows into the amounts each journal entry will carry. For a foreign split the
  // typed amount is the foreign one and the shekel share is proportional, with the last
  // row absorbing the rounding remainder so the shares always add up to the shekel total.
  const buildSplitAmounts = () => {
    const magnitudes = splitRows.map((row) => cjeAbsNumeric(row.amount) || 0);

    if (!splitTotals.isForeign) {
      return magnitudes.map((amount) => ({
        amount: Number(amount.toFixed(2)),
        foreignCurrencyAmount: null,
      }));
    }

    let allocatedNis = 0;
    return magnitudes.map((fcAmount, index) => {
      const isLastRow = index === magnitudes.length - 1;
      const nisShare = isLastRow
        ? Number((splitTotals.nisTotal - allocatedNis).toFixed(2))
        : Number(
            ((splitTotals.nisTotal * fcAmount) / splitTotals.fcTotal).toFixed(2)
          );
      allocatedNis = Number((allocatedNis + nisShare).toFixed(2));
      return {
        amount: nisShare,
        foreignCurrencyAmount: Number(fcAmount.toFixed(CJE_FC_AMOUNT_DECIMALS)),
      };
    });
  };




  const updateDenseTableTotalsForDateRange = async (rangeStart, rangeEnd) => {
    if (!client?.caseId || !selectedCardId) {
      setDenseTableCreditDebitRows([{}]);
      setFinsiteBalanceRows([]);
      setFinsiteDiffRows([]);
      return;
    }

    // An account balance is only comparable to the bank's own balance when it
    // accumulates from the beginning, so the totals always run from the epoch
    // up to the end of the selected period. Same convention as Bank Statements.
    const formattedStartDate = BALANCE_EPOCH;
    const formattedEndDate = endOfUtcDay(rangeEnd);

    try {
      const response = await ExternalTransactionsService.GetExternalTransactionsByDateRange(
        client.caseId,
        formattedStartDate,
        formattedEndDate,
        selectedCardId,
        token
      );
      if (response.ok) {
        const data = await response.json();
        // Credit (זכות) carries the positive side, Debit (חובה) the negative
        // one, matching how the transaction rows are displayed.
        const xtramBalance = data.balance ?? 0;
        const xtramCredit = data.debitAccountAmount ?? 0;
        const xtramDebit = data.creditAccountAmount ?? 0;
        setDenseTableCreditDebitRows([{
          balance: beautifyNumber(xtramBalance),
          credit: beautifyNumber(xtramCredit),
          debit: beautifyNumber(xtramDebit),
        }]);
        refreshFinsiteBalances(
          selectedCardId,
          formattedStartDate,
          formattedEndDate,
          { balance: xtramBalance, credit: xtramCredit, debit: xtramDebit }
        );
      } else {
        setDenseTableCreditDebitRows([{}]);
        setFinsiteBalanceRows([]);
        setFinsiteDiffRows([]);
        const errorMessage = await response.text();
        console.error("Error fetching date-range summary:", errorMessage);
      }
    } catch (error) {
      setDenseTableCreditDebitRows([{}]);
      setFinsiteBalanceRows([]);
      setFinsiteDiffRows([]);
      console.error("Error fetching date-range summary:", error);
    }
  };

  const refreshDataForDates = async (rangeStart, rangeEnd, range = isRange) => {
    const { start, end } = getFetchDateRange(fetchType, rangeStart, rangeEnd, range);
    if (fetchType === "Matched") {
      await fetchMatchDataOnDateRangeChange(start, end, isMatchDate);
    } else {
      await fetchNotMatchDataOnDateRangeChange(start, end);
    }
    await updateDenseTableTotalsForDateRange(start, end);
  };

  const applyPeriod = async (start, end, range = isRange) => {
    localStorage.setItem("StartDate", start.toISOString());
    localStorage.setItem("EndDate", end.toISOString());
    setStartDate(start);
    setEndDate(end);
    await refreshDataForDates(start, end, range);
  };

  const handlePeriodYearChange = async (year) => {
    if (!Number.isFinite(year)) return;
    const { start, end } = yearBounds(year);
    await applyPeriod(start, end);
  };

  const handlePeriodStartChange = async (newValue) => {
    const next = startOfUtcDay(new Date(newValue));
    if (isNaN(next.getTime())) return;
    // Keep the range valid rather than rejecting the pick.
    const end = next > endDate ? endOfUtcDay(next) : endDate;
    await applyPeriod(next, end);
  };

  const handlePeriodEndChange = async (newValue) => {
    const next = endOfUtcDay(new Date(newValue));
    if (isNaN(next.getTime())) return;
    const start = next < startDate ? startOfUtcDay(next) : startDate;
    await applyPeriod(start, next);
  };

  const handlePeriodModeChange = async (mode) => {
    const nextIsRange = mode === PERIOD_MODE.RANGE;
    if (nextIsRange === isRange) return;

    localStorage.setItem("IsRange", String(nextIsRange));
    setIsRange(nextIsRange);

    if (nextIsRange) {
      // Restore the range the user last worked with, if there was one.
      const { start, end } = lastRangeRef.current.start
        ? lastRangeRef.current
        : { start: startDate, end: endDate };
      await applyPeriod(start, end, true);
      return;
    }

    lastRangeRef.current = { start: startDate, end: endDate };
    const { start, end } = yearBounds(endDate.getUTCFullYear());
    await applyPeriod(start, end, false);
  };

  const handleMatchDateToggle = async () => {
    const next = !isMatchDate;
    setIsMatchDate(next);
    localStorage.setItem("BankMatchingIsMatchDate", String(next));
    if (fetchType === "Matched") {
      const { start, end } = getFetchDateRange();
      await fetchMatchDataOnDateRangeChange(start, end, next);
    }
  };

  const handleChangeCreateBank = (field, value) => {

    if (field === "bankBranch") {
      setBankBranch(value);
    } else if (field === "bankAccountNumber") {
      setBankAccountNumber(value);
    } else if (field === "foreignCurrencyCode") {
      setForeignCurrencyCode(value ?? null);
    }
  };

  async function fetchMatchDataOnDateRangeChange(
    startDate,
    endDate,
    isMatchDate
  ) {
    setLoading(true);
    const formattedStartDate = startDate;
    const formattedEndDate = endDate;

    try {
      const externalMatchResponse =
        await ExternalTransactionsService.GetMatchedbyDateRange(
          client.caseId,
          formattedStartDate,
          formattedEndDate,
          selectedCardId,
          isMatchDate,
          token
        );

      if (externalMatchResponse.ok) {
        const externalMatchData = await externalMatchResponse.json();

        // Update matchData state
        setMatchData(externalMatchData);
      }
    } catch (error) {
      console.error("Error fetching match data:", error);
    }

    setLoading(false);
  }
  const handleRemoveBank = async () => {
    const result = await Swal.fire({
      title: t('AreYouSure'),
      text: t('DeleteBankConfirmation'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: t('YesDeleteIt'),
      cancelButtonText: t('No'),
      customClass: {
        container: 'swal-high-zindex'
      }
    });

    if (result.isConfirmed) {
      try {
        const response = await EnumsService.DeleteTBank(
          client.caseId,
          bankAccountNumber,
          selectedBankForCreate.value,
          token
        );
        if (response.ok) {
          toast.success(t('BankDeletedSuccessfully'));
          fetchEnums(user, token, client);
          handleCloseCreateModal();
        } else {
          toast.error(t("BankFailedToDelete"));
        }
      } catch (error) {
        console.error("BankFailedToDelete");
        toast.error(t("BankFailedToDelete"));
      }
    }
  };

  const handleDeleteSelectedBanks = async (selectedIndices) => {
    if (!selectedIndices || selectedIndices.length === 0) {
      return;
    }

    const banksToDelete = selectedIndices
      .map((index) => tBanksData[index])
      .filter(Boolean);

    if (banksToDelete.length === 0) {
      return;
    }

    const result = await Swal.fire({
      title: t('AreYouSure'),
      text: `${t('DeleteBankConfirmation')} (${banksToDelete.length})`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: t('YesDeleteIt'),
      cancelButtonText: t('No'),
      customClass: {
        container: 'swal-high-zindex'
      }
    });

    if (!result.isConfirmed) {
      return;
    }

    setLoading(true);
    try {
      const responses = await Promise.all(
        banksToDelete.map((bank) =>
          EnumsService.DeleteTBank(
            client.caseId,
            bank.accountNumber,
            bank.bankCode,
            token
          )
        )
      );

      const failedCount = responses.filter((response) => !response.ok).length;

      if (failedCount === 0) {
        toast.success(t('BankDeletedSuccessfully'));
      } else if (failedCount === banksToDelete.length) {
        toast.error(t('BankFailedToDelete'));
      } else {
        toast.warn(`${t('BankFailedToDelete')} (${failedCount}/${banksToDelete.length})`);
      }

      await fetchEnums(user, token, client);
    } catch (error) {
      console.error('Error deleting banks:', error);
      toast.error(t('BankFailedToDelete'));
    }
    setLoading(false);
  };

  async function fetchNotMatchDataOnDateRangeChange(startDate, endDate) {
    setLoading(true);
    const formattedStartDate = new Date(
      Date.UTC(startDate.getUTCFullYear(), startDate.getUTCMonth(), 1)
    );
    const formattedEndDate = new Date(
      Date.UTC(endDate.getUTCFullYear(), endDate.getUTCMonth() + 1, 0, 23, 59, 59)
    );
    try {
      const internalResponse =
        await DocumentService.GetInternalByAccountCodeIdDateRange(
          client.caseId,
          formattedStartDate,
          formattedEndDate,
          selectedCardId,
          token,
          selectedTBank.foreignCurrencyCode != null ? true : false,
        );
      const externalResponse =
        await ExternalTransactionsService.GetNotMatchedbyDateRange(
          client.caseId,
          formattedStartDate,
          formattedEndDate,
          selectedCardId,
          token
        );

      if (internalResponse.ok && externalResponse.ok) {
        const internalData = await internalResponse.json();
        const externalData = await externalResponse.json();

        // Mapping internal rows
        const formattedInternalRows = internalData.map((row, index) => ({
          id: row.id,
          paymentAcceptanceId: row.paymentAcceptanceId,
          description: row.description,
          reference: row.reference,
          reference2: row.reference2,
          amount: beautifyNumber(row.amount),
          amount1: row.amount,
          documentDate: row.documentDate ? formatDate(row.documentDate) : '',
          subRows: row.subRows || [],  // Optional: Handle subRows if available
          type: row.type,
          foreignCurrencyCode: row.foreignCurrencyCode,
          foreignCurrencyAmount: row.foreignCurrencyAmount
        }));

        // Mapping external rows
        const formattedExternalRows = externalData.map((row) => ({
          id: row.id,
          caseId: row.caseId,
          description: row.description,
          reference: row.reference,
          reference1: row.reference,
          amount: beautifyNumber(row.amount),
          amount1: row.amount,
          transactionDate: formatDate(row.transactionDate),
          transactionDateRaw: row.transactionDate,
          matchNumber: row.matchNumber,
          documentUrl: row.documentUrl,
        }));

        setInternalRows(formattedInternalRows);
        setExternalRows(formattedExternalRows);
        setSortedTransactions(formattedInternalRows);
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
    }

    setLoading(false);
  }

  const handleChangeBankForCreate = (value) => {
    setSelectedBankForCreate(value);
  };

  const handleOpenCreateModal = () => {
    setCreateBankModal(true);
  };

  const handleCloseCreateModal = () => {
    setCreateBankModal(false);
    setSelectedBankForCreate(null);
    setBankBranch("");
    setBankAccountNumber("");
    setIsEditingBank(false);
    setCardForNewBank(null)

  };

  const handleAddBank = async () => {
    try {
      const bankName =
        Constants.BankNames[parseInt(selectedBankForCreate.value)];
      const bankCode = selectedBankForCreate.value;

      if (!selectedBankForCreate || !bankBranch || !bankAccountNumber) {
        toast.error(t("PleaseFillAllFields"));
        return;
      }

      const response = await EnumsService.AddTBank(
        client.caseId,
        bankName,
        bankCode,
        bankBranch,
        bankAccountNumber,
        foreignCurrencyCode,
        cardForNewBank.toString(),
        token
      );
      if (response.ok) {
        toast.success(t("BankAccountAddedSuccessfully"));
        fetchEnums(user, token, client);
        handleCloseCreateModal();
      } else {
        toast.error(t("FailedToAddBankAccount"));
      }
    } catch (error) {
      console.error(error);
      toast.error(t("ErrorAddingBankAccount"));
    }
  };
  const [oldBank, setOldBank] = useState(null);

  const handleEditBank = async () => {
    try {
      const bankName =
        Constants.BankNames[parseInt(selectedBankForCreate.value)];
      const bankCode = selectedBankForCreate.value;

      if (!selectedBankForCreate || !bankBranch || !bankAccountNumber) {
        toast.error(t("PleaseFillAllFields"));
        return;
      }

      if (!oldBank) {
        toast.error(t("OldBankDataNotFound"));
        return;
      }

      const hadForeignCurrency = oldBank.foreignCurrencyCode != null;
      const removingForeignCurrency =
        hadForeignCurrency && foreignCurrencyCode == null;

      const response = await EnumsService.EditTBank(
        client.caseId, // Use the CaseId from the edited bank
        oldBank.bankCode, // Old bank code
        oldBank.accountNumber, // Old account number
        bankName, // New bank name
        bankCode, // New bank code
        bankBranch, // New branch number
        bankAccountNumber, // New account number
        foreignCurrencyCode,
        cardForNewBank.toString(),
        token // Authorization token
      );

      if (response.ok) {
        if (removingForeignCurrency) {
          const convertRes =
            await ExternalTransactionsService.ConvertForeignAmountsToAmount(
              client.caseId,
              cardForNewBank.toString(),
              token
            );
          if (!convertRes.ok) {
            toast.error(t("ErrorUpdatingBankAccount"));
            fetchEnums(user, token, client);
            if (String(selectedCardId) === String(cardForNewBank)) {
              await FetchData();
            }
            handleCloseCreateModal();
            return;
          }
        }

        if (
          removingForeignCurrency &&
          String(selectedCardId) === String(cardForNewBank)
        ) {
          await FetchData();
        }

        toast.success(t("BankAccountUpdatedSuccessfully"));
        fetchEnums(user, token, client); // Fetch updated data
        handleCloseCreateModal(); // Close the modal
      } else {
        toast.error(t("FailedToUpdateBankAccount"));
      }
    } catch (error) {
      console.error(error);
      toast.error(t("ErrorUpdatingBankAccount"));
    }
  };

  const handleAddOrEditBank = async () => {
    if (isEditingBank && editedBank) {
      await handleEditBank();
    } else {
      await handleAddBank();
    }
  };

  const [addingJournalEntryToMatch, setAddingJournalEntryToMatch] = useState(false);

  const handleConfirm = async () => {
    if (createJournalEntries === true) {

      // Case 2: Checked is true
      const selectedRows = externalDisplayedRows.filter((row) =>
        selectedExternalRows.includes(row.id)
      );

      const isForeignBank = selectedTBank?.foreignCurrencyCode != null;
      const fcCode = selectedTBank?.foreignCurrencyCode ?? null;

      // For a foreign-currency bank each transaction's amount is expressed in the
      // foreign currency. We keep that as the FC amount and derive the NIS (shekel)
      // amount from the representative rate on the transaction date, so every created
      // journal entry carries both values (mirroring the create-in-difference flow).
      let rateByDate = {};
      if (isForeignBank) {
        setLoading(true);
        try {
          const uniqueDates = [
            ...new Set(
              selectedRows.map(
                (row) =>
                  new Date(parseCustomDate(row.transactionDate))
                    .toISOString()
                    .split("T")[0]
              )
            ),
          ];
          const rates = await Promise.all(
            uniqueDates.map((d) =>
              ForeignCurrencyService.GetIlsRateForDate(fcCode, d, token)
                .then((r) => ({ d, r }))
                .catch(() => ({ d, r: null }))
            )
          );
          rateByDate = rates.reduce((acc, { d, r }) => {
            acc[d] = r;
            return acc;
          }, {});
        } catch (err) {
          console.error(err);
          toast.error(t("CurrencyRateFetchError"));
        } finally {
          setLoading(false);
        }
      }

      const journalEntries = selectedRows.map((row) => {
        const amount = parseFloat(row.amount1);
        const isNegative = amount < 0;

        const transactionDate = new Date(parseCustomDate(row.transactionDate))
          .toISOString()
          .split("T")[0];
        const description = row.description;
        const reference = row.reference || "";

        const perRowMonthSource = usePerRowReportingMonth
          ? new Date(parseCustomDate(row.transactionDate))
          : null;

        const baseEntry = {
          creditAccount: isNegative ? selectedCardId : formValues.accountCard,
          debitAccount: isNegative ? formValues.accountCard : selectedCardId,
          description,
          reference,
          documentDate: transactionDate,
          reportingMonthDate: (() => {
            const d = setReportingMonthToDay10(
              perRowMonthSource || formValues.reportingMonthDate || reportingMonthDate
            );
            return d ? `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}` : "";
          })(),
          registrationMonthDate: (() => {
            const d = setReportingMonthToDay10(
              perRowMonthSource || formValues.registrationMonthDate || formValues.reportingMonthDate || reportingMonthDate
            );
            return d ? `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}` : "";
          })(),
          sortCodeId: formValues.sortCode || null,
          externalId: row.id,
          vat: formValues.vat || 0
        };

        if (isForeignBank) {
          const fcAmount = parseFloat(
            Math.abs(amount).toFixed(CJE_FC_AMOUNT_DECIMALS)
          );
          const rate = rateByDate[transactionDate];
          const hasRate = rate != null && rate > 0;
          const nisAmount = hasRate
            ? parseFloat((fcAmount * rate).toFixed(2))
            : fcAmount;
          return {
            ...baseEntry,
            amount: nisAmount,
            foreignCurrencyAmount: fcAmount,
            foreignCurrencyCode: fcCode,
            exchangeRate: hasRate ? rate : null,
            exchangeRateType: Constants.ExchangeRateType.Representative,
            bankIsForeign: true,
            // The match reconciles on the FC amount for a foreign bank; keep the
            // original value so edits to the shekel amount never break the match.
            matchAmount: fcAmount,
          };
        }

        const nisAmount = parseFloat(Math.abs(amount).toFixed(2));
        return {
          ...baseEntry,
          amount: nisAmount,
          foreignCurrencyAmount: null,
          foreignCurrencyCode: null,
          exchangeRate: null,
          exchangeRateType: null,
          bankIsForeign: false,
          // The match reconciles on the NIS amount for a non-foreign bank.
          matchAmount: nisAmount,
        };
      });


      // Show the journal entries as card list
      setJournalEntriesList(journalEntries);
      setIsJournalEntriesListOpen(true);

      // Close the initial dialog
      setIsCreateDialogOpen(false);
    } else if (splitDifference) {
      // Single difference split into several separate journal entries.
      // Bank account stays on a fixed side (based on the difference sign);
      // each split row provides its own amount + counter-account.
      const isNegative = Number(cjeParseNumeric(formValues.amount)) < 0;
      const fmtMonth = (d) => {
        const x = setReportingMonthToDay10(
          d ? (d instanceof Date ? d : new Date(d)) : new Date()
        );
        return x
          ? `${x.getFullYear()}-${String(x.getMonth() + 1).padStart(2, "0")}-${String(
              x.getDate()
            ).padStart(2, "0")}`
          : "";
      };
      const documentDate = formValues.documentDate
        ? new Date(formValues.documentDate).toISOString().split("T")[0]
        : new Date().toISOString().split("T")[0];
      const vat = returnProperVatBySortId(formValues.sortCodeId);

      // Row amounts are allocated first (shekel shares for a foreign split), then each
      // share is paired with its row's counter account.
      const splitAmounts = buildSplitAmounts();
      const bankIsForeign = isCjeForeignBank();

      const journalEntries = splitRows.map((row, index) => {
        const { amount: nisAmount, foreignCurrencyAmount } = splitAmounts[index];
        const isForeignEntry = splitTotals.isForeign && foreignCurrencyAmount != null;
        return {
          amount: nisAmount,
          creditAccount: isNegative ? selectedCardId : row.counterAccount,
          debitAccount: isNegative ? row.counterAccount : selectedCardId,
          description: formValues.description,
          reference: formValues.reference,
          documentDate,
          reportingMonthDate: fmtMonth(formValues.reportingMonthDate),
          registrationMonthDate: fmtMonth(
            formValues.registrationMonthDate || formValues.reportingMonthDate
          ),
          sortCodeId: formValues.sortCodeId || null,
          externalId: null,
          vat,
          foreignCurrencyAmount: isForeignEntry ? foreignCurrencyAmount : null,
          foreignCurrencyCode: isForeignEntry ? splitTotals.currencyCode : null,
          // One (positive) rate for the whole split, derived from the totals that drove
          // the allocation. Per-row resolve would drift by a cent on the last row's
          // remainder; using the shared rate keeps every entry consistent on save.
          exchangeRate: isForeignEntry
            ? cjeResolveSavedRate(
                splitTotals.nisTotal,
                splitTotals.fcTotal,
                splitTotals.rate
              )
            : null,
          exchangeRateType: isForeignEntry
            ? Constants.ExchangeRateType.Manual
            : null,
          bankIsForeign: isForeignEntry && bankIsForeign,
          // Each split row is its own match unit. A foreign bank reconciles on the foreign
          // amount, everything else on the shekel amount; keeping matchAmount aligned also
          // stops the preview/finalize guards from treating a missing value as 0.
          matchAmount:
            isForeignEntry && bankIsForeign ? foreignCurrencyAmount : nisAmount,
        };
      });

      setJournalEntriesList(journalEntries);
      setIsJournalEntriesListOpen(true);
      setIsCreateDialogOpen(false);
    } else {

      setIsCreateDialogOpen(false);
      await handleCreateJournalEntry();
    }
  };

  const returnProperVatBySortId = (mySortCodeId) => {
    let newVat = 100;

    const name = sortCodeIdOptions.find(
      (option) => option.value === mySortCodeId
    )?.label || '';
    // Extract the name without the parentheses

    const nameWithoutParentheses = name.replace(/\s*\(.*?\)\s*/, '').trim();
    // Check for a number within parentheses
    const match = name.match(/\((\d+)%?/);
    const customVat = match ? parseInt(match[1], 10) : null;

    const sortCode = sortCodeIdOptions.find(sc => sc.sortCodeId === mySortCodeId);
    // Determine the VAT based on the name without parentheses
    if (Constants.SortCodesWith66Vat.includes(nameWithoutParentheses)) {
      newVat = Constants.Vat66;
    } else if (Constants.SortCodesWithZeroVat.includes(nameWithoutParentheses) || sortCode?.sortCodeVatType === 0) {
      newVat = 0;
    } else if (Constants.SortCodesWith16Vat.includes(nameWithoutParentheses)) {
      newVat = 16;
    } else if (customVat !== null) {
      // If a custom VAT was found, use it
      newVat = customVat === Constants.Vat66 ? Constants.Vat66 : customVat;
    } else {
      // Default VAT if no special conditions are met
      newVat = 100;
    }
    return newVat; // Return the determined VAT
  };


  const [rawSortCodes, setRawSortCodes] = useState([]);
  const [aiOpen, setAiOpen] = useState(false);
  const [aiLoading, setAiLoading] = useState(false);
  const [aiResult, setAiResult] = useState(null);
  const [aiError, setAiError] = useState(null);
  const [aiPrompt, setAiPrompt] = useState("");
  const aiAbortRef = useRef(null);

  const handleAiSuggest = async ({ prompt, useSelection }) => {
    if (!selectedCardId || aiLoading) return;
    // Same month-widened window the unmatched lists are loaded with.
    const { start, end } = getFetchDateRange();
    const rangeStart = new Date(Date.UTC(start.getUTCFullYear(), start.getUTCMonth(), 1));
    const rangeEnd = new Date(Date.UTC(end.getUTCFullYear(), end.getUTCMonth() + 1, 0, 23, 59, 59));

    aiAbortRef.current?.abort();
    const controller = new AbortController();
    aiAbortRef.current = controller;

    setAiPrompt(prompt);
    setAiResult(null);
    setAiError(null);
    setAiOpen(true);
    setAiLoading(true);
    try {
      const result = await BankMatchAiService.Suggest(
        {
          caseId: client.caseId,
          accountCodeId: selectedCardId,
          startDate: rangeStart.toISOString(),
          endDate: rangeEnd.toISOString(),
          prompt,
          externalIds: useSelection ? selectedExternalRows : null,
          internalIds: useSelection ? selectedInternalRows : null,
        },
        token,
        controller.signal
      );
      if (!controller.signal.aborted) setAiResult(result);
    } catch (err) {
      if (err?.name !== "AbortError") setAiError(err?.message || t("AiSuggestFailed"));
    } finally {
      if (aiAbortRef.current === controller) {
        aiAbortRef.current = null;
        setAiLoading(false);
      }
    }
  };

  const handleAiModalClose = async (changed) => {
    aiAbortRef.current?.abort();
    aiAbortRef.current = null;
    setAiLoading(false);
    setAiOpen(false);
    if (changed) {
      handleClearMatches();
      await FetchData();
    }
  };

  const handleCreateJournalEntry = async () => {
    setLoading(true);

    // Foreign currency: prefer the explicit selection in the dialog. Fall back to the
    // bank transaction's currency for back-compat when the user hasn't touched the
    // new dropdown.
    const fcCode =
      formValues.foreignCurrencyCode != null && formValues.foreignCurrencyCode !== ''
        ? formValues.foreignCurrencyCode
        : (selectedTBank?.foreignCurrencyCode ?? null);
    const isForeign = fcCode != null && fcCode !== '';

    const payload = buildBankMatchJournalPayload({
      caseId: client.caseId,
      accountantId: client.accountantId,
      sortCodeId: formValues.sortCodeId,
      reference: formValues.reference,
      description: formValues.description,
      amount: formValues.amount,
      documentDate: formValues.documentDate,
      reportingMonthDate: formValues.reportingMonthDate,
      registrationMonthDate: formValues.registrationMonthDate,
      creditAccount: formValues.creditAccount,
      debitAccount: formValues.debitAccount,
      vat: returnProperVatBySortId(formValues.sortCodeId),
      foreignCurrencyCode: isForeign ? fcCode : null,
      foreignCurrencyAmount: isForeign ? formValues.foreignCurrencyAmount : null,
      // The representative rate is only a starting point in the dialog; whatever rate
      // produced the shekel amount on screen is stored as a manual snapshot.
      exchangeRate: isForeign
        ? cjeResolveSavedRate(
            formValues.amount,
            formValues.foreignCurrencyAmount,
            formValues.exchangeRate ?? cjeGetRate(formValues)
          )
        : null,
    });

    try {
      const response = await DocumentService.UploadDocumentPayload(
        "JournalEntries",
        payload,
        token
      );

      if (response.ok) {
        const data = await response.json(); // Parse the response as JSON
        const newJournalEntryId = data.journalEntryId; // Extract the ID from the response

        // Update selectedInternalRows
        const updatedSelectedInternalRows = [...selectedInternalRows, newJournalEntryId];
        setSelectedInternalRows(updatedSelectedInternalRows);

        // Create new journal entry object
        const newJournalEntry = {
          id: newJournalEntryId,
          type: "JournalEntries",
        };

        // Update displayedRows with the new journal entry
        const updatedDisplayedRows = [...displayedRows, newJournalEntry];
        // setDisplayedRows(updatedDisplayedRows);

        // Call handleMatch2 with updated rows
        await handleMatch2(
          updatedSelectedInternalRows,
          selectedExternalRows,
          updatedDisplayedRows,
          externalRows
        );

        // Optionally clear matches and fetch updated data
        handleClearMatches();
        await FetchData();

        // Perform cleanup or additional logic
        await ClientDocumentCountService.removeDocumentByTypeAndId(
          client.caseId,
          client.accountantId,
          "JournalEntries",
          newJournalEntryId, token
        );

        toast.success(t("documentUploadSuccess"));
      } else {
        const errorText = await response.text();
        toast.error(t("documentUploadError", { errorText }));
        return false;
      }
    } catch (error) {
      toast.error(
        t("documentUploadError", { errorText: "Error uploading document" })
      );
      return false;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (addingJournalEntryToMatch) {
      if (shouldMatch && displayedRows.length > 0 && selectedInternalRows.length > 0) {
        handleMatch(selectedInternalRows); // Pass updated internal rows
        setShouldMatch(false); // Reset the flag after calling handleMatch
        setAddingJournalEntryToMatch(false);
      }
    } else {

      if (shouldMatch && displayedRows.length > 0) {
        handleMatch(selectedInternalRows); // Pass updated internal rows
        setShouldMatch(false); // Reset the flag after calling handleMatch
      }
    }
  }, [displayedRows, addingJournalEntryToMatch, shouldMatch]);

  // Step 3: Function to handle what happens after state update
  const afterStateUpdate = async (updatedRows) => {
    setFormValues({
      confirmationNumber: "",
      accountCaseId: "",
      reference: "",
      description: "",
      documentDate: "",
      reportingMonthDate: "",
      registrationMonthDate: "",
      amount: "",
      vat: 0,
      sortCodeId: "3",
      creditAccount: "",
      debitAccount: "",
      sortCode: "3",
      accountCard: "",
      foreignCurrencyCode: null,
      foreignCurrencyAmount: null,
      exchangeRateType: null,
      exchangeRate: null,
    });
    cjeResetCurrencyInputs();

    // Fetch the data and wait for it to complete
    await FetchData();

    setLoading(false);
  };
  const selectedDenseTableRow = async (index) => {
    setSelectedTBank(tBanksData[index]);
    setSelectedTBankIndex(index);
    if (index !== -1 && tBanksData[index]) {
      setSelectedCardId(tBanksData[index].cardId);
    } else {
      console.warn('Invalid index or data not found');
    }

    const cardIndexForAdv = processedCardsData.findIndex(
      (item) => item.cardId === tBanksData[index].cardId
    );

    if (cardIndexForAdv !== -1) {
      // If cardId is found
      const updatedMainCard = {
        ...processedCardsData[cardIndexForAdv],
        index: cardIndexForAdv,
      }; // Add the index to mainCard
      setMainCard(updatedMainCard); // Set the updated mainCard with the index
      setSelectedFormattedAccountCard(processedCardsData[cardIndexForAdv]);
    } else {
      // setMainCard(-1);
      // toast.info(t('NonBankAccountCardSelected'));
    }
  };
  const [isEditingBank, setIsEditingBank] = useState(false);
  const [editedBank, setEditedBank] = useState(false);
  const [selectedBankAccount, setSelectedBankAccount] = useState(null);

  const handleOpenEditTBank = (index) => {
    const selectedBankData = tBanksData[index]; // Get the selected bank data from tBanksData

    setOldBank(selectedBankData);
    // Find the bank option that matches the selected bank's bankCode
    const selectedBank = bankOptions.find(
      (bank) => bank.value === selectedBankData.bankCode
    );

    setSelectedBankForCreate(selectedBank);
    setEditedBank(selectedBankData); // Set the entire bank data for editing

    // Set other values for editing
    setBankBranch(selectedBankData.branchNumber);
    setBankAccountNumber(selectedBankData.accountNumber);
    setCardForNewBank(selectedBankData.cardId);
    setForeignCurrencyCode(selectedBankData.foreignCurrencyCode);
    setIsEditingBank(true);

    setCreateBankModal(true); // Open the modal
  };

  useEffect(() => {
    if (selectedCardId && client) {
      FetchData()
    }
  }, [selectedCardId]);

  const FetchData = async () => {
    const { start, end } = getFetchDateRange();
    if (fetchType === "Matched") {
      await fetchMatchDataOnDateRangeChange(start, end, isMatchDate);
    } else {
      await fetchNotMatchDataOnDateRangeChange(start, end);
    }
    await updateDenseTableTotalsForDateRange(start, end);
  };
  useEffect(() => {

    if (mainCard) {


      // setSelectedCardId(mainCard.cardId);
      const cardIndex = tBanksData.findIndex(
        (item) => item.cardId?.toString() === mainCard.cardId.toString()
      );

      if (cardIndex !== -1) {
        setSelectedTBankIndex(cardIndex);
      } else {
        setSelectedTBankIndex(-1);
        // toast.info(t('NonBankAccountCardSelected'));
      }
    }
  }, [mainCard]);

  // Calculate the sum of amounts from selected rows
  const calculateSum = (rows, selectedIds) => {
    return rows
      .filter((row) => selectedIds.includes(row.id))
      .reduce((sum, row) => sum + (row.amount1 || 0), 0);
  };

  // Effect to update sums when row selection changes
  useEffect(() => {
    const externalSumValue = calculateSum(
      externalDisplayedRows,
      selectedExternalRows
    );
    const internalSumValue = calculateSum(displayedRows, selectedInternalRows);
    setExternalSum(externalSumValue);
    setInternalSum(internalSumValue);
  }, [selectedExternalRows, selectedInternalRows]);


  const [assets, setAssets] = useState([]);


  const [showAddGroupModal, setShowAddGroupModal] = useState(false);
  const [assetGroups, setAssetGroups] = useState([]);

  const handleOpenGroudAdd = () => {
    setShowAddGroupModal(true);
  }



  const fetchEnums = async (user, token, client) => {
    setLoading(true);
    try {
      const tBanks = await EnumsService.GetAllTBanksByCaseId(
        client.caseId,
        token
      );
      const accountCardsResponse = await EnumsService.GetAccountCardsByCaseId(
        client.caseId,
        token
      );
      const accountCardsData = await accountCardsResponse.json();

      const tBanksRows = tBanks.map((bank) => [
        // Show currency label and symbol, e.g., 'USD ($)'
        (() => {
          const currencyObj = currencyOptions.find(o => o.value === bank.foreignCurrencyCode);
          const code = currencyObj?.label;
          const symbol = Constants.ForeignCurrencySymbol[code] || '';
          return code ? `${code}${symbol ? ' (' + symbol + ')' : ''}` : '-';
        })(),
        bank.bankCode || '-',
        bank.bankName || '-',
        bank.branchNumber || '-',
        bank.accountNumber || '-',
        bank.cardId || '-',
        null, // Finsite status filled after eligibility loads
      ]);

      const assetGroupResponse = await AssetService.GetAllAssetGroups(client?.caseId, token);
      if (assetGroupResponse.success) {
        setAssetGroups(assetGroupResponse.data);
      } else {
        toast.error(t('FailedToFetchAssets'));
      }

      //processed account cards data
      if (accountCardsData && accountCardsData.length > 0) {
        const transformedData = accountCardsData.map((card) => ({
          ...card,
          value: card.cardId, // Set value to cardId
          label: `${card.cardId} - ${card.name} `, // Set label to name
        }));
        setProcessedCardsData(transformedData);
      }
      const accountCardOptions = [{ name: t('AddAccountCard'), value1: 'AddItem' }, ...accountCardsData];
      setAccountCardOptionsForBank(accountCardOptions);
      setDenseTableRows(tBanksRows);
      setTBanksData(tBanks);
      setAccountCardsData(accountCardsData);

      // Fetching sortCodeIdOptions
      const codeIdResponse = await EnumsService.GetSortCodesByAccountantId(
        client.accountantId,
        token
      );
      if (codeIdResponse.ok) {
        const codeIdData = await codeIdResponse.json();


        setRawSortCodes(codeIdData);
        const sortCodeOptions = codeIdData.map((sortCode) => ({
          ...sortCode,
          label: `${sortCode.sortCodeId} - ${sortCode.sortCodeName}`,
          value: sortCode.sortCodeId, // Use cardId as the value
        }));
        setSortCodeIdOptionsForEditModals(codeIdData);
        setSortCodeIdOptions(sortCodeOptions); // Assuming codeIdData is already in the correct format
      }

      const assetResponse = await AssetService.GetAllAssets(client?.caseId, token);
      if (assetResponse.success) {
        setAssets(assetResponse.data);
      } else {
        toast.error(t('FailedToFetchAssets'));
      }


      // Fetching creditAccountOptions and debitAccountOptions
      const accountsResponse = await EnumsService.GetAccountCardsByCaseId(
        client.caseId,
        token
      );
      if (accountsResponse.ok) {
        const accountsData = await accountsResponse.json();

        // Map accountsData to extract name and cardId
        const accountOptions = accountsData.map((account) => ({
          label: `${account.cardId} - ${account.name}`,
          value: account.cardId, // Use cardId as the value
        }));



        setCreditAccountOptions(accountOptions);
        setDebitAccountOptions(accountOptions); // Assuming both options are the same
        setAccountCardEditDownloadOptions(accountOptions);

        const accountCardOptionsEdit = [
          { name: t("AddAccountCard"), value1: "AddItem" },
          ...accountsData,
        ];
        setEditModalsAccountCardOptions(accountCardOptionsEdit);

        setAccountCardOptions(accountCardOptionsEdit);
      }
      const palCodesResponse = await EnumsService.GetPalCodesByAccountantId(
        client.accountantId,
        token
      );
      // Process palCodes if response is okay
      if (palCodesResponse.ok) {
        const palCodesData = await palCodesResponse.json();
        const formattedPalCodes = palCodesData.map((palCode) => ({
          label: palCode.palCodeId,
          value: palCode.palCodeId,
        }));

        setFormattedPalCodeOptions(formattedPalCodes);
      }

      setIsClientDataFetched(true);
    } catch (error) {
      console.error(error);
      toast.error(t("fetchEnumsError"), error);
      setIsClientDataFetched(false);
    }
    setLoading(false);
  };

  const [bankFromBankPage, setBankFromBankPage] = useState(-1);
  const [previosPage, setPreviosPage] = useState(null);
  useEffect(() => {
    const fetchUserData = async () => {
      setLoading(true);
      try {
        const currentUser = await UserService.getCurrentUser();
        const currentToken = await UserService.getCurrentToken();
        if (currentUser && currentToken) {
          setUser(currentUser);
          setToken(currentToken);

          // Get client data from location.state
          if (location.state && location.state.client && location.state.type) {
            setType(location.state.type);
            setClient(location.state.client);

          }

          if (!isNaN(Number(location.state.selectedTBankIndex)) && bankFromBankPage === -1) {

            setBankFromBankPage(location.state.selectedTBankIndex);
          }

          if (location.state.previosPage) {
            setPreviosPage(location.state.previosPage);
          }

          await fetchEnums(currentUser, currentToken, location.state.client);
          // Fetch financial data for the current date on initial load only
        } else {
          navigate("/login");
        }
      } catch (error) {
        // Handle error - maybe navigate to login or show a message
      }
      setLoading(false);
    };
    fetchUserData();
  }, []);

  useEffect(() => {
    if (bankFromBankPage !== -1 && denseTableRows) {
      setSelectedBankAccount(bankFromBankPage);
      const matchingBank = denseTableRows[bankFromBankPage]
      selectedDenseTableRow(bankFromBankPage);
    }
  }, [bankFromBankPage, denseTableRows, tBanksData]);



  const filteredAndSortedData = useMemo(() => {
    if (accountCardsData.length <= 0) {
      return [];
    }

    const query = searchQuery.toLowerCase();
    // Apply filtering and scoring
    if (accountCardsData.length <= 0) {
      return [];
    }
    const scoredData = accountCardsData
      .filter((item) => {
        // Basic filtering to remove irrelevant items
        return (
          item?.cardId?.toString()?.includes(query) ||
          item?.caseId?.toString()?.includes(query) ||
          item?.accountCaseId?.toString()?.includes(query) ||
          item?.name?.toLowerCase()?.includes(query) ||
          item?.palCode?.toLowerCase()?.includes(query) ||
          item?.client?.toString()?.includes(query) ||
          item?.phoneNumber?.toString()?.includes(query) ||
          item?.location?.toLowerCase()?.includes(query) ||
          item?.email?.toLowerCase()?.includes(query) ||
          item?.sourceDeductionAssociation?.toString()?.includes(query)
        );
      })
      .map((item) => {
        // Calculate a relevance score based on the match
        let score = 0;

        if (item?.cardId?.toString() === query)
          score += 10; // Exact match on cardId
        else if (item?.cardId?.toString()?.includes(query)) score += 5; // Partial match

        if (item?.caseId?.toString() === query)
          score += 10; // Exact match on caseId
        else if (item?.caseId?.toString()?.includes(query)) score += 5;

        if (item?.accountCaseId?.toString() === query) score += 10;
        else if (item?.accountCaseId?.toString()?.includes(query)) score += 5;

        if (item?.name?.toLowerCase() === query)
          score += 15; // Give more weight to name exact match
        else if (item?.name?.toLowerCase()?.includes(query)) score += 7;

        if (item?.palCode?.toLowerCase() === query) score += 10;
        else if (item?.palCode?.toLowerCase()?.includes(query)) score += 5;

        if (item?.client?.toString() === query) score += 10;
        else if (item?.client?.toString()?.includes(query)) score += 5;

        if (item?.phoneNumber?.toString() === query) score += 10;
        else if (item?.phoneNumber?.toString()?.includes(query)) score += 5;

        if (item?.location?.toLowerCase() === query) score += 8;
        else if (item?.location?.toLowerCase()?.includes(query)) score += 4;

        if (item?.email?.toLowerCase() === query) score += 10;
        else if (item?.email?.toLowerCase()?.includes(query)) score += 5;

        if (item?.sourceDeductionAssociation?.toString() === query) score += 10;
        else if (item?.sourceDeductionAssociation?.toString()?.includes(query))
          score += 5;

        // Return item along with its score
        return { ...item, score };
      });

    // Sort by relevance score (descending)
    const sortedData = scoredData.sort((a, b) => b.score - a.score);

    // Apply any additional sorting based on sortConfig
    if (sortConfig.key) {
      sortedData.sort((a, b) => {
        const aValue = a[sortConfig.key] || ""; // Default to empty string if null or undefined
        const bValue = b[sortConfig.key] || ""; // Default to empty string if null or undefined

        if (sortConfig.type === "number") {
          return sortConfig.direction === "ascending"
            ? aValue - bValue
            : bValue - aValue;
        } else if (sortConfig.type === "date") {
          return sortConfig.direction === "ascending"
            ? new Date(aValue) - new Date(bValue)
            : new Date(bValue) - new Date(aValue);
        } else {
          // default to string comparison
          return sortConfig.direction === "ascending"
            ? aValue.localeCompare(bValue)
            : bValue.localeCompare(aValue);
        }
      });
    }

    return sortedData;
  }, [accountCardsData, searchQuery, sortConfig]);

  const handleConfirmDelete = async () => {
    // Perform delete operation

    setLoading(true);
    setIsModalVisible(false);


    try {
      const response = await DocumentService.DeleteDocument(itemTypeToDelete, itemIdToDelete, token);
      if (response.ok) {

        await FetchData();
        toast.success(t("documentDeleteSuccess"), {
          position: direction === 'rtl' ? 'top-left' : 'top-right'
        });
      } else {
        // Handle any errors or display an error toast
        const errorResponse = await response.json();
        console.error('Error deleting document:', errorResponse);

        // Show error toast
        toast.error(t("documentDeleteError"));
      }
    } catch (error) {
      console.error('Error deleting document:', error);

      // Show error toast
      toast.error(t("documentDeleteError"));
    }
    setLoading(false);
  };

  const handleConfirmDeletion = async () => {
    if (actionType === 'delete') {
      await handleConfirmDelete();
    }
    if (actionType === 'deleteExternal') {
      await deleteMultipleExternal();
    }
  };

  const getTitleMessage = () => {
    switch (actionType) {

      case 'closeMonth':
        return t('ConfirmCloseMonth');
      case 'openMonth':
        return t('ConfirmOpenMonth');
      default:
        return t('confirmDeleteTitle');
    }
  };
  const getConfirmMessage = () => {
    switch (actionType) {
      case 'closeMonth':
        return t('AreYouSureCloseMonth');
      case 'openMonth':
        return t('AreYouSureOpenMonth');
      default:
        return t('confirmDeleteMessage');

    }
  };

  const { hasBack, handleBack } = useBack();

  const handleGoBack = () => {
    // Navigate back to the previous page using React Router
    if (client) {
      // const prevPage = previosPage || '/client-details';
      // navigate(prevPage, {
      //   state: { client, bankFromBankPage, type: 'BankPages' },
      // });
      // handleBack();
      goBack()
    }
  };

  const rowStyle = {
    padding: "6px",
    fontSize: "12px",
  };

  const headerStyle = {
    backgroundColor: "#ebebeb",
    padding: "8px",
    fontSize: "12px",
  };

  const [itemEditing, setItemEditing] = useState(true);
  const [addNewAccountCardDocument, setAddNewAccountCardDocument] =
    useState(false);
  const [companyId, setCompanyId] = useState("");
  const [accountCodeName, setAccountCodeName] = useState("");
  const [accountCodeId, setAccountCodeId] = useState("");

  const [modalVisible, setModalVisible] = useState(false);
  const [addNewAccountCard, setAddNewAccountCard] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const isClosedReportingMonthAndIsRange = !isRange
    ? isClosedReportingMonth
    : addEditableItem.isClosedReportingMonth;
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [paymentAcceptanceItems, setPaymentAcceptanceItems] = useState([]);
  const [invoiceClientCaseId, setInvoiceClientCaseId] = useState("");
  const [accountType, setAccountType] = useState(null);
  const [description, setDescription] = useState("");
  const [showAccountCardInputsEdit, setShowAccountCardInputsEdit] =
    useState(false);
  const [acceptedWithholdingTax, setAcceptedWithholdingTax] = useState(0);
  const [palCode, setPalCode] = useState("");
  const [paymentWithholdingTax, setPaymentWithholdingTax] = useState(0);
  const [newItem, setNewItem] = useState(false);
  const [isUpdated, setIsUpdated] = useState(false);
  const [actionType, setActionType] = useState("delete");
  const [accountCardIdToDelete, setAccountCardIdToDelete] = useState("");
  const [paymentBeingEdited, setPaymentBeingEdited] = useState(true);

  ///add acccount card
  const [newCardId, setNewCardId] = useState(null);

  const [creditDebitSearchTerm, setCreditDebitSearchTerm] = useState('');
  const [addAccountCardType, setAddAccountCardType] = useState('main');
  const [isEditAccountCard, setIsEditAccountCard] = useState(false);
  const [newAccountCard, setNewAccountCard] = useState({ accountCodeName: '', accountCodeId: "" });
  const [cardIdOption, setCardIdOption] = useState(-1);
  // When adding a new account card from a split-difference row, remember which row
  // should receive the newly-created card so the write-back targets it (instead of
  // the shared debit/credit fields used elsewhere).
  const [splitRowForNewCard, setSplitRowForNewCard] = useState(null);
  const [selectedAccount, setSelectedAccount] = useState(() => {
    if (!editedItem?.accountCodeName) return '';

    const selectedOption = accountCardOptions.find(option => option.cardId === editedItem.accountCodeId);
    return selectedOption ? selectedOption : null;
  });
  useEffect(() => {
    if (accountCardOptions && accountCardOptions.length > 0) {
      const maxCardId = Math.max(...accountCardOptions.slice(1).map(option => parseInt(option.cardId, 10)));
      setCardIdOption(maxCardId + 1);
    }
  }, [accountCardOptions]);
  const handleChangeAfterAdd = (cardId, type) => {
    ///set type
    const newCard = {
      cardId,
      type
    }
    setNewCardId(newCard);
  }
  useEffect(() => {
    if (accountCardOptions && accountCardOptions.length > 0 && newCardId) {
      const selectedOption = accountCardOptions.find(option => option.cardId === newCardId.cardId);
      if (newCardId) {
        if (splitRowForNewCard != null) {
          // The add-card flow was triggered from a split-difference row: write the
          // created card back into that row's counter account instead of the shared field.
          updateSplitRow(
            splitRowForNewCard,
            'counterAccount',
            selectedOption ? selectedOption.cardId : ''
          );
          setSplitRowForNewCard(null);
        } else {
          handleSelectChange(
            newCardId.type,
            selectedOption
          )
        }
        setNewCardId(null);
      }
    }
  }, [accountCardOptions, newCardId]);



  const handleCloseItem = () => {
    setPalCode('');
    setShowAccountCardInputsEdit(false);
    setEditedAddAccountCard(false);
    setSelectedAccount(oldSelectedAccountCardItem);
    // handleChangeAccount('accountCodeId', oldSelectedAccountCardItem.cardId?.toString());
    // handleChangeAccount('accountCodeName', oldSelectedAccountCardItem.name?.toString());
    // handleChangeAccount('accountCaseId', oldSelectedAccountCardItem.accountCaseId?.toString());
  };
  const formattedAccountCardOptions = accountCardOptions.map((option) => ({
    value: option.cardId,
    label: option.value1 === 'AddItem'
      ? option.name
      : option.accountCaseId
        ? `${option.cardId} - ${option.name} - ${option?.accountCaseId || ''}`
        : `${option.cardId} - ${option.name}`,
    name: option.name,
    accountCaseId: option.accountCaseId || '',
    cardId: option.cardId,
    value1: option.value1,
    palCode: option.palCode,
    isEditable: option.isEditable
  }));

  const handleCreditAccountCardForNewCommands = (card, type) => {
    if (!card) {
      return;
    }

    if (card.value1 === 'AddItem') {
      // Default: a new card lands on a shared field. Split-row adds re-set this
      // immediately after calling here (see handleAddCounterAccountCard).
      setSplitRowForNewCard(null);
      setEditedAddAccountCard(true);
      setAddAccountCardType(type);
      setIsEditAccountCard(false);
      setNewAccountCard({ accountCodeName: card.searchTerm || '', accountCodeId: cardIdOption })
    }
  };

  const handleNoOptionCreditDebitClick = (searchTerm, type) => {
    const newOption = {
      ...formattedAccountCardOptions[0],
      searchTerm: searchTerm
    };
    handleCreditAccountCardForNewCommands(newOption, type)
  };

  // Open the add-account-card modal for a split-difference row. The counter account
  // lands on the debit side when the bank amount is negative, otherwise on the credit
  // side (mirrors how the rows are booked in the journal entries).
  const handleAddCounterAccountCard = (searchTerm, rowId, isNegative) => {
    const side = isNegative ? 'debitAccount' : 'creditAccount';
    handleCreditAccountCardForNewCommands(
      { ...formattedAccountCardOptions[0], value1: 'AddItem', searchTerm: searchTerm || '' },
      side
    );
    setSplitRowForNewCard(rowId);
  };

  // Mirrors EditModal's account-card filter: search by code/name/case/palcode and
  // surface an inline "Add account card" option when nothing matches the input.
  const filterSplitAccountCardOptions = useCallback((options, { inputValue }) => {
    const realOptions = options.filter((o) => o.value1 !== 'AddItem');
    const input = (inputValue || '').trim();
    if (!input) return realOptions;
    const inputLower = input.toLowerCase();
    const filtered = realOptions.filter((option) => {
      const cardIdStr = String(option.cardId ?? option.value ?? '');
      const matchCardId = cardIdStr.toLowerCase().includes(inputLower) || cardIdStr.includes(input);
      const matchLabel = (option.label || '').toLowerCase().includes(inputLower);
      const matchName = (option.name || '').toLowerCase().includes(inputLower);
      const matchAccountCaseId = (option.accountCaseId || '').toLowerCase().includes(inputLower);
      const matchPalCode = option.palCode != null && String(option.palCode).toLowerCase().includes(inputLower);
      return matchCardId || matchLabel || matchName || matchAccountCaseId || matchPalCode;
    });
    if (filtered.length === 0) {
      return [{ value1: 'AddItem', searchTerm: input, cardId: '', name: '', label: '', accountCaseId: '' }];
    }
    return filtered;
  }, []);

  const checkIfExistingAccountCard = (
    accountCardOptions,
    cardId,
    accountCaseId,
    edit = false
  ) => {
    const existingAccountCard = accountCardOptions.filter(
      (card) =>
        (card.accountCaseId === accountCaseId && accountCaseId) ||
        (card.cardId === cardId && cardId)
    );

    const isExist =
      existingAccountCard &&
      (edit ? existingAccountCard.length > 1 : existingAccountCard.length > 0);

    if (isExist) {
      toast.info(
        t("AccountCardExists", { accountCodeId: existingAccountCard[0].cardId })
      );
      return true;
    }
  };

  const handleSaveEditAccountCard = async () => {
    if (
      checkIfExistingAccountCard(
        accountCardOptions,
        accountCodeId,
        companyId,
        true
      )
    ) {
      return;
    }
    const Item = addEditableItem;
    handleClose();
    try {
      setLoading(true);

      const response = await EnumsService.UpdateAccountCard(
        client.caseId,
        oldSelectedAccountCardItem.cardId,
        oldSelectedAccountCardItem.name,
        accountCodeId,
        accountCodeName,
        companyId,
        palCode,
        token
      );
      if (response.ok) {
        const newItem = {
          ...Item,
          accountCodeId: accountCodeId?.toString(),
          accountCodeName: accountCodeName?.toString(),
          accountCaseId: invoiceClientCaseId?.toString(),
        };
        setNewItem(newItem);
        let selectedAccountCard = {
          cardId: accountCodeId,
          caseId: client.caseId,
          accountCaseId: companyId,
          name: accountCodeName,
          palCode: palCode,
          client: null,
        };
        setAccountCardOptions((prevCards) => {
          const updatedCards = prevCards.filter(
            (card) => card.cardId !== selectedAccountCard.cardId
          );
          updatedCards.push(selectedAccountCard);
          setIsUpdated(true);
          return updatedCards;
        });
        // handleReopenEdit(editedItem);
        toast.success(t("CustomerSupplierUpdatedSuccessfully"));
        setSelectedOption(selectedAccountCard ? selectedAccountCard : null);
      } else {
        const errorText = await response.text();
        console.error("FailedToUpdateCustomerSupplier", errorText);
        toast.error(t("FailedToUpdateCustomerSupplier"));
      }
    } catch (error) {
      console.error("FailedToUpdateCustomerSupplier:", error);

      toast.error(t("FailedToUpdateCustomerSupplier"));
    }
    setLoading(false);
    setPalCode("");
    setAccountCodeId("");
    setAccountCodeName("");
    setAddNewAccountCardDocument(false);
    setShowAccountCardInputsEdit(false);
  };

  const handleAddAccountCard = async () => {
    if (
      checkIfExistingAccountCard(accountCardOptions, accountCodeId, companyId)
    ) {
      return;
    }
    const Item = addEditableItem;
    handleClose();
    try {
      setLoading(true);
      const response = await EnumsService.AddAccountCard(
        client.caseId,
        accountCodeId,
        accountCodeName,
        companyId,
        palCode,
        token
      );
      if (response.ok) {
        const accountCodeId = await response.json();
        let selectedAccountCard = {
          cardId: accountCodeId,
          caseId: client.caseId,
          accountCaseId: companyId,
          name: accountCodeName,
          palCode: palCode,
          client: null,
        };

        const newItem = {
          ...Item,
          accountCodeId: accountCodeId?.toString(),
          accountCodeName: accountCodeName?.toString(),
          accountCaseId: invoiceClientCaseId?.toString(),
        };
        setNewItem(newItem);
        setAccountCardOptions((prevCards) => {
          const updatedCards = [...prevCards, selectedAccountCard];
          setIsUpdated(true);
          return updatedCards;
        });

        toast.success(t("CustomerSupplierAddedSuccessfully"));
        setSelectedOption(selectedAccountCard ? selectedAccountCard : null);
      } else {
        const errorText = await response.text();
        console.error("Failed to edit user", errorText);
        toast.error(t("FailedToAddCustomerSupplier"));
      }
    } catch (error) {
      console.error("Error edit user:", error);
      toast.error(t("FailedToAddCustomerSupplier"));
    }
    setLoading(false);
    setPalCode("");
    setAccountCodeId("");
    setAccountCodeName("");
    setAddNewAccountCardDocument(false);
  };

  const onRefresh = async () => {
    setLoading(true);
    await fetchEnums(user, token, client);
  };

  const handleCloseAddNewAccountCardDocument = () => {
    setAccountCodeId("");
    setAccountCodeName("");
    setAddNewAccountCardDocument(false);
  };


  const handleMuiChange = (event, value) => {

    if (value?.value1 === 'AddItem') {
      setAccountCodeName("");
      setAccountCodeId("");
      setCompanyId("");
      setAddNewAccountCardDocument(true);
      setAddNewAccountCard(true);
    }
    else {
      setItemEditing(true);
      const updatedFields = {
        accountCaseId: value.accountCaseId,
        accountCodeId: value.cardId,
        accountCodeName: value.name,
      };

      setAccountCodeName(value.name);
      setCompanyId(value.accountCaseId);
      setAccountCodeId(value.cardId);
      setInvoiceClientCaseId(value.cardId);

      // Update addEditableItem state
      setAddEditableItem(prevState => ({
        ...prevState,
        ...updatedFields,
      }));
      setSelectedOption({ ...value });

      // Call the function to update items
      updateAllItems(value, updatedFields);
    }



  };

  const updateAllItems = (value, updatedFields) => {
    const updatedItems = ['checks', 'bankTransactions', 'creditCards', 'cash'];
    const paymentType = addEditableItem.paymentAcceptanceType;

    updatedItems.forEach(itemType => {
      addEditableItem[itemType]?.forEach((item, index) => {
        // Determine the field to update
        const fieldToUpdate = paymentType === 'תקבול' ? 'creditAccount' : 'debitAccount';

        handleItemChange(itemType, index, fieldToUpdate, value.cardId);
      });
    });

    // Update addEditableItem with new account data
    setAddEditableItem(prevState => ({
      ...prevState,
      ...updatedFields,
    }));
  };

  const handleAccountDelete = (option) => {
    setActionType("deleteAccountCard");
    setAccountCardIdToDelete(option.cardId);
    setIsModalVisible(true);
    // handleAccountCardDeleteClick(option.cardId);
  };

  const handleChangeAccountType = (selectedOption) => {
    setAccountType(selectedOption.value);
    setAddEditableItem((prevState) => ({
      ...prevState,
      paymentAcceptanceType: selectedOption ? selectedOption.value : "",
    }));
  };
  const customStyles = {
    valueContainer: (base, state) => ({
      ...base,
      justifyContent: "center",
    }),
  };

  const setPaymentDate = async (date) => {
    // const response1 = await ClientService.CheckIfMonthClosed(
    //   client.caseId,
    //   date,
    //   token
    // );
    // const isClosedReportingMonth = await response1.json();
    // if (isClosedReportingMonth) {
    //   toast.error(t("MonthReportAlreadyClosedTryAgain"));
    //   return;
    // }
    setAddEditableItem((prevItem) => ({
      ...prevItem,
      date: date.toISOString(),
    }));
  };

  const handleDescriptionChange = (event) => {
    setDescription(event.target.value);
    setAddEditableItem((prevState) => ({
      ...prevState,
      description: event.target.value || ''
    }));
  };
  const handleChangeOriginalTaxClearance = (event) => {
    const raw = event.target.value.trim();      // always a string
    const normalised = raw === '' ? 0        // user cleared the field
        : Number(raw) // otherwise turn to number

    // Use the proper state update pattern
    handleAddEditableItemChange('withholdingTax', normalised);
    // setOriginalTaxClearance(value);
  };

  const handleRemoveItem = (type, index) => {
    let count = 0;

    // Update paymentAcceptanceItems
    const newItems = paymentAcceptanceItems.filter((item) => {
      if (item.type === type) {
        if (count === index) {
          count++;
          return false;
        }
        count++;
      }
      return true;
    });
    setPaymentAcceptanceItems(newItems);

    // Update addEditableItem
    setAddEditableItem((prevItem) => {
      if (!Array.isArray(prevItem[type])) return prevItem;
      const updatedTypeItems = prevItem[type].filter((_, idx) => idx !== index);
      return { ...prevItem, [type]: updatedTypeItems };
    });
  };

  const handleAddItem = (theType, suggestedAmount = '', accountFields = {}) => {
    const paymentType = addEditableItem.paymentAcceptanceType;

    const newItem = {
      type: theType,
      description: '',
      amount: suggestedAmount,
      paymentDate: new Date(),
      bankName: '',
      bankCode: '',
      bankBranchCode: '',
      supplierAccountNumber: '',
      bankTransactionsCode: caseSystemSettings.generalBankCardId,
      creditAccount: paymentType === 'תקבול' ? addEditableItem.accountCodeId || '' : '',
      debitAccount: paymentType === 'תשלום' ? addEditableItem.accountCodeId || '' : '',
      ...accountFields,
    };

    // Update paymentAcceptanceItems
    setPaymentAcceptanceItems(prevItems => [...prevItems, newItem]);

    // Update addEditableItem
    setAddEditableItem(prevItem => ({
      ...prevItem,
      [theType]: Array.isArray(prevItem[theType]) ? [...prevItem[theType], newItem] : [newItem]
    }));

  };

  const handleAddEditableItemChange = (name, value) => {
    setAddEditableItem((prev) => ({ ...prev, [name]: value }));
  };

  const patchAddEditableItem = useCallback((patch) => {
    setAddEditableItem((prev) => ({ ...prev, ...patch }));
  }, []);

  const handleSave = async () => {
    try {
      setModalVisible(false);
      setOpenInvoiceCreatorModal(false);
      setLoading(true);
      // Prepare the data to be sent in the request body
      const updatedDocument = buildPaymentAcceptanceUpdatePayload(addEditableItem);

      // Call the UpdateDocument function from DocumentService
      const response = await DocumentService.UpdateDocument(
        "PaymentAcceptances",
        token,
        updatedDocument
      );

      if (response.ok) {
        // Handle successful update
        if (addEditableItem.status === "done") {
          await handleDoneClick(addEditableItem.id, addEditableItem.type);
        } else if (addEditableItem.status === "notDone") {
          await handleNotDoneClick(addEditableItem.id, addEditableItem.type);
        }
        toast.success(t("documentUpdateSuccess"));
        setWholeDataTransactions((prev) => {
          const updated = { ...prev };

          // Find the key where the value.id matches updatedDocument.id
          const matchingKey = Object.keys(updated).find(
            (key) => updated[key]?.id === updatedDocument.id
          );

          if (matchingKey) {
            delete updated[matchingKey];
          }

          return updated;
        });
        // await fetchAccountCardDashboard(startDate, endDate, processedFilesCheckbox);
        await FetchData();
      } else {
        // Handle any errors or display an error message
        toast.error(t("documentUpdateError"));
      }
    } catch (error) {
      console.error("documentUpdateError:", error);
      // Show an error toast message
      toast.error(t("documentUpdateError"));
    }
    await onRefresh();
    // handleClose(); // Function to revert or exit the edit mode
    setLoading(false);
  };


  const handleItemChange = (type, index, field, value) => {
    setPaymentAcceptanceItems(prevItems => {
      let typeIndex = -1;
      const updatedItems = prevItems.map((item, idx) => {
        if (item.type === type) {
          typeIndex += 1;
          if (typeIndex === index) {
            return { ...item, [field]: value };
          }
        }
        return item;
      });

      // Update the corresponding field in addEditableItem
      setAddEditableItem(prevItem => {
        const updatedTypeItems = prevItem[type].map((item, idx) => {
          if (idx === index) {
            return { ...item, [field]: value };
          }
          return item;
        });

        // Conditionally update the fields based on payment type and field
        const paymentType = addEditableItem.paymentAcceptanceType;
        const shouldUpdateFields =
          (paymentType === 'תקבול' && field === 'creditAccount') ||
          (paymentType === 'תשלום' && field === 'debitAccount');

        const matchingOption = accountCardOptions.find(
          option => option.cardId === value
        );

        const updatedFields = shouldUpdateFields && matchingOption
          ? {
            accountCaseId: matchingOption.accountCaseId || '',
            accountCodeId: matchingOption.cardId || '',
            accountCodeName: matchingOption.name || '',
          }
          : {};

        return { ...prevItem, ...updatedFields, [type]: updatedTypeItems };
      });

      return updatedItems;
    });
  };
  const setAccount = (field, input) => {
    //switch case on field
    switch (field) {
      case "companyId":
        setCompanyId(input);
        setInvoiceClientCaseId(input);

        break;
      case "accountCodeName":
        setAccountCodeName(input);

        break;
      case "accountCodeId":
        setAccountCodeId(input);

        break;
      default:
    }
  };
  const handleClose = async (clearDocuments = true) => {
    setOpenInvoiceCreatorModal(false);
    setPaymentModal(false);
    setAddEditableItem({
      checks: [],
      creditCards: [],
      cash: [],
      bankTransactions: [],
      offsets: [],
      date: new Date(),
    });
  };

  const [wholeDataTransactions, setWholeDataTransactions] = useState([]);


  const handleEdit = async (row) => {
    // ─────────────────────────────────────────────────────────
    // 0️⃣  Index inside the current (already-sorted) array
    // ─────────────────────────────────────────────────────────
    const currentIndex = sortedTransactions.findIndex(
      (transaction) => transaction.id === row.id
    );
    const currentTransaction = sortedTransactions.find(
      (transaction) => transaction.id === row.id
    );

    if (currentIndex === -1) {
      console.error('Transaction not found in sortedTransactions');
      return;
    }
    setCurrentIndex(currentIndex);
    setEditingRow(row.id);                                // <── keep this

    // ─────────────────────────────────────────────────────────
    // 1️⃣  Figure out the *overall* document type
    //     ("Incomes", "Expenses", "PaymentAcceptances", "JournalEntries")
    // ─────────────────────────────────────────────────────────
    const overAllType = row.type.split('-')[0].trim();

    // 1.1  Build status (✔ / ✖) against client.documentIds
    let statusChecked = false;

    if (client?.documentIds) {
      switch (overAllType) {
        case 'Incomes':
          statusChecked = client.documentIds.incomes?.includes(row.id);
          break;
        case 'Expenses':
          statusChecked = client.documentIds.expenses?.includes(row.id);
          break;
        default: // other types have no "processed / unprocessed" flag (yet)
          statusChecked = false;
          break;
      }
    }
    // will become "done" if already inside the processed array
    row.status = statusChecked ? 'notDone' : 'done';
    setStatusCheck(!statusChecked);                       // keep the old toggle

    // ─────────────────────────────────────────────────────────
    // 2️⃣  Helper that fetches (or re-uses cached) document DTO
    // ─────────────────────────────────────────────────────────
    const getDataForRow = async (row, overAllType) => {

      if (wholeDataTransactions[row.id]) {
        
        // Extract paymentacceptance from types like "paymentacceptance-xxxx"
        const itemType = row.type.startsWith('PaymentAcceptances-') ? 'PaymentAcceptances' : row.type;
        const itemId = row.type.startsWith('PaymentAcceptances-') ? row.paymentAcceptanceId : row.id;
        setItemTypeToDelete(itemType);
        setItemIdToDelete(itemId);
        return wholeDataTransactions[row.id];
      }

      const isPaymentAcceptance = row.type !== overAllType;
      const documentId = isPaymentAcceptance ? row.paymentAcceptanceId : row.id;

      const response = await DocumentService.GetDocumentById(
        overAllType,
        client.caseId,
        documentId,
        token,
      );

      if (!response.ok)
        throw new Error(`Failed to fetch data for document ID: ${documentId}`);

      const data = await response.json();
      const dataWithDocType = { ...data, docType: overAllType, status: row.status };

      // 🔒  cache
      setWholeDataTransactions((prev) => ({ ...prev, [row.id]: dataWithDocType }));

      setItemIdToDelete(dataWithDocType.id);
      setItemTypeToDelete(dataWithDocType.docType);

      return dataWithDocType;
    };


    try {
      // ───────────────────────────────────────────────────────
      // 3️⃣  Pull / reuse the DTO, push into edit state
      // ───────────────────────────────────────────────────────
      const data = await getDataForRow(row, overAllType);
      const withFx = {
        ...data,
        foreignCurrencyCode: row.foreignCurrencyCode,
        foreignCurrencyAmount: row.foreignCurrencyAmount,
      };
      setEditedItem(withFx);

      // Account-card combo-box, unchanged:
      const selectedAccountCard = {
        cardId: accountCodeId,
        caseId: client.caseId,
        accountCaseId: companyId,
        name: accountCodeName,
        palCode: palCode,
        client: null,
      };
      setSelectedOption(selectedAccountCard);

      // ───────────────────────────────────────────────────────
      // 4️⃣  Popup / modal routing
      // ───────────────────────────────────────────────────────
      switch (overAllType) {
        case 'Incomes':
        case 'Expenses':
          setEditedPopupItem(true);
          setPaymentModal(false);
          setEditedJournalItem(false);
          break;

        case 'PaymentAcceptances':
          handlePaymentAcceptance(row, data);
          break;

        case 'JournalEntries':
          setEditedPopupItem(true);
          setPaymentModal(false);
          setEditedJournalItem(true);
          break;

        default:
          setEditedPopupItem(false);
          setPaymentModal(false);
          setEditedJournalItem(false);
          break;
      }
    } catch (error) {
      console.error('Error during edit handling:', error);
      toast.error(t('FailedToFetchDocument')); // or any user-facing message
    }
  };


  // Helper function to handle PaymentAcceptances
  const handlePaymentAcceptance = (row, data) => {
    const itemType = row.type.split('-')[1].trim();
    const itemId = row.id;

    // Get the array corresponding to the itemType (e.g., 'checks', 'creditCards')
    const itemsArray = data[itemType];

    if (Array.isArray(itemsArray)) {
      // Find the index of the item with the matching ID
      const indexInArray = itemsArray.findIndex((item) => item.id === itemId);

      if (indexInArray !== -1) {
        setShowType({ type: itemType, index: indexInArray });
      } else {
        console.error('Item with the specified ID not found in the array.');
        setShowType({ type: itemType, index: -1 });
      }
    } else {
      console.error(`No array found for type "${itemType}" in data.`);
      setShowType({ type: itemType, index: -1 });
    }

    // Update state variables for the modal
    setOpenInvoiceCreatorModal(true);
    setAddEditableItem({ ...data });
    setPaymentModal(true);
    setEditedJournalItem(false);
    setEditedPopupItem(false);
    setItemEditing(true);
  };

  const handleRemoveMatchClick = (match) => {
    match.accountCardName = mainCard.name;

    setSelectedMatch(match);
    setOpenRemoveMatchDialog(true);
  };
  const handleCellDoubleClick = (params) => {
    handleEdit(params.row);
  };

  // Double-clicking a bank (external) transaction opens the edit dialog (with document support).
  const handleOpenEditExternalTransaction = (row) => {
    const matchNum = row?.matchNumber;
    // Matched transactions open in read-only "view" mode (to inspect the document in a large
    // preview); only unmatched transactions can actually be edited.
    const isMatched = matchNum != null && matchNum !== -1 && matchNum !== 0;
    setEditViewOnly(isMatched);
    const amt = Number(row?.amount1 ?? 0);
    const creditAccount = amt < 0 ? Math.abs(amt) : 0;
    const debitAccount = amt >= 0 ? amt : 0;
    const base = {
      ...row,
      reference1: row?.reference ?? row?.reference1 ?? '',
      amount: amt,
      transactionDate: row?.transactionDateRaw ?? row?.transactionDate,
      creditAccount,
      debitAccount,
    };
    setOldEditedTransaction(base);
    setEditedTransaction(base);
    setEditBankTransactionDialog(true);
  };

  const changeEditedBankTransaction = (field, value) => {
    setEditedTransaction((prev) => ({ ...prev, [field]: value }));
  };

  const handleCloseBankEditTransactionDialog = () => {
    setEditBankTransactionDialog(false);
    setEditedTransaction(null);
    setOldEditedTransaction(null);
    setEditViewOnly(false);
  };

  const handleEditExternalTransactionSave = async () => {
    try {
      const isForeign = selectedTBank?.foreignCurrencyCode != null;
      const amtRaw = parseFloat(editedTransaction.amount ?? 0);
      const isCredit = amtRaw < 0;
      const absAmt = Math.abs(amtRaw);
      const updatedBankItem = {
        ...editedTransaction,
        caseId: client.caseId,
        accountCodeId: selectedCardId,
        accountCodeName: mainCard?.name,
        reference: editedTransaction.reference1,
        amount: isForeign ? 0 : amtRaw,
        foreignCurrencyAmount: isForeign ? amtRaw : null,
        foreignCurrencyCode: isForeign ? selectedTBank.foreignCurrencyCode : null,
        debitAccount: isCredit ? 0 : absAmt,
        creditAccount: isCredit ? absAmt : 0,
      };
      const response = await ExternalTransactionsService.UpdateExternalTransaction(
        updatedBankItem,
        oldEditedTransaction?.creditAccount ?? 0,
        oldEditedTransaction?.debitAccount ?? 0,
        token
      );
      if (response.ok) {
        handleCloseBankEditTransactionDialog();
        await FetchData();
        toast.success(t('TransactionUpdatedSuccessfully'));
      } else {
        toast.error(t('FailedToUpdateBankCommand'));
      }
    } catch (error) {
      toast.error(t('FailedToUpdateBankCommand'));
    }
  };

  const handleDeleteExternalTransaction = async () => {
    try {
      const deleteDTO = {
        Id: editedTransaction.id,
        CaseId: client.caseId,
        AccountCodeId: selectedCardId,
        Credit: editedTransaction.creditAccount,
        Debit: editedTransaction.debitAccount,
      };
      const response = await ExternalTransactionsService.DeleteExternalTransaction(deleteDTO, token);
      if (response.ok) {
        handleCloseBankEditTransactionDialog();
        await FetchData();
      } else {
        toast.error(t('FailedToDeleteTransaction'));
      }
    } catch (error) {
      toast.error(t('FailedToDeleteTransaction'));
    }
  };


  const handleConfirmRemove = async () => {
    try {
      const deleteDTO = {
        CaseId: selectedMatch.caseId,
        Id: selectedMatch.id,
      };

      // Call the delete service
      const response = await ExternalTransactionsService.DeleteMatch(
        deleteDTO,
        token
      );
      if (response.ok) {
        toast.success(t("MatchDeletedSuccessfully"));
        // Close the dialog after confirming
        await FetchData();
      } else {
        toast.error(t("ErrorDeletingMatch"));
      }
    } catch (error) {
      console.error("Error deleting match:", error);
      toast.error(t("ErrorDeletingMatch"));
    }
    setOpenRemoveMatchDialog(false);
  };

  const handleCloseRemoveMatchDialog = () => {
    setOpenRemoveMatchDialog(false);
  };

  /** Cancels several matches at once, one call each: the API deletes a single match. */
  const handleRemoveMatches = async (matches) => {
    if (!matches?.length) return;
    const confirmed = await Swal.fire({
      title: t("AreYouSure"),
      text: `${t("CancelSelectedMatches")} (${matches.length})\n${t("RemoveMatchesConfirm")}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: t("RemoveMatch"),
      cancelButtonText: t("cancelButton"),
    });
    if (!confirmed.isConfirmed) return;

    setRemovingMatches(true);
    let failed = 0;
    for (const match of matches) {
      try {
        // eslint-disable-next-line no-await-in-loop
        const response = await ExternalTransactionsService.DeleteMatch(
          { CaseId: match.caseId ?? client.caseId, Id: match.id },
          token
        );
        if (!response.ok) failed += 1;
      } catch (error) {
        console.error("Error deleting match:", error);
        failed += 1;
      }
    }
    if (failed === 0) toast.success(t("MatchesDeletedSuccessfully"));
    else toast.error(`${t("ErrorDeletingMatch")} (${failed})`);
    await FetchData();
    setRemovingMatches(false);
  };

  const handleFormattedAccountCardChange = (event, newValue) => {
    setMainCard(newValue);
    setSelectedCardId(newValue?.cardId);
    setSelectedFormattedAccountCard(newValue);
  };

  const EditAccountCard = (selectedItem, type) => {

    if (!selectedItem) {
      console.warn("No account card selected for editing.");
      return;
    }


    setSplitRowForNewCard(null);
    setPalCode(selectedItem.palCode);
    setNewAccountCard({ accountCodeName: selectedItem.name || '', accountCodeId: selectedItem.cardId, accountCaseId: selectedItem.accountCaseId || '' })
    setIsEditAccountCard(true);
    setEditedAddAccountCard(true);
    setAddAccountCardType(type);
  };

  const clickedDeleteMultipleExternal = async () => {
    if (!selectedExternalRows || selectedExternalRows.length === 0) {
      console.error("No rows selected for deletion.");
      return;
    }

    const idSet = new Set(selectedExternalRows.map(String));
    const hasFinsite = (externalTransactions || []).some((tx) => {
      const id = tx?.id ?? tx?.iD ?? tx?.ID;
      if (id == null || !idSet.has(String(id))) return false;
      return tx.finsiteEntryId != null || tx.FinsiteEntryId != null;
    });

    const confirmResult = await Swal.fire({
      title: t('confirmDeleteTitle'),
      text: hasFinsite
        ? t('AreYouSureDeleteSelectedFinsite', { count: selectedExternalRows.length })
        : t('AreYouSureDeleteSelected', { count: selectedExternalRows.length }),
      icon: 'warning',
      showDenyButton: hasFinsite,
      showCancelButton: true,
      confirmButtonColor: '#d32f2f',
      denyButtonColor: '#E57C22',
      cancelButtonColor: '#6c757d',
      confirmButtonText: hasFinsite ? t('DeleteAndBlockFinsite') : t('Delete'),
      denyButtonText: t('DeleteOnly'),
      cancelButtonText: t('Cancel'),
    });

    if (confirmResult.isDismissed) return;
    if (!hasFinsite && !confirmResult.isConfirmed) return;
    if (hasFinsite && !confirmResult.isConfirmed && !confirmResult.isDenied) return;

    const blockFinsiteReimport = hasFinsite ? confirmResult.isConfirmed : false;
    setBottomDockBarLoading(true);
    try {
      const response = await ExternalTransactionsService.DeleteMultipleExternalTransactions(
        client.caseId,
        selectedExternalRows,
        token,
        blockFinsiteReimport
      );
      if (response.ok) {
        await FetchData();
        if (blockFinsiteReimport) {
          toast.success(t('FinsiteReimportBlocked'));
        }
      } else {
        console.error("Failed to delete transactions:", await response.text());
      }
    } catch (error) {
      console.error("An error occurred while deleting transactions:", error);
    } finally {
      setBottomDockBarLoading(false);
    }
  };

  const currencySymbol = React.useMemo(() => {
    if (selectedTBank?.foreignCurrencyCode == null) return "";
    // find the string key whose value matches the numeric code
    const currencyKey = Object
      .entries(Constants.ForeignCurrencyCode)
      .find(([key, val]) => val === selectedTBank.foreignCurrencyCode)?.[0];
    return currencyKey ? Constants.ForeignCurrencySymbol[currencyKey] : "";
  }, [selectedTBank?.foreignCurrencyCode]);

  const deleteMultipleExternal = async () => {
    if (!selectedExternalRows || selectedExternalRows.length === 0) {
      console.error("No rows selected for deletion.");
      return;
    }
    setBottomDockBarLoading(true);
    try {
      const response = await ExternalTransactionsService.DeleteMultipleExternalTransactions(client.caseId, selectedExternalRows, token);
      if (response.ok) {
        await FetchData();
      } else {
        console.error("Failed to delete transactions:", await response.text());
      }
      setActionType('delete');
      setIsModalVisible(false);
    } catch (error) {
      console.error("An error occurred while deleting transactions:", error);
      setActionType('delete');
      setIsModalVisible(false);
    } finally {
      setBottomDockBarLoading(false);
    }
  };





  return (

    <>
      <AssetFoundDialog
        open={showAssetFoundDialog}
        asset={foundAsset}
        assetGroups={assetGroups}
        onClose={() => setShowAssetFoundDialog(false)}
        isDraggable={true}            // or false if you don't want drag
        caseId={client?.caseId}
        token={token}
        transactionId={editedItem.id}
        fetchEnums={fetchEnumsNoParams}
      />
      <AddAccountCardModal
        accountCardOptions={accountCardOptions}
        open={editedAddAccountCard}
        onClose={handleCloseItem}
        editedItem={newAccountCard}
        isEdit={isEditAccountCard}
        isRange={isRange}
        isClosedReportingMonth={isClosedReportingMonth}
        palCodes={formattedPalCodeOptions}
        propPalCode={palCode}
        setPalCode={setPalCode}
        direction={direction} // Pass direction for styling
        isAdd={!showAccountCardInputsEdit}
        client={client}
        token={token}
        setLoading={setLoading}
        handleChangeAfterAdd={handleChangeAfterAdd}
        fetchEnums={fetchEnums}
        type={addAccountCardType}
      />
      {/* adding bank transaction */}
      <AddExternalTransactionDialog
        addBankTransactionDialog={addBankTransactionDialog}
        handleCloseBankAddTransactionDialog={handleCloseBankAddTransactionDialog}
        t={t}
        newBankEditableItem={newBankEditableItem}
        changeNewBankTransaction={changeNewBankTransaction}
        handleAddBankTransaction={handleAddBankTransaction}
        selectedTBank={selectedTBank}
      />
      {editedTransaction && (
        <EditExternalTransactionDialog
          editBankTransactionDialog={editBankTransactionDialog}
          handleCloseBankEditTransactionDialog={handleCloseBankEditTransactionDialog}
          t={t}
          editedTransaction={editedTransaction}
          changeNewBankTransaction={changeEditedBankTransaction}
          handleEditBankTransaction={handleEditExternalTransactionSave}
          handleDelete={handleDeleteExternalTransaction}
          selectedTBank={selectedTBank}
          token={token}
          viewOnly={editViewOnly}
        />
      )}
      <>
        <div className={`bank-workspace ${focusMode ? "bank-workspace--focus" : ""}`}>
          <AddOrEditBankDialog
            open={createBankModal}
            onClose={handleCloseCreateModal}
            isEditingBank={isEditingBank}
            selectedBankForCreate={selectedBankForCreate}
            bankOptions={bankOptions} // Add actual bank options
            handleChangeBankForCreate={handleChangeBankForCreate}
            bankBranch={bankBranch}
            handleChangeCreateBank={handleChangeCreateBank}
            bankAccountNumber={bankAccountNumber}
            foreignCurrencyCode={foreignCurrencyCode}
            cardForNewBank={cardForNewBank}
            processedCardsData={accountCardOptionsForBank}
            setCardForNewBank={handleChangeSetCardForNewBank}
            handleAddOrEditBank={handleAddOrEditBank}
            handleRemoveBank={handleRemoveBank}
            client={client}
            token={token}
            setLoading={setLoading}
            palCodes={formattedPalCodeOptions}
            fetchEnums={fetchEnums}
          />

          {/* Which account, over which period, and where its balance stands.
              The full account table and the Xtram/Finsite breakdown live in the
              bar's popover so the workspace keeps the height for transactions. */}
          <div className="bank-workspace__context">
          <BankAccountBar
            selectedAccount={selectedTBank}
            selectedAccountIndex={selectedTBankIndex}
            onSelectAccount={selectedDenseTableRow}
            denseTableHeader={denseTableHeader}
            denseTableRows={denseTableRows}
            onEditAccount={handleOpenEditTBank}
            onDeleteSelectedAccounts={handleDeleteSelectedBanks}
            xtramRows={denseTableCreditDebitRows}
            finsiteRows={finsiteBalanceRows}
            diffRows={finsiteDiffRows}
            showFinsite={isSelectedAccountFinsiteLinked}
            finsiteLoading={finsiteBalanceLoading}
            direction={direction}
            accountCardSlot={
              <AccountCardSelect
                options={processedCardsData}
                value={selectedFormattedAccountCard}
                onChange={handleFormattedAccountCardChange}
                placeholder={t('Select AccountCard')}
                direction={direction}
              />
            }
            modeSlot={
            <>
              <FilterToggleGroup
                label={t('Status')}
                value={fetchType}
                onChange={handleFetchTypeChange}
                direction={direction}
                options={[
                  { value: 'Matched', label: t('Matched') },
                  { value: 'NotMatched', label: t('NotMatched') },
                ]}
              />
              {fetchType !== "Matched" && (
                <>
                  <label className={`${headerStyles.switchRow} ${headerStyles[direction] || ''}`} dir={direction}>
                    <span>{t('WithDocuments')}</span>
                    <input
                      type="checkbox"
                      checked={showOnlyWithDocuments}
                      onChange={(e) => setShowOnlyWithDocuments(e.target.checked)}
                    />
                    <span className={headerStyles.switchTrack} aria-hidden="true" />
                  </label>
                  <Tooltip title={t("KbdGuideTitle")} arrow>
                    <IconButton onClick={() => setShortcutsOpen(true)} sx={toolbarIconButtonSx('#304FFF')}>
                      <KeyboardIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                  {/* Spelled out rather than icon-only: the three reports are easy to
                      mistake for one another at icon size. */}
                  {selectedCardId && (
                    <>
                      <ActionChip
                        label={t("DownloadPDFFile")}
                        icon={<PictureAsPdfIcon fontSize="small" />}
                        borderColor="#D32F2F"
                        direction={direction}
                        tooltip={`${t("DownloadPDFFile")} - ${t("UnmatchedReport")}`}
                        onClick={() => handleDownloadUnmatched("pdf")}
                      />
                      <ActionChip
                        label={t("DownloadExcelFile")}
                        icon={<TableChartIcon fontSize="small" />}
                        borderColor="#1D6F42"
                        direction={direction}
                        tooltip={`${t("DownloadExcelFile")} - ${t("UnmatchedReport")}`}
                        onClick={() => handleDownloadUnmatched("excel")}
                      />
                    </>
                  )}
                  <ActionChip
                    label={t("UnmatchedAccountsReport")}
                    icon={<SummarizeIcon fontSize="small" />}
                    direction={direction}
                    onClick={() => setUnmatchedAccountsModalOpen(true)}
                  />
                </>
              )}
              {selectedTBank?.foreignCurrencyCode != null && currencySymbol && (
                <Typography variant="body2" sx={{ color: 'red', fontWeight: 'bold', fontSize: '0.72rem' }}>
                  {`${t('BankCurrencyNote', { currencySymbol })} ${currencySymbol}`}
                </Typography>
              )}
            </>
            }
            periodSlot={
            <div className="date-toggle-group">
              <BankPeriodPicker
                mode={isRange ? PERIOD_MODE.RANGE : PERIOD_MODE.YEAR}
                onModeChange={handlePeriodModeChange}
                year={endDate.getUTCFullYear()}
                onYearChange={handlePeriodYearChange}
                startDate={startDate}
                endDate={endDate}
                onStartDateChange={handlePeriodStartChange}
                onEndDateChange={handlePeriodEndChange}
              />
              {fetchType === "Matched" && (
                <label className={`${headerStyles.switchRow} ${headerStyles[direction] || ''}`} dir={direction}>
                  <span>{t(isMatchDate ? 'MatchDate' : 'TransactionDate')}</span>
                  <input
                    type="checkbox"
                    checked={isMatchDate}
                    onChange={handleMatchDateToggle}
                  />
                  <span className={headerStyles.switchTrack} aria-hidden="true" />
                </label>
              )}
            </div>
            }
            actionsSlot={
            <>
            <ActionChip
              label={t("AddBank")}
              tooltip={t("AddBank")}
              icon={<AddCircleOutlineIcon sx={{ color: "#304FFF !important" }} />}
              borderColor="#304FFF"
              onClick={() => handleOpenCreateModal()}
              direction={direction}
              maxLabelWidth={140}
            />
            <ActionChip
              label={t("DownloadXtramTemplate")}
              tooltip={t("DownloadTemplate")}
              icon={<DownloadIcon sx={{ color: "#009688 !important", fontSize: 18 }} />}
              borderColor="#009688"
              onClick={() =>
                handleDownloadTemplate(BankFile, "Xtram_Bank_Template.xlsx")
              }
              direction={direction}
              maxLabelWidth={180}
            />
            <ActionChip
              label={t("Import")}
              tooltip={t("Import")}
              icon={
                <CloudUploadIcon
                  sx={{
                    color: !selectedTBank ? "#9e9e9e !important" : "#304FFF !important",
                  }}
                />
              }
              borderColor={!selectedTBank ? "#bdbdbd" : "#304FFF"}
              onClick={handleOpenImportDialog}
              disabled={!selectedTBank}
              direction={direction}
              maxLabelWidth={100}
            />
            {isSelectedAccountFinsiteLinked && (
              <ActionChip
                label={t("FetchFromFinsite")}
                tooltip={t("FetchFromFinsite")}
                icon={
                  <CloudSyncIcon
                    sx={{
                      color: !selectedTBank ? "#9e9e9e !important" : "#1B8A5A !important",
                    }}
                  />
                }
                borderColor={!selectedTBank ? "#bdbdbd" : "#1B8A5A"}
                onClick={() => setFinsiteDialogOpen(true)}
                disabled={!selectedTBank}
                direction={direction}
                maxLabelWidth={180}
              />
            )}
            <Tooltip title={t("FocusMode")} arrow>
              <IconButton onClick={() => setFocusMode(true)} sx={toolbarIconButtonSx('#F9AA2A')}>
                <UnfoldLessIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            </>
            }
          />
          </div>
          <input
            type="file"
            ref={fileInputRef1}
            style={{ display: "none" }} // Hide the file input
          />
          {/* Focus mode hides the header, so the mode switch and the way back out
              move into a thin strip of their own. */}
          {focusMode && (
            <div className="bank-workspace__toolbar" dir={direction}>
              <FilterToggleGroup
                label={t('Status')}
                value={fetchType}
                onChange={handleFetchTypeChange}
                direction={direction}
                options={[
                  { value: 'Matched', label: t('Matched') },
                  { value: 'NotMatched', label: t('NotMatched') },
                ]}
              />
              {fetchType !== "Matched" && (
                <Tooltip title={t("KbdGuideTitle")} arrow>
                  <IconButton onClick={() => setShortcutsOpen(true)} sx={toolbarIconButtonSx('#304FFF')}>
                    <KeyboardIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              )}
              <Tooltip title={t("ShowFilters")} arrow>
                <IconButton onClick={() => setFocusMode(false)} sx={toolbarIconButtonSx('#F9AA2A')}>
                  <UnfoldMoreIcon fontSize="small" />
                </IconButton>
              </Tooltip>
              <div className="bank-workspace__toolbar-spacer" />
            </div>
          )}

          <div className="bank-workspace__body">
            <div className="bank-matching-tables-row" dir={direction}>

              {fetchType === "Matched" ? (
                <div style={{ width: "100%", height: "100%", minHeight: 0 }}>
                  <Box
                    sx={{
                      height: "100%",
                      width: "100%",
                      boxSizing: "border-box",
                      backgroundColor: "#fff",
                    }}
                  >

                    <MatchedTable
                      matchData={matchData}
                      expandedMatchedRows={expandedMatchedRows}
                      handleMatchedExpandClick={handleMatchedExpandClick}
                      handleRemoveMatchClick={handleRemoveMatchClick}
                      onRemoveMatches={handleRemoveMatches}
                      removing={removingMatches}
                      formatDate={formatDate}
                      beautifyNumber={beautifyNumber}
                      formatAccountLabel={(id) =>
                        id ? `${id} - ${getAccountCardName(id)}` : ""
                      }
                      t={t}
                      direction={direction}
                      isForeignCurrency={selectedTBank?.foreignCurrencyCode != null}
                    />
                  </Box>
                </div>
              ) : (
                <>
                  <div className="bank-matching-panel">
                    <div className="bank-commands-toolbar" dir={direction}>
                      <div className="table-titles">{t("BookCommands")}</div>
                      <span className="bank-panel-count">{displayedRows.length}</span>
                    </div>

                    <Box
                      dir="rtl"
                      className={activePanel === "internal" ? "kbd-active-panel" : ""}
                      sx={{
                        height: "100%",
                        width: "100%",
                        boxSizing: "border-box",
                        backgroundColor: "#fff",
                      }}
                    >
                      <StyledDataGrid
                        apiRef={apiRef}
                        rows={displayedRows}
                        columns={InternalColumns}
                        paginationMode="server"
                        rowCount={displayedRows.length}
                        paginationModel={ALL_ROWS_PAGINATION_MODEL}
                        pageSizeOptions={ALL_ROWS_PAGE_SIZE_OPTIONS}
                        hideFooterPagination
                        checkboxSelection
                        disableRowSelectionOnClick
                        onRowSelectionModelChange={handlePanelSelectionChange("internal")}
                        getRowClassName={(params) =>
                          [
                            params.row.rowClassName || "",
                            params.id === focusedInternalId ? "kbd-focused-row" : "",
                          ]
                            .filter(Boolean)
                            .join(" ")
                        }
                        getRowId={(row) => row.id}
                        onCellEditCommit={(row) => handleEdit(row)}
                        rowSelectionModel={selectedInternalRows}
                        slots={{ toolbar: CustomGridToolbar }}
                        slotProps={{
                          toolbar: {
                            t,
                            direction,
                            fileName: `${t("BookCommands")}`,
                            title: `${t("BookCommands")}`,
                          },
                        }}
                        onSortModelChange={handleSortModelChange}
                        onFilterModelChange={handleSortModelChange}
                        onCellDoubleClick={handleCellDoubleClick}
                        onCellClick={handlePanelCellClick("internal")}

                      />
                    </Box>
                  </div>

                  <div className="bank-matching-panel">
                    <div className="bank-commands-toolbar" dir={direction}>
                      <div className="table-titles">{t("BankCommands")}</div>
                      <span className="bank-panel-count">{externalDisplayedRows.length}</span>
                      <div
                        className="document-action-chips"
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "4px",
                          alignItems: "center",
                        }}
                      >
                        <ActionChip
                          label={t("AddBankCommand")}
                          tooltip={t("AddBankCommand")}
                          icon={
                            <AddCircleOutlineIcon
                              sx={{
                                color: !selectedTBank
                                  ? "#9e9e9e !important"
                                  : "#304FFF !important",
                              }}
                            />
                          }
                          borderColor={!selectedTBank ? "#bdbdbd" : "#304FFF"}
                          onClick={handleOpenBankAddTransactionDialog}
                          disabled={!selectedTBank}
                          direction={direction}
                          maxLabelWidth={160}
                        />
                      </div>
                    </div>

                    <Box
                      dir="rtl"
                      className={activePanel === "external" ? "kbd-active-panel" : ""}
                      sx={{
                        height: "100%",
                        width: "100%",
                        boxSizing: "border-box",
                        backgroundColor: "#fff",
                      }}
                    >
                      <StyledDataGrid
                        apiRef={externalApiRef}
                        rows={externalDisplayedRows}
                        columns={ExternalColumns}
                        paginationMode="server"
                        rowCount={externalDisplayedRows.length}
                        paginationModel={ALL_ROWS_PAGINATION_MODEL}
                        pageSizeOptions={ALL_ROWS_PAGE_SIZE_OPTIONS}
                        hideFooterPagination
                        checkboxSelection
                        disableRowSelectionOnClick
                        onCellDoubleClick={(params) =>
                          handleOpenEditExternalTransaction(params.row)
                        }
                        onRowSelectionModelChange={handlePanelSelectionChange("external")}
                        getRowClassName={(params) =>
                          [
                            params.row.rowClassName || "",
                            params.id === focusedExternalId ? "kbd-focused-row" : "",
                          ]
                            .filter(Boolean)
                            .join(" ")
                        }
                        getRowId={(row) => row.id}
                        onCellEditCommit={(row) => handleEdit(row)}
                        rowSelectionModel={selectedExternalRows}
                        slots={{ toolbar: CustomGridToolbar }}
                        slotProps={{
                          toolbar: {
                            t,
                            direction,
                            fileName: `${t("BankCommands")}`,
                            title: `${t("BankCommands")}`,
                          },
                        }}
                        onCellClick={handlePanelCellClick("external")}
                      />
                    </Box>
                  </div>
                </>
              )}
            </div>
          </div>

          {/* In the layout flow at the foot of the workspace, so it can never
              cover the last rows of the two lists. */}
          {!(editedItem && paymentModal) &&
            !(
              editedItem &&
              editedPopupItem &&
              Object.keys(editedItem).length > 0
            ) &&
            fetchType !== "Matched" && (
              <div className="bank-workspace__footer">
                <BottomDockBar
                  columns={ExternalColumns}
                  handleJournalEntries={withBottomDockBarLoading(handleCreateJournalEntries)}
                  handleMatchEntries={withBottomDockBarLoading(handleMatchEntries)}
                  handleAutoMatch={withBottomDockBarLoading(handleAutoMatchHeaders)}
                  handleMatch={withBottomDockBarLoading(handleMatch)}
                  handleClearMatches={withBottomDockBarLoading(handleClearMatches)}
                  externalSum={externalSum}
                  internalSum={internalSum}
                  matches={matchedPairs}
                  selectedInternalRows={selectedInternalRows}
                  selectedExternalRows={selectedExternalRows}
                  handleDeleteExternalRows={withBottomDockBarLoading(clickedDeleteMultipleExternal)}
                  externalDisplayedRows={externalDisplayedRows}
                  displayedRows={displayedRows}
                  calculateSum={calculateSum}
                  loading={bottomDockBarLoading}
                  direction={direction}
                  onAiSuggest={selectedCardId ? handleAiSuggest : undefined}
                  aiLoading={aiLoading}
                />
              </div>
            )}
        </div>

        <AiMatchSuggestionsModal
          open={aiOpen}
          onClose={handleAiModalClose}
          loading={aiLoading}
          result={aiResult}
          error={aiError}
          userPrompt={aiPrompt}
          client={client}
          token={token}
          accountCodeId={selectedCardId}
          bankAccountName={mainCard?.name}
          foreignCurrencyCode={
            selectedTBank?.foreignCurrencyCode ?? foreignCurrencyCode ?? null
          }
          accountCards={accountCardOptions}
          direction={direction}
        />

        <ToastContainer position={direction === 'rtl' ? 'top-left' : 'top-right'} rtl={direction === 'rtl'} />
        {loading && (
          <div className="loader-container">
            <PuffLoader
              size={100}
              loading={loading}
            />
          </div>
        )}
        <ImportDialog
          open={openImportDialog}
          onClose={handleCloseImportDialog}
          onImport={handleImport}
          onPreview={handlePreview}
        />
        <ImportPreviewModal
          open={openPreviewModal}
          onClose={() => {
            setOpenPreviewModal(false);
            setPreviewData(null);
            setPreviewFile(null);
          }}
          onConfirm={handleConfirmImport}
          previewData={previewData}
          loading={loading}
        />
        <KeyboardShortcutsDialog
          open={shortcutsOpen}
          onClose={() => setShortcutsOpen(false)}
          direction={direction}
        />
        <UnmatchedReportModal
          open={unmatchedAccountsModalOpen}
          onClose={() => setUnmatchedAccountsModalOpen(false)}
          title={t("UnmatchedAccountsReport")}
          itemsLabel={t("BankAccounts")}
          items={bankAccountReportItems}
          direction={direction}
          defaultStartDate={startDate}
          defaultEndDate={endDate}
          onDownload={handleDownloadUnmatchedAccounts}
          progress={unmatchedAccountsProgress}
          busy={unmatchedAccountsBusy}
        />
        <FinsiteFetchModal
          open={finsiteDialogOpen}
          onClose={() => setFinsiteDialogOpen(false)}
          from={finsiteFrom}
          to={finsiteTo}
          setFrom={setFinsiteFrom}
          setTo={setFinsiteTo}
          onFetch={handleFinsiteFetch}
          loading={loading}
          direction={direction}
        />
        {/* Dialog for Create Journal Entries with Inputs */}

        <XtramModal
          open={isCreateDialogOpen}
          onClose={handleCloseDialog}
          title={t("CreateJournalEntries")}
          direction={direction}
          wide
          onOpened={focusFirstField}
          onKeyDown={(e) => {
            // Enter walks through the fields; after the last field (or with
            // Ctrl/Cmd+Enter from anywhere) it confirms, once the required
            // fields are filled. Skipped when an Autocomplete already consumed
            // Enter to pick an option.
            const canConfirm =
              createJournalEntries === true
                ? !!formValues.accountCard
                : !!formValues.debitAccount && !!formValues.creditAccount;
            handleDialogEnterNavigation(e, {
              canConfirm,
              onConfirm: handleConfirm,
            });
          }}
          footer={(() => {
            const confirmDisabled =
              createJournalEntries === true
                ? !formValues.accountCard
                : splitDifference
                  ? !isSplitValid
                  : !formValues.debitAccount || !formValues.creditAccount;
            return (
              <>
                <XtramButton variant="secondary" onClick={handleCloseDialog}>
                  {t("close")}
                </XtramButton>
                <XtramButton onClick={handleConfirm} disabled={confirmDisabled}>
                  {t("Confirm")}
                </XtramButton>
              </>
            );
          })()}
        >
            {createJournalEntries === true ? (
              // Case 2: Checked is true
              <>
                <Typography variant="body1" gutterBottom>
                  {t("Select AccountCard")}
                </Typography>
                <Box
                  component="form"
                  noValidate
                  autoComplete="off"
                  sx={{ mt: 3 }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginBottom: "16px",
                      width: "30%",
                      margin: "0 auto",
                    }}
                  >
                    <AccountAutocomplete
                      type="accountCard"
                      options={formattedAccountCardOptions}
                      formValues={formValues}
                      handleSelectChange={handleSelectChange}
                      editedItem={editedItem}
                      setCreditDebitSearchTerm={setCreditDebitSearchTerm}
                      handleNoOptionCreditDebitClick={handleNoOptionCreditDebitClick}
                      creditDebitSearchTerm={creditDebitSearchTerm}
                      t={t}
                      direction={direction}
                      EditAccountCard={EditAccountCard}
                      width="100%"
                    />
                  </div>
                  <Typography variant="body1" gutterBottom>
                    {t("Select SortCode")}
                  </Typography>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginTop: "16px",
                      width: "30%",
                      margin: "0 auto",
                    }}
                  >
                    <Autocomplete
                      options={sortCodeIdOptions}
                      getOptionLabel={(option) =>
                        option?.sortCodeId != null || option?.sortCodeName
                          ? `${option.sortCodeId ?? option.value ?? ""} - ${option.sortCodeName ?? ""}`.trim()
                          : option?.label || ""
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={t("Code ID")}
                          fullWidth
                          InputProps={{
                            ...params.InputProps,
                            className: "custom-input-box-sizing",
                          }}
                          sx={{
                            marginRight: "16px",
                            ".MuiInputBase-root": {
                              boxSizing: "border-box !important", // Apply box-sizing to the desired class
                            },
                          }}
                        />
                      )}
                      value={
                        sortCodeIdOptions.find(
                          (option) => option.value === formValues.sortCode
                        ) || null
                      } // bind value
                      ListboxProps={{ dir: "rtl" }}
                      style={{
                        direction: "rtl",
                        boxSizing: "border-box !important",
                      }}
                      onChange={(event, newValue) =>
                        handleSelectChange(
                          "sortCode",
                          newValue ? newValue.value : ""
                        )
                      }
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginTop: "8px",
                      marginBottom: "8px",
                    }}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={usePerRowReportingMonth}
                          onChange={(e) => setUsePerRowReportingMonth(e.target.checked)}
                          sx={{
                            color: "#304FFF",
                            "&.Mui-checked": { color: "#304FFF" },
                          }}
                        />
                      }
                      label={t("UseTransactionDateAsReportingMonth")}
                      sx={{
                        margin: 0,
                        "& .MuiFormControlLabel-label": {
                          fontSize: "14px",
                        },
                      }}
                    />
                  </div>
                  {!usePerRowReportingMonth && (
                    <>
                      <Typography variant="body1" gutterBottom>
                        {t("SelectMonthReport")}
                      </Typography>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          marginTop: "16px",
                          width: "30%",
                          margin: "0 auto",
                        }}
                      >
                        <CustomMonthDatePickerMui
                          Date={setReportingMonthToDay10(
                            formValues.reportingMonthDate
                              ? (formValues.reportingMonthDate instanceof Date
                                  ? formValues.reportingMonthDate
                                  : new Date(formValues.reportingMonthDate))
                              : (reportingMonthDate
                                  ? (reportingMonthDate instanceof Date
                                      ? reportingMonthDate
                                      : new Date(reportingMonthDate))
                                  : new Date())
                          )}
                          setDate={(value) => {
                            const normalized = setReportingMonthToDay10(value);
                            setFormValues((prevValues) => ({
                              ...prevValues,
                              reportingMonthDate: normalized,
                              registrationMonthDate: normalized,
                            }));
                            setReportingMonthDate(normalized);
                          }}
                          label="MonthReportDate"
                        />
                      </div>
                      <Typography variant="body1" gutterBottom>
                        {t("SelectMonthRegister")}
                      </Typography>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          marginTop: "16px",
                          width: "30%",
                          margin: "0 auto",
                        }}
                      >
                        <CustomMonthDatePickerMui
                          Date={setReportingMonthToDay10(
                            formValues.registrationMonthDate
                              ? (formValues.registrationMonthDate instanceof Date
                                  ? formValues.registrationMonthDate
                                  : new Date(formValues.registrationMonthDate))
                              : new Date()
                          )}
                          setDate={(value) => {
                            const normalized = setReportingMonthToDay10(value);
                            setFormValues((prevValues) => ({
                              ...prevValues,
                              registrationMonthDate: normalized,
                            }));
                          }}
                          label="MonthRegisterDate"
                        />
                      </div>
                    </>
                  )}
                </Box>
              </>
            ) : (
              <>
                <Typography variant="body1" gutterBottom>
                  {t("SelectedRowsTotalBankSum")}{" "}
                  {beautifyNumber((externalSum - internalSum).toFixed(2))} {t("and")}
                  {createJournalEntries === true
                    ? t("CreateJournalEntryForEachRow")
                    : t("CreateJournalEntryForAllRows")}
                  .
                </Typography>
                <Typography variant="body2" gutterBottom>
                  {t("FillDetailsToProceed")}
                </Typography>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={splitDifference}
                      onChange={(e) => {
                        const checked = e.target.checked;
                        setSplitDifference(checked);
                        if (checked) {
                          // Seed a single row with the full amount to allocate.
                          splitRowIdRef.current = 1;
                          setSplitRows([
                            {
                              id: 1,
                              amount: splitTarget
                                ? (splitTotals.sign * splitTarget).toFixed(
                                    splitTotals.decimals
                                  )
                                : "",
                              counterAccount: "",
                            },
                          ]);
                        }
                      }}
                      sx={{
                        color: "#304FFF",
                        "&.Mui-checked": { color: "#304FFF" },
                      }}
                    />
                  }
                  label={t("SplitIntoSeparateTransactions")}
                  sx={{
                    margin: 0,
                    "& .MuiFormControlLabel-label": { fontSize: "14px" },
                  }}
                />
                <Box
                  component="form"
                  noValidate
                  autoComplete="off"
                  sx={{ mt: 3 }}
                >
                  {/* Amount + Currency row — single flex row, title above each input */}
                  {(() => {
                    const isManualRate =
                      formValues.exchangeRateType === Constants.ExchangeRateType.Manual;
                    const hasFCCode =
                      formValues.foreignCurrencyCode != null &&
                      formValues.foreignCurrencyCode !== '';
                    const fcCodeKey = hasFCCode
                      ? Object.entries(Constants.ForeignCurrencyCode).find(
                          ([, v]) => v === formValues.foreignCurrencyCode
                        )?.[0]
                          ?? null
                      : null;
                    const titleRowStyle = {
                      display: "flex",
                      alignItems: "center",
                      gap: 6,
                      minHeight: 24,
                      fontSize: 13,
                      color: "#6C757D",
                      fontWeight: 500,
                    };
                    const colStyle = {
                      flex: 1,
                      minWidth: 0,
                      display: "flex",
                      flexDirection: "column",
                      gap: 6,
                    };
                    const inputSx = {
                      ".MuiInputBase-root": {
                        boxSizing: "border-box !important",
                      },
                    };
                    return (
                      <div
                        dir="rtl"
                        style={{
                          display: "flex",
                          marginBottom: "16px",
                          gap: "8px",
                          alignItems: "flex-start",
                        }}
                      >


                        {/* Currency Code + compact Rep/Manual toggle beside label */}
                        <div style={colStyle}>
                          <div style={titleRowStyle}>
                            <span>{t("Currency")}</span>
                            <div
                              style={{
                                display: "flex",
                                gap: "2px",
                                height: "20px",
                                padding: "1px",
                                borderRadius: "4px",
                                background: "#F8F9FA",
                                border: "1px solid #E9ECEF",
                              }}
                            >
                              <div
                                onClick={handleCjeSwitchToRepresentative}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  padding: "2px 6px",
                                  borderRadius: "3px",
                                  cursor: "pointer",
                                  backgroundColor: !isManualRate ? "#304FFF" : "transparent",
                                  color: !isManualRate ? "#FFFFFF" : "#6C757D",
                                  fontWeight: !isManualRate ? 600 : 500,
                                  fontSize: "11px",
                                  transition: "all 0.2s ease",
                                }}
                              >
                                {t("RepresentativeRate")}
                              </div>
                              <div
                                onClick={handleCjeSwitchToManual}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  padding: "2px 6px",
                                  borderRadius: "3px",
                                  cursor: "pointer",
                                  backgroundColor: isManualRate ? "#304FFF" : "transparent",
                                  color: isManualRate ? "#FFFFFF" : "#6C757D",
                                  fontWeight: isManualRate ? 600 : 500,
                                  fontSize: "11px",
                                  transition: "all 0.2s ease",
                                }}
                              >
                                {t("ManualRate")}
                              </div>
                            </div>
                          </div>
                          <Autocomplete
                            options={Object.entries(Constants.ForeignCurrencyCode).map(
                              ([code, num]) => ({
                                value: num,
                                code,
                                label: `${code}${
                                  Constants.ForeignCurrencySymbol[code]
                                    ? '  ' + Constants.ForeignCurrencySymbol[code]
                                    : ''
                                }`,
                              })
                            )}
                            getOptionLabel={(option) => option.label || ''}
                            isOptionEqualToValue={(o, v) => o.value === v.value}
                            value={
                              hasFCCode && fcCodeKey
                                ? {
                                    value: formValues.foreignCurrencyCode,
                                    code: fcCodeKey,
                                    label: `${fcCodeKey}${
                                      Constants.ForeignCurrencySymbol[fcCodeKey]
                                        ? '  ' + Constants.ForeignCurrencySymbol[fcCodeKey]
                                        : ''
                                    }`,
                                  }
                                : null
                            }
                            onChange={(_e, newValue) =>
                              handleCjeCurrencyCodeChange({
                                target: {
                                  value: newValue ? String(newValue.value) : '',
                                },
                              })
                            }
                            ListboxProps={{ dir: 'rtl' }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder={t("Currency")}
                                fullWidth
                                InputProps={{
                                  ...params.InputProps,
                                  className: "custom-input-box-sizing",
                                }}
                                sx={inputSx}
                              />
                            )}
                          />
                        </div>
                        
                      {/* NIS Amount (anchor) */}
                      <div style={colStyle}>
                          <div style={titleRowStyle}>
                            <span>{t("Amount")}</span>
                          </div>
                          <TextField
                            fullWidth
                            placeholder={t("Amount")}
                            name="amount"
                            type="number"
                            value={cjeAmountInput}
                            onFocus={() => {
                              setCjeAmountInput(
                                formValues.amount !== undefined &&
                                formValues.amount !== null &&
                                formValues.amount !== ''
                                  ? String(Number(cjeParseNumeric(formValues.amount)))
                                  : ''
                              );
                            }}
                            onBlur={(e) => {
                              const val = e.target.value;
                              if (val !== '' && !isNaN(val)) {
                                const formatted = Number(val).toFixed(2);
                                setCjeAmountInput(formatted);
                                setFormValues((prev) => ({ ...prev, amount: formatted }));
                                cjeFlushAmountSync(formatted);
                              } else {
                                setFormValues((prev) => ({ ...prev, amount: val }));
                                cjeFlushAmountSync();
                              }
                            }}
                            onChange={(e) => handleCjeAmountChange(e.target.value)}
                            sx={inputSx}
                            InputProps={{
                              className: "custom-input-box-sizing",
                            }}
                          />
                        </div>
                        {/* Currency Amount */}
                        <div style={colStyle}>
                          <div style={titleRowStyle}>
                            <span>{t("CurrencyAmount")}</span>
                          </div>
                          <TextField
                            fullWidth
                            placeholder={t("CurrencyAmount")}
                            type="number"
                            value={cjeCurrencyAmountInput}
                            onFocus={() => {
                              setCjeCurrencyAmountInput(
                                formValues.foreignCurrencyAmount !== undefined &&
                                formValues.foreignCurrencyAmount !== null &&
                                formValues.foreignCurrencyAmount !== ''
                                  ? String(
                                      Number(
                                        cjeParseNumeric(formValues.foreignCurrencyAmount)
                                      ).toFixed(CJE_FC_AMOUNT_DECIMALS)
                                    )
                                  : ''
                              );
                            }}
                            onBlur={(e) => {
                              const val = e.target.value;
                              if (val !== '' && !isNaN(val)) {
                                const formatted = Number(val).toFixed(CJE_FC_AMOUNT_DECIMALS);
                                setCjeCurrencyAmountInput(formatted);
                                setFormValues((prev) => ({
                                  ...prev,
                                  foreignCurrencyAmount: formatted,
                                }));
                                cjeFlushFcSync(formatted);
                              } else {
                                setFormValues((prev) => ({
                                  ...prev,
                                  foreignCurrencyAmount: val,
                                }));
                                cjeFlushFcSync();
                              }
                            }}
                            onChange={(e) => handleCjeForeignAmountChange(e.target.value)}
                            disabled={!hasFCCode || cjeIsLoadingFCRate}
                            sx={inputSx}
                            InputProps={{
                              className: "custom-input-box-sizing",
                              endAdornment: cjeIsLoadingFCRate ? (
                                <InputAdornment position="end">
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 1,
                                    }}
                                  >
                                    <CircularProgress size={18} />
                                    <span style={{ fontSize: "0.7rem", color: "#666" }}>
                                      {t("FetchingCurrencyRateByDate")}
                                    </span>
                                  </Box>
                                </InputAdornment>
                              ) : null,
                            }}
                          />
                        </div>

                        {/* Manual Exchange Rate — same row, only in Manual mode */}
                        {isManualRate && (
                          <div style={colStyle}>
                            <div style={titleRowStyle}>
                              <span>{t("ManualExchangeRate")}</span>
                            </div>
                            <TextField
                              fullWidth
                              placeholder={t("ManualExchangeRate")}
                              type="number"
                              value={cjeManualRateInput}
                              onChange={(e) => handleCjeManualRateChange(e.target.value)}
                              onBlur={(e) => {
                                const val = cjeAbsNumeric(e.target.value);
                                if (!isNaN(val) && val > 0) {
                                  const formatted = val.toFixed(
                                    CJE_MANUAL_RATE_DECIMALS
                                  );
                                  setCjeManualRateInput(formatted);
                                  handleCjeManualRateChange(formatted);
                                }
                              }}
                              inputProps={{ min: 0, step: "any" }}
                              disabled={!hasFCCode}
                              sx={inputSx}
                              InputProps={{
                                className: "custom-input-box-sizing",
                              }}
                            />
                          </div>
                        )}

                      </div>
                    );
                  })()}

                  {/* Second Row: Credit Account and Debit Account */}
                  {!splitDifference && (
                  <div
                    dir="rtl"
                    style={{
                      display: "flex",
                      justifyContent: "space-around",
                      marginBottom: "16px",
                      marginTop: "16px",
                    }}
                  >
                    <AccountAutocomplete
                      type="debitAccount"
                      options={formattedAccountCardOptions}
                      formValues={formValues}
                      handleSelectChange={handleSelectChange}
                      setCreditDebitSearchTerm={setCreditDebitSearchTerm}
                      handleNoOptionCreditDebitClick={handleNoOptionCreditDebitClick}
                      creditDebitSearchTerm={creditDebitSearchTerm}
                      editedItem={editedItem}
                      t={t}
                      direction={direction}
                      EditAccountCard={EditAccountCard}
                      sx={{ width: "30% !important" }}
                    />

                    <AccountAutocomplete
                      type="creditAccount"
                      options={formattedAccountCardOptions}
                      formValues={formValues}
                      handleSelectChange={handleSelectChange}
                      setCreditDebitSearchTerm={setCreditDebitSearchTerm}
                      handleNoOptionCreditDebitClick={handleNoOptionCreditDebitClick}
                      creditDebitSearchTerm={creditDebitSearchTerm}
                      editedItem={editedItem}
                      t={t}
                      direction={direction}
                      EditAccountCard={EditAccountCard}
                      sx={{ width: "30% !important" }}
                    />


                  </div>
                  )}

                  {/* Split rows: one journal entry per row, counter-account + amount */}
                  {splitDifference && (
                    <Box dir="rtl" sx={{ mb: 2, mt: 2 }}>
                      {splitTotals.isForeign && (
                        <Typography
                          variant="body2"
                          sx={{ mb: 1.5, color: "#6C757D" }}
                        >
                          {t("SplitRowsAreInCurrency", {
                            currency: cjeCurrencyLabel(splitTotals.currencyCode),
                          })}
                        </Typography>
                      )}
                      {(() => {
                        const isNegative =
                          Number(cjeParseNumeric(formValues.amount)) < 0;
                        // Bank stays on a fixed side; user picks the counter side.
                        const counterLabel = isNegative
                          ? t("Debit Account")
                          : t("Credit Account");
                        // Shekel share per row, shown next to a foreign amount so the user
                        // sees what will actually be booked.
                        const shekelShares = buildSplitAmounts();
                        return splitRows.map((row, index) => (
                          <div
                            key={row.id}
                            style={{
                              display: "flex",
                              alignItems: "flex-start",
                              gap: "8px",
                              marginBottom: "12px",
                            }}
                          >
                            <Typography
                              variant="body2"
                              sx={{
                                minWidth: 20,
                                mt: 2,
                                fontWeight: 600,
                                color: "#6C757D",
                              }}
                            >
                              {`${index + 1}.`}
                            </Typography>
                            <TextField
                              label={
                                splitTotals.isForeign
                                  ? t("CurrencyAmount")
                                  : t("Amount")
                              }
                              type="number"
                              value={row.amount}
                              onChange={(e) =>
                                updateSplitRow(row.id, "amount", e.target.value)
                              }
                              helperText={
                                splitTotals.isForeign && isSplitSumValid
                                  ? `≈ ${beautifyNumber(
                                      (
                                        splitTotals.sign *
                                        (shekelShares[index]?.amount ?? 0)
                                      ).toFixed(2)
                                    )} ₪`
                                  : " "
                              }
                              InputProps={{
                                className: "custom-input-box-sizing",
                              }}
                              sx={{ width: "30%" }}
                            />
                            <Autocomplete
                              options={formattedAccountCardOptions}
                              getOptionLabel={(option) => {
                                if (option?.value1 === "AddItem") {
                                  return `${t("AddAccountCard")} "${option.searchTerm || ""}"`;
                                }
                                return option.label || "";
                              }}
                              isOptionEqualToValue={(o, v) => o.value === v.value}
                              filterOptions={filterSplitAccountCardOptions}
                              value={
                                formattedAccountCardOptions.find(
                                  (option) => option.value === row.counterAccount
                                ) || null
                              }
                              onChange={(event, newValue) => {
                                if (newValue?.value1 === "AddItem") {
                                  handleAddCounterAccountCard(
                                    creditDebitSearchTerm,
                                    row.id,
                                    isNegative
                                  );
                                  return;
                                }
                                updateSplitRow(
                                  row.id,
                                  "counterAccount",
                                  newValue ? newValue.value : ""
                                );
                              }}
                              onInputChange={(event, inputValue) =>
                                setCreditDebitSearchTerm(inputValue)
                              }
                              noOptionsText={
                                <Button
                                  onClick={() =>
                                    handleAddCounterAccountCard(
                                      creditDebitSearchTerm,
                                      row.id,
                                      isNegative
                                    )
                                  }
                                  variant="contained"
                                  color="primary"
                                >
                                  {t("AddAccountCard")} "{creditDebitSearchTerm}"
                                </Button>
                              }
                              renderOption={(props, option) => {
                                if (option?.value1 === "AddItem") {
                                  const { key, ...optionProps } = props;
                                  return (
                                    <li key={key} {...optionProps}>
                                      {`${t("AddAccountCard")}${
                                        option.searchTerm
                                          ? ` "${option.searchTerm}"`
                                          : ""
                                      }`}
                                    </li>
                                  );
                                }
                                return (
                                  <Tooltip
                                    key={props.key}
                                    title={
                                      option.isEditable
                                        ? t("RightClickToEdit")
                                        : t("NotEditable")
                                    }
                                    placement="top"
                                  >
                                    <li
                                      {...props}
                                      onContextMenu={(event) => {
                                        event.preventDefault();
                                        EditAccountCard(
                                          option,
                                          isNegative ? "debitAccount" : "creditAccount"
                                        );
                                      }}
                                    >
                                      {option.label ||
                                        `${option?.cardId ?? ""} - ${option.name}`}
                                    </li>
                                  </Tooltip>
                                );
                              }}
                              ListboxProps={{ dir: "rtl" }}
                              style={{ direction: "rtl", flex: 1 }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label={counterLabel}
                                  fullWidth
                                  InputProps={{
                                    ...params.InputProps,
                                    className: "custom-input-box-sizing",
                                  }}
                                />
                              )}
                            />
                            <IconButton
                              onClick={() => removeSplitRow(row.id)}
                              disabled={splitRows.length <= 1}
                              sx={{ color: "#d32f2f", mt: 0.5 }}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </div>
                        ));
                      })()}

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          marginTop: "8px",
                        }}
                      >
                        <Button
                          startIcon={<AddCircleIcon sx={{ ml: 1 }} />}
                          onClick={addSplitRow}
                          sx={{ color: "#304FFF", textTransform: "none" }}
                        >
                          {t("AddSplitRow")}
                        </Button>
                        <Box sx={{ textAlign: "left" }}>
                          <Typography
                            variant="body2"
                            sx={{
                              color: isSplitSumValid ? "#2e7d32" : "#d32f2f",
                              fontWeight: 600,
                            }}
                          >
                            {`${t("SplitAllocated")}: ${beautifyNumber(
                              splitAllocated.toFixed(splitTotals.decimals)
                            )} / ${beautifyNumber(
                              splitTarget.toFixed(splitTotals.decimals)
                            )} ${
                              splitTotals.isForeign
                                ? cjeCurrencyLabel(splitTotals.currencyCode)
                                : "₪"
                            } (${t("SplitRemaining")}: ${beautifyNumber(
                              splitRemaining.toFixed(splitTotals.decimals)
                            )})`}
                          </Typography>
                          {splitTotals.isForeign && (
                            <Typography
                              variant="caption"
                              sx={{ color: "#6C757D" }}
                            >
                              {`${t("Amount")}: ${beautifyNumber(
                                splitTotals.nisTotal.toFixed(2)
                              )} ₪`}
                            </Typography>
                          )}
                        </Box>
                      </div>

                      {/* Spell out what still blocks the confirm button. */}
                      {!isSplitValid && (
                        <Typography
                          variant="body2"
                          sx={{ mt: 1, color: "#d32f2f" }}
                        >
                          {!splitRowsHaveAmounts
                            ? t("SplitRowsNeedAmount")
                            : !isSplitSumValid
                              ? t("SplitMustMatchTotal")
                              : t("SplitRowsNeedAccount")}
                        </Typography>
                      )}
                    </Box>
                  )}

                  {/* Third Row: Description and Reference */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-around",
                      marginBottom: "16px",
                    }}
                  >
                    <TextField
                      fullWidth
                      label={t("Description")}
                      name="description"
                      onChange={handleInputChange}
                      InputProps={{
                        className: "custom-input-box-sizing",
                      }}
                      sx={{ width: "30%" }}
                      value={formValues.description}
                    />
                    <TextField
                      fullWidth
                      label={t("Reference")}
                      name="reference"
                      onChange={handleInputChange}
                      InputProps={{
                        className: "custom-input-box-sizing",
                      }}
                      sx={{ width: "30%" }}
                      value={formValues.reference}
                    />
                  </div>

                  {/* Fourth Row: Code ID and ValueDate */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: "16px",
                      gap: "8px",
                    }}
                  >
                    <Autocomplete
                      options={sortCodeIdOptions}
                      getOptionLabel={(option) =>
                        option?.sortCodeId != null || option?.sortCodeName
                          ? `${option.sortCodeId ?? option.value ?? ""} - ${option.sortCodeName ?? ""}`.trim()
                          : option?.label || ""
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={t("Code ID")}
                          fullWidth
                          sx={{
                            marginRight: "16px",
                            ".MuiInputBase-root": {
                              boxSizing: "border-box !important", // Apply box-sizing to the desired class
                            },
                          }}
                          InputProps={{
                            ...params.InputProps,
                            className: "custom-input-box-sizing",
                          }}
                        />
                      )}
                      ListboxProps={{ dir: "rtl" }}
                      style={{ direction: "rtl" }}
                      sx={{ width: "30%" }}
                      onChange={(event, newValue) =>
                        handleSelectChange(
                          "sortCodeId",
                          newValue ? newValue.value : ""
                        )
                      }
                      value={
                        sortCodeIdOptions.find(
                          (option) => option.value === formValues.sortCodeId
                        ) || null
                      } // bind value
                    />
                    <div style={{ width: "30%" }}>
                      <TextField
                        fullWidth
                        label={t("ValueDate")}
                        name="documentDate"
                        type="date"
                        InputLabelProps={{ shrink: true }}
                        onChange={handleInputChange}
                        InputProps={{
                          className: "custom-input-box-sizing",
                        }}
                        sx={{ width: "100%" }}
                        value={formValues.documentDate}
                      />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "16px",
                        width: "30%",
                        margin: "0 auto",
                      }}
                    >
                      <CustomMonthDatePickerMui
                        Date={setReportingMonthToDay10(
                          formValues.reportingMonthDate instanceof Date
                            ? formValues.reportingMonthDate
                            : formValues.reportingMonthDate
                              ? new Date(formValues.reportingMonthDate)
                              : new Date()
                        )}
                        setDate={(value) => {
                          const normalized = setReportingMonthToDay10(value);
                          setFormValues((prevValues) => ({
                            ...prevValues,
                            reportingMonthDate: normalized,
                            registrationMonthDate: normalized,
                          }));
                        }}
                        label="MonthReportDate"
                      />
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "16px",
                        width: "30%",
                        margin: "0 auto",
                      }}
                    >
                      <CustomMonthDatePickerMui
                        Date={setReportingMonthToDay10(
                          formValues.registrationMonthDate instanceof Date
                            ? formValues.registrationMonthDate
                            : formValues.registrationMonthDate
                              ? new Date(formValues.registrationMonthDate)
                              : new Date()
                        )}
                        setDate={(value) =>
                          setFormValues((prevValues) => ({
                            ...prevValues,
                            registrationMonthDate: setReportingMonthToDay10(value),
                          }))
                        }
                        label="MonthRegisterDate"
                      />
                    </div>
                  </div>
                </Box>
              </>
            )}
        </XtramModal>

        <XtramModal
          open={isJournalEntriesListOpen}
          onClose={() => setIsJournalEntriesListOpen(false)}
          title={t("JournalEntriesPreview")}
          direction={direction}
          wide
          onKeyDown={(e) => {
            // Enter creates all previewed journal entries, unless the user
            // tabbed onto a specific button (its own click then applies).
            if (e.target?.tagName === "BUTTON") return;
            if (e.key === "Enter" && !e.shiftKey && !e.defaultMuiPrevented) {
              e.preventDefault();
              handleFinalizeEntries();
            }
          }}
          footer={
            <>
              <XtramButton
                variant="secondary"
                onClick={() => setIsJournalEntriesListOpen(false)}
              >
                {t("close")}
              </XtramButton>
              <XtramButton
                onClick={handleFinalizeEntries}
                disabled={!journalEntriesMatchInfo.isValid}
              >
                {t("create")}
              </XtramButton>
            </>
          }
        >
          {journalEntriesList.map((entry, index) => (
            <div key={index} className={`${xtramStyles.card} ${xtramStyles.section}`}>
              <h4 className={xtramStyles.sectionTitle}>
                {t("Entry")} #{index + 1}
              </h4>
              {(() => {
                const isForeignBank = entry.bankIsForeign;
                const hasFc = entry.foreignCurrencyCode != null;
                const showFcControls = isForeignBank || hasFc;
                const isManualRate =
                  entry.exchangeRateType === Constants.ExchangeRateType.Manual;
                const nisLocked = isForeignBank
                  ? !isManualRate
                  : hasFc;
                const fcLocked = isForeignBank || !isManualRate;
                const nisDeviates =
                  Math.abs(
                    (Math.abs(Number(entry.amount)) || 0) -
                      (Math.abs(Number(entry.matchAmount ?? entry.amount)) ||
                        0)
                  ) >= 0.005;
                const currencyOptions = Object.entries(
                  Constants.ForeignCurrencyCode
                ).map(([code, num]) => ({
                  value: num,
                  code,
                  label: `${code}${
                    Constants.ForeignCurrencySymbol[code]
                      ? "  " + Constants.ForeignCurrencySymbol[code]
                      : ""
                  }`,
                }));
                const fcCodeKey = hasFc
                  ? Object.entries(Constants.ForeignCurrencyCode).find(
                      ([, v]) => v === entry.foreignCurrencyCode
                    )?.[0] ?? null
                  : null;
                const currencyValue =
                  hasFc && fcCodeKey
                    ? currencyOptions.find((o) => o.code === fcCodeKey) || null
                    : null;
                const amountHint = nisLocked
                  ? isForeignBank
                    ? t("AutoCalculatedFromRate")
                    : t("LockedToKeepMatchValid")
                  : nisDeviates
                    ? t("EditedAmountsBreakMatch")
                    : "";
                const fcHint = fcLocked
                  ? isForeignBank
                    ? t("LockedToKeepMatchValid")
                    : t("AutoCalculatedFromRate")
                  : "";

                return (
                  <>
                    {(!isForeignBank || showFcControls) && (
                      <div className={xtramStyles.toolbar}>
                        {!isForeignBank && (
                          <XtramField label={t("Currency")} size="narrow">
                            <XtramSelect
                              direction={direction}
                              options={currencyOptions}
                              value={currencyValue}
                              placeholder={t("Currency")}
                              getOptionLabel={(option) => option?.label || ""}
                              isOptionEqualToValue={(o, v) => o.value === v.value}
                              onChange={(option) =>
                                handleJournalEntryCurrencyChange(
                                  index,
                                  option ? String(option.value) : ""
                                )
                              }
                            />
                          </XtramField>
                        )}
                        {showFcControls && (
                          <div className={xtramStyles.toolbarGroup}>
                            <XtramButton
                              variant="ghost"
                              small
                              active={!isManualRate}
                              onClick={() =>
                                handleJournalEntryRateTypeChange(
                                  index,
                                  Constants.ExchangeRateType.Representative
                                )
                              }
                            >
                              {t("RepresentativeRate")}
                            </XtramButton>
                            <XtramButton
                              variant="ghost"
                              small
                              active={isManualRate}
                              onClick={() =>
                                handleJournalEntryRateTypeChange(
                                  index,
                                  Constants.ExchangeRateType.Manual
                                )
                              }
                            >
                              {t("ManualRate")}
                            </XtramButton>
                          </div>
                        )}
                      </div>
                    )}

                    <div className={xtramStyles.formFields}>
                      <XtramField
                        label={t("Amount")}
                        error={!hasFc && nisDeviates ? amountHint : undefined}
                        hint={amountHint}
                      >
                        <XtramInput
                          direction={direction}
                          type="number"
                          value={entry.amount ?? ""}
                          onChange={(e) =>
                            handleJournalEntryAmountChange(index, e.target.value)
                          }
                          disabled={nisLocked || !!journalEntryRateLoading[index]}
                          error={!hasFc && nisDeviates}
                        />
                      </XtramField>

                      {showFcControls && (
                        <>
                          <XtramField label={t("CurrencyAmount")} hint={fcHint}>
                            <XtramInput
                              direction={direction}
                              type="number"
                              value={entry.foreignCurrencyAmount ?? ""}
                              onChange={(e) =>
                                handleJournalEntryFcAmountChange(index, e.target.value)
                              }
                              disabled={fcLocked || !!journalEntryRateLoading[index]}
                              InputProps={{
                                endAdornment: journalEntryRateLoading[index] ? (
                                  <InputAdornment position="end">
                                    <CircularProgress size={16} />
                                  </InputAdornment>
                                ) : null,
                              }}
                            />
                          </XtramField>
                          <XtramField label={t("ManualExchangeRate")}>
                            <XtramInput
                              direction={direction}
                              type="number"
                              value={entry.exchangeRate ?? ""}
                              onChange={(e) =>
                                handleJournalEntryRateChange(index, e.target.value)
                              }
                              disabled={!isManualRate || !!journalEntryRateLoading[index]}
                            />
                          </XtramField>
                        </>
                      )}
                    </div>
                  </>
                );
              })()}
              <div className={bankXtramStyles.kvList}>
                <div className={bankXtramStyles.kv}>
                  <span className={bankXtramStyles.kvLabel}>{t("Debit Account")}</span>
                  <span className={bankXtramStyles.kvValue}>
                    {entry.debitAccount} ({getAccountCardName(entry.debitAccount)})
                  </span>
                </div>
                <div className={bankXtramStyles.kv}>
                  <span className={bankXtramStyles.kvLabel}>{t("Credit Account")}</span>
                  <span className={bankXtramStyles.kvValue}>
                    {entry.creditAccount} ({getAccountCardName(entry.creditAccount)})
                  </span>
                </div>
                <div className={bankXtramStyles.kv}>
                  <span className={bankXtramStyles.kvLabel}>{t("description")}</span>
                  <span className={bankXtramStyles.kvValue}>{entry.description}</span>
                </div>
                <div className={bankXtramStyles.kv}>
                  <span className={bankXtramStyles.kvLabel}>{t("reference")}</span>
                  <span className={bankXtramStyles.kvValue}>{entry.reference}</span>
                </div>
                <div className={bankXtramStyles.kv}>
                  <span className={bankXtramStyles.kvLabel}>{t("DueOrDocumentDate")}</span>
                  <span className={bankXtramStyles.kvValue}>{entry.documentDate}</span>
                </div>
                <div className={bankXtramStyles.kv}>
                  <span className={bankXtramStyles.kvLabel}>{t("MonthReportDate")}</span>
                  <span className={bankXtramStyles.kvValue}>
                    {formatMonthYearDate(entry.reportingMonthDate)}
                  </span>
                </div>
                <div className={bankXtramStyles.kv}>
                  <span className={bankXtramStyles.kvLabel}>{t("MonthRegisterDate")}</span>
                  <span className={bankXtramStyles.kvValue}>
                    {formatMonthYearDate(entry.registrationMonthDate || entry.reportingMonthDate)}
                  </span>
                </div>
                {entry.sortCodeId && (
                  <div className={bankXtramStyles.kv}>
                    <span className={bankXtramStyles.kvLabel}>{t("SortCode")}</span>
                    <span className={bankXtramStyles.kvValue}>
                      {entry.sortCodeId} {getSortCodeName(entry.sortCodeId)}
                    </span>
                  </div>
                )}
              </div>
            </div>
          ))}
          {!journalEntriesMatchInfo.isValid && (
            <XtramNotice type="error">
              <strong>{t("EditedAmountsBreakMatch")}</strong>
              <span>
                {`${t("SplitAllocated")}: ${beautifyNumber(
                  journalEntriesMatchInfo.current.toFixed(2)
                )} / ${beautifyNumber(
                  journalEntriesMatchInfo.required.toFixed(2)
                )}`}
              </span>
            </XtramNotice>
          )}
        </XtramModal>

        <RemoveMatchConfirmModal
          open={openRemoveMatchDialog}
          onClose={handleCloseRemoveMatchDialog}
          onConfirm={handleConfirmRemove}
          match={selectedMatch}
          formatDate={formatDate}
          direction={direction}
        />
      </>

      <CustomDeleteConfirmationModal
        isVisible={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        onDelete={handleConfirmDeletion}
        confirmMessage={getConfirmMessage()}
        titleMessage={getTitleMessage()}
      />

      {showChooseAsset && (
        <ChooseAsset
          date={dateForAsset}
          open={showChooseAsset}
          onClose={() => handleAssetClose()}
          type={editedItem?.docType} //or type
          itemId={itemToAddToAsset}
          client={client}
          token={token}
          editedItemVat={editedItem.vat}
          onAssetChosen={(assetId) => {
            setShowChooseAsset(false);
          }}
          onCreateAsset={(newAsset) => {
            setShowChooseAsset(false);
          }}
          fullItem={itemForAssets}
          saleEquipment={saleEquipment}
          clickedAsset={clickedAsset}
          fetchEnums={fetchEnums}
          user={user}
          setShowAddGroupModal={handleOpenGroudAdd}
          assetGroups={assetGroups}

        />
      )}

      {showAddGroupModal && (
        <AddAssetGroup
          open={showAddGroupModal}
          onClose={() => setShowAddGroupModal(false)}
          caseId={client.caseId}
          token={token}
          assetGroups={assetGroups}
          refreshAssetGroups={() => {
            // Refresh the list
            fetchEnums(user, token, client);
            setShowAddGroupModal(false);
          }}
        />
      )}


      {editedItem && editedPopupItem && Object.keys(editedItem).length > 0 && (
        <EditModal
          editedItem={editedItem}
          fade={fade}
          handlePrevious={handlePrevious}
          handleNext={handleNext}
          currentIndex={currentIndex}
          filteredAndSortedData={sortedTransactions}
          NoDocumentsPdf={NoDocumentsPdf}
          t={t}
          handleAccountChange={handleAccountChange}
          isRange={isRange}
          isClosedReportingMonth={isClosedReportingMonth}
          accountCardOptions={editModalsAccountCardOptions}
          handleChange={handleChange}
          handleDateChange={handleDateChange}
          CustomInput2={CustomInput2}
          setReportingMonthDate={setReportingMonthDate}
          handleVatRadioChange={handleVatRadioChange}
          statusCheck={statusCheck}
          handleRadioChange={handleRadioChange}
          type={type}
          editedAddAccountCard={editedAddAccountCard}
          handleCloseEditAddNewAccountCardDocument={
            handleCloseEditAddNewAccountCardDocument
          }
          handleEditAddAccountChange={handleEditAddAccountChange}
          sortCodeIdOptions={sortCodeIdOptionsForEditModals}
          debitAccountOptions={debitAccountOptions}
          creditAccountOptions={creditAccountOptions}
          handleUpdate={handleUpdate}
          handleCancel={handleCancel}
          handleDeleteClick={handleEditDeleteClick}
          client={client}
          token={token}
          setAccountCardOptions={setAccountCardOptions}
          setLoading={setLoading}
          setEditedAddAccountCard={setEditedAddAccountCard}
          setEditedItem={setEditedItem}
          handleReopenEdit={handleReopenEdit}
          showIframe={!editedJournalItem}
          palCodes={formattedPalCodeOptions}
          fetchEnums={fetchEnums}
          RefreshPage={FetchData}
          assets={assets}
          assetClicked={handleAssetClicked}
        />
      )}

      {addEditableItem && paymentModal && (
        <PaymentAcceptanceCreateEditModal
          openInvoiceCreatorModal={openInvoiceCreatorModal}
          handleClose={handleClose}
          t={t}
          itemEditing={itemEditing}
          addNewAccountCardDocument={addNewAccountCardDocument}
          companyId={companyId}
          accountCodeName={accountCodeName}
          accountCodeId={accountCodeId}
          setAccount={setAccount}
          Constants={Constants}
          palCode={palCode}
          setPalCode={setPalCode}
          isRange={isRange}
          addEditableItem={addEditableItem} // renamed from editedItem
          isClosedReportingMonth={isClosedReportingMonth}
          handleSaveEditAccountCard={handleSaveEditAccountCard}
          handleAddAccountCard={handleAddAccountCard}
          handleCloseAddNewAccountCardDocument={
            handleCloseAddNewAccountCardDocument
          }
          accountCardOptions={accountCardOptions}
          selectedOption={selectedOption}
          handleMuiChange={handleMuiChange}
          handleEdit={handleEdit}
          handleAccountDelete={handleAccountDelete} // renamed from handleDelete
          handleChangeAccountType={handleChangeAccountType}
          customStyles={customStyles}
          setPaymentDate={setPaymentDate}
          setReportingMonthDate={setReportingMonthDate}
          handleDescriptionChange={handleDescriptionChange}
          handleChangeOriginalTaxClearance={handleChangeOriginalTaxClearance}
          handleAddEditableItemChange={handleAddEditableItemChange}
          patchAddEditableItem={patchAddEditableItem}
          handleItemChange={handleItemChange}
          handleRemoveItem={handleRemoveItem}
          showAccountCardInputsEdit={showAccountCardInputsEdit}
          statusCheck={statusCheck}
          handleRadioChange={handleRadioPAChange}
          handleSave={handleSave}
          buttonDisabled={buttonDisabled}
          paymentBeingEdited={paymentBeingEdited}
          CustomDropdown={CustomDropdown}
          type={type}
          direction={direction}
          setAddNewAccountCardDocument={setAddNewAccountCardDocument}
          isClosedReportingMonthAndIsRange={isClosedReportingMonthAndIsRange}
          handleAddItem={handleAddItem}
          CustomPalCode={CustomPalCode}
          handleAccountEdit={handleAccountEdit}
          handlePrevious={handlePrevious}
          currentIndex={currentIndex}
          filteredAndSortedData={filteredAndSortedTransactions}
          handleNext={handleNext}
          showType={showType}
          handleDeleteClick={handleEditDeleteClick}
          fetchEnums={fetchEnums}
          client={client}
          token={token}
          setLoading={setLoading}
          handleTransferRefresh={async () => {
            await FetchData();
          }}

        />
      )}
    </>
  );
}

export default BankMatching;
